{
    "apiErrors": {
        "draft_busy": "Зараз створюється надто багато відповідей. Спробуйте ще раз за мить.",
        "special_hours_require_business_hours": "Змінений графік потребує графіка роботи. Залиште графік хоча б з одним робочим днем або спершу видаліть особливі дати.",
        "special_hours_duplicate_date": "Особлива дата вказана більше одного разу. Залиште один запис на дату.",
        "menu_name_conflict": "Інше опубліковане меню з такою самою назвою вже існує в одній з локацій цього меню. Спочатку перейменуйте одне з меню.",
        "conversation_assigned_to_agent": "Цю розмову веде Pulse. Приєднайтеся до розмови, щоб взяти її на себе.",
        "conversation_already_in_team": "Розмова вже належить цій команді.",
        "team_not_found": "Ця команда більше не існує. Оновіть сторінку та спробуйте ще раз.",
        "conversation_assigned_to_another_user": "Ця розмова призначена іншому агенту. Приєднайтеся до розмови, щоб взяти її на себе.",
        "billing_surveys_advanced_disabled": "Ця функція доступна на тарифі Professional.",
        "google_authentication_failed": "Не вдалося підключити інтеграцію",
        "google_access_revoked": "Не вдалося підключити інтеграцію",
        "google_auth_code_expired": "Термін дії входу через Google минув. Спробуйте ще раз",
        "google_server_error": "Google тимчасово недоступний. Спробуйте ще раз пізніше",
        "google_validation_failed": "Google відхилив цей запит: {{reasons}}",
        "google_not_found": "Верифікація Google наразі недоступна для цієї локації",
        "something_wrong": "Щось пішло не так",
        "validation": "Щось пішло не так",
        "message_too_long": "Текст допису задовгий для однієї з вибраних платформ. Скоротіть повідомлення та спробуйте ще раз.",
        "duplicate_question_titles": "Назви запитань мають бути унікальними. Дублікати: {{duplicates}}",
        "forbid": "Немає доступу",
        "unauthorized": "Немає доступу",
        "google_access_revoke_error": "Не вдалося відключити інтеграцію",
        "google_publish_reply_error": "Не вдалося опублікувати відповідь для відгуку",
        "google_delete_reply_error": "Не вдалося видалити відповідь для відгуку",
        "delete_user_failed_assigned_to_other_companies": "Неможливо видалити. Користувача призначено до іншої локації",
        "user_already_exists": "Користувач {{email}} вже існує",
        "user_not_found": "Користувач не існує",
        "invalid_credentials": "Невірно введені дані",
        "google_email_unverified": "Підтвердьте цю адресу електронної пошти у своєму обліковому записі Google і спробуйте ще раз",
        "invalid_password": "Невірний пароль",
        "campaign_not_enough_credits": "У вас недостатньо повідомлень для проведення цієї кампанії",
        "cannot_edit_campaign": "Ви не можете редагувати кампанію",
        "running_campaigns_exists": "Неможливо продовжити: {{amount}} кампаній(я) в прогресі",
        "running_coupons_exist": "Неможливо продовжити: {{amount}} активний(х) шаблон(ів) купонів призначено до цієї локації",
        "active_directories_addon_exists": "Спочатку скасуйте додаток «Локальні каталоги» для цієї локації",
        "location_country_locked_by_listings": "Скасуйте додаток «Локальні каталоги» або відключіть лістинг, перш ніж змінювати країну цієї локації",
        "location_country_required": "Вкажіть країну локації",
        "location_country_locked_by_google": "Відключіть Google-лістинг цієї локації, перш ніж змінювати країну",
        "google_listing_country_mismatch": "Цей Google-лістинг у країні {{listingCountry}}, а локація — у країні {{locationCountry}}. Підключіть лістинг із країни локації",
        "located_in_self_reference": "Локація не може бути розташована всередині самої себе. Оберіть бізнес, усередині якого вона розташована",
        "located_in_place_required": "Оберіть бізнес, усередині якого розташована локація, або вимкніть «Розташований всередині іншого бізнесу»",
        "tracking_tags_medium_invalid": "Використовуйте малі літери, цифри та дефіси в utm_medium",
        "tracking_tags_medium_paid": "Аналітика зарахує цей utm_medium як платний трафік. Оберіть інше значення",
        "tracking_tags_campaign_invalid": "Використовуйте малі літери, цифри та дефіси в utm_campaign",
        "tracking_tags_campaign_shopping": "Аналітика зарахує цей utm_campaign як трафік покупок. Оберіть інше значення",
        "store_code_too_long": "Код магазину має не більше 64 символів",
        "located_in_place_invalid": "Не вдалося розпізнати цей бізнес у Google. Знайдіть його ще раз і оберіть із результатів",
        "located_in_relation_invalid": "Оберіть тип зв'язку з бізнесом, усередині якого розташована локація",
        "pulse_ai_agent_assigned": "Неможливо продовжити: активний агент на цій локації",
        "campaign_empty": "В обраному сегменті немає контактів",
        "campaign_audience_to_big": "Невозможно создать кампанию с более чем 1000 контактов",
        "maximum_daily_messages_reached": "Досягнутий щоденний ліміт повідомлень",
        "over_survey": "Досягнутий ліміт повідомлень цьому контакту протягом останніх {{delay}} днів",
        "contact_unsubscribed": "Контакт відписався від повідомлень",
        "ticket_managenet_disabled": "Змініть тариф щоб відкрити цю функцію",
        "maximum_sms_count_reached": "Змініть тариф щоб надсилати більше SMS",
        "maximum_emails_count_reached": "Змініть тариф щоб надсилати більше emailʼів",
        "maximum_companies_count_reached": "Змініть тариф щоб відкрити цю функцію",
        "maximum_users_count_reached": "Змініть тариф щоб відкрити цю функцію",
        "maximum_templates_count_reached": "Змініть тариф щоб відкрити цю функцію",
        "maximum_company_services_count_reached": "Змініть тариф щоб відкрити цю функцію",
        "maximum_reply_rules_count_reached": "Змініть тариф щоб відкрити цю функцію",
        "review_platforms_disabled": "Змініть тариф щоб відкрити цю функцію",
        "review_not_found": "Couldn't reply because to the review because it no longer exists.",
        "google_reply_rejected": "Google не прийняв запит. Спробуйте ще раз пізніше",
        "review_still_live_on_google": "Цей відгук досі опублікований у Google",
        "google_verification_unavailable": "Не вдалося перевірити в Google, чи відгук ще існує. Спробуйте ще раз пізніше",
        "google_reply_unclaimed_location": "Google не приймає відповіді для цього профілю, поки його не підтверджено в Google Business Profile",
        "google_my_business_missing_rights": "Недостатньо прав - Надайте дозвіл на 'Керування списками' під час реєстрації через Google для продовження",
        "IFOOD_AUTHENTICATION_FAILED": "iFood Authentication failed",
        "IFOOD_REVIEW_ALREADY_REPLIED": "Review already replied",
        "IFOOD_MERCHANT_NOT_REGISTERED": "Доступ iFood для цього мерчанта неактивний",
        "IFOOD_INTEGRATION_NOT_CONNECTED": "Інтеграцію iFood не підключено",
        "IFOOD_REVIEW_DISCARDED_OR_MODERATION_PENDING": "Review is already discarded or has a pending moderation",
        "IFOOD_INVALID_REVIEW_REPLY_LENGTH": "Comment length must be between 10 and 300 characters",
        "IFOOD_EMPTY_REVIEW": "You can't reply to review with empty comment",
        "IFOOD_REVIEW_RATING_NOT_REPLYABLE": "На пʼятизіркові відгуки не можна відповісти",
        "IFOOD_REVIEW_REPLY_WINDOW_EXPIRED": "iFood припиняє приймати відповіді через 5 днів після відгуку",
        "channel_not_connected": "Ви не можете надсилати повідомлення на цей канал, оскільки він не підключений.",
        "channel_unreachable_contact": "Цей контакт не може отримувати повідомлення з цього каналу. Перевірте номер телефону та спробуйте ще раз.",
        "ringcentral_not_connected": "Обліковий запис RingCentral більше не підключено. Підключіть його знову в розділі Інтеграції.",
        "ringcentral_number_not_available": "Вибраний номер не може надсилати SMS з цього облікового запису RingCentral.",
        "ringcentral_unavailable": "RingCentral не відповідає. Спробуйте ще раз за кілька хвилин.",
        "channel_phone_number_in_use": "Цей номер телефону вже використовує інший канал.",
        "sms_provider_cannot_change": "Не можна змінити провайдера наявного SMS-каналу. Створіть новий канал.",
        "file_size_too_large": "Розмір файлу не повинен перевищувати {{size}} {{metric}}",
        "attachment_type_not_supported": "Цей тип файлу не можна надіслати через цей канал",
        "file_size_too_small": "Розмір файлу не повинен бути меншим за {{size}} {{metric}}",
        "image_dimensions_too_small": "Зображення має бути щонайменше {{minWidth}}×{{minHeight}} пікселів",
        "video_duration_out_of_range": "Відео має тривати від {{min}} до {{max}} секунд для вибраних платформ",
        "VTEX_AUTHENTICATION_FAILED": "Не вдалося підключити VTEX інтеграцію",
        "COVERMANAGER_NOT_CONNECTED": "Інтеграція CoverManager не підключена",
        "FACEBOOK_NOT_AUTHENTICATED": "Facebook не автентифікований",
        "FACECBOOK_COMMON_ERROR": "Facebook наразі недоступний, спробуйте пізніше",
        "WHATSAPP_REGISTRATION_FAILED": "Не вдалося зареєструвати номер телефону WhatsApp. Переконайтеся, що номер підтверджено, і спробуйте ще раз.",
        "WHATSAPP_CLOUD_API_NOT_ACCEPTED": "Необхідно прийняти Умови використання WhatsApp Business Cloud API перед підключенням.",
        "WHATSAPP_WABA_MISSING": "Реєстрація WhatsApp не повернула бізнес-акаунт WhatsApp. Повторіть підключення та завершіть усі кроки реєстрації.",
        "WHATSAPP_NUMBER_NOT_VALID": "Невірний формат номера телефону WhatsApp.",
        "WHATSAPP_NUMBER_IN_USE": "Цей номер досі зареєстровано в застосунку WhatsApp. Якщо це застосунок WhatsApp Business, підключіть його знову й виберіть продовжити користуватися застосунком. Інакше створіть резервну копію чатів, видаліть цей обліковий запис WhatsApp, зачекайте кілька хвилин і спробуйте ще раз.",
        "Internal error": "Щось пішло не так",
        "csv_validation": "Некоректний формат файлу",
        "csv_import_phone_invalid": "Номер телефону повинен бути в міжнародному форматі, якщо країна не вказана",
        "csv_import_country_required": "Вкажіть країну для: {{errors}}",
        "invalid_format": "Некоректний формат файлу",
        "request_timeout": "Запит вийшов за ліміт часу. Будь ласка, спробуйте ще раз",
        "channel_configuration_error": "Неможливо відправити повідомлення: Неправильне налаштування каналу",
        "phoneOrEmailRequired": "Телефон або email мають бути обов'язковими",
        "phone_number_required": "Необхідний контактний номер телефону",
        "email_required": "Необхідна контактна електронна адреса",
        "invalid_email": "Контактна електронна адреса недійсна: {{errors}}",
        "videos_not_supported_by_google": "Відео не підтримуються Google",
        "google_allow_one_image": "Публікації у Google можуть мати лише 1 зображення",
        "stories_allow_one_media": "Історії дозволяють рівно одне зображення або відео",
        "facebook_allow_one_video": "Публікації у Facebook можуть мати лише 1 відео",
        "facebook_allow_one_type_of_media": "Відеопублікації у Facebook не можуть містити зображень",
        "tiktok_allow_one_video": "Публікації у TikTok можуть мати лише 1 відео",
        "tiktok_no_mixed_media": "Публікації у TikTok не можуть поєднувати фото та відео",
        "tiktok_max_photos_exceeded": "Фотопублікації у TikTok підтримують максимум 35 зображень",
        "x_allow_one_video": "Публікації у X можуть мати лише 1 відео",
        "x_no_mixed_media": "Публікації у X не можуть поєднувати фото та відео",
        "x_max_photos_exceeded": "Публікації у X підтримують максимум 4 зображення",
        "profile_connected_to_another_location": "Цей профіль вже підключений до іншої локації. Виберіть інший профіль або відключіть його від поточної локації",
        "brand_locations_required": "Бренд повинен мати принаймні одну локацію",
        "brand_requires_location": "Це єдина локація бренду. Спершу призначте бренду іншу локацію",
        "delete_brand_failed_assigned_to_channels": "Неможливо видалити. Бренд призначено для активних каналів",
        "delete_brand_failed_assigned_to_agent": "Неможливо видалити. Бренд призначено для активного агента",
        "delete_brand_failed_assigned_to_survey_templates": "Неможливо видалити. Бренд пов’язаний з існуючими шаблонами опитувань",
        "conversations_export_in_progress": "Експорт триває. Очікуйте листа",
        "export_in_progress": "Експорт триває. Очікуйте листа",
        "invalidWhatsAppTemplate": "Шаблон містить непідтримувані змінні",
        "an_unexpected_error_occurred": "Сталася непередбачувана помилка. Будь ласка, спробуйте ще раз",
        "agent_sole_knowledge_owner": "Неможливо видалити агента. Контент бази знань призначено лише цьому агенту. Спочатку перепризначте або видаліть його.",
        "team_owns_channels": "Ця команда володіє каналами. Спочатку призначте її канали іншій команді.",
        "team_owns_channels_requires_messaging": "Не можна забрати доступ до листування в команди, що володіє каналами. Спочатку призначте її канали іншій команді.",
        "channel_team_required": "Оберіть команду для цього каналу.",
        "live_chat_notification_channel_out_of_scope": "Канал для зв'язку має належати бренду лайв-чату або не бути прив'язаним до жодної локації чи бренду.",
        "live_chat_brand_required": "Оберіть бренд, до якого належить цей лайв-чат.",
        "live_chat_phone_or_email_required": "Зробіть електронну пошту або телефон обов'язковим полем.",
        "live_chat_follow_up_channel_required": "Оберіть один канал, щоб зв'язатися з відвідувачами, які пішли.",
        "live_chat_follow_up_channel_not_collected": "Каналу для зв'язку потрібне контактне поле, яке чат не вимагає. Оберіть інший канал.",
        "live_chat_locations_out_of_brand": "Усі вибрані локації мають належати обраному бренду.",
        "live_chat_texts_required": "Напишіть вітальне повідомлення.",
        "live_chat_welcome_name_fallback_required": "У вітальному повідомленні {{errors}} додайте до кожного [name] запасний текст для відвідувачів, які не увійшли, наприклад [name|друже].",
        "business_hours_time_zone_invalid": "Часовий пояс розкладу не підтримується. Зверніться до служби підтримки.",
        "business_hours_invalid": "Робочі години мають бути вказані у форматі на кшталт 09:00.",
        "business_hours_range_empty": "Проміжок часу не може починатися й закінчуватися в один і той самий час.",
        "business_hours_days_required": "Увімкніть принаймні один день.",
        "live_chat_location_out_of_scope": "Цей лайв-чат не обслуговує вибрану локацію.",
        "channel_team_requires_messaging": "Ця команда не має доступу до листування. Оберіть команду з правами на листування.",
        "page_already_connected": "Ця сторінка вже підключена до іншого каналу.",
        "page_cannot_be_changed": "Сторінку наявного каналу не можна змінити. Створіть новий канал.",
        "subscription_required": "Потрібна активна підписка — оформіть її, щоб продовжити",
        "minimum_locations_required": "Тариф Pluspoint починається з {{minimumLocations}} локацій",
        "plan_not_available_for_new_subscriptions": "Цей тариф більше не доступний для нових підписок",
        "custom_pricing_requires_support": "Ваш обліковий запис має індивідуальні ціни. Зверніться до служби підтримки, щоб змінити тариф або період оплати.",
        "billing_catalog_ambiguous": "Виставлення рахунків для цього тарифу тимчасово недоступне. Зверніться до служби підтримки.",
        "directories_addon_requires_subscription": "Локальні каталоги потребують активної підписки",
        "directories_addon_included_in_plan": "Публікація в Локальних каталогах вже включена у ваш тариф",
        "directories_addon_already_enrolled": "Ця локація вже має Локальні каталоги",
        "directories_addon_not_enrolled": "Ця локація не має Локальних каталогів",
        "directories_addon_subscription_required": "Оберіть, з якої підписки оплачувати Локальні каталоги",
        "directories_addon_minimum_term": "Локальні каталоги можна скасувати після мінімального терміну у 3 місяці",
        "directories_addon_country_not_supported": "Публікація в Локальних каталогах поки недоступна в країні цієї локації",
        "locations_below_directories_enrollments": "{{enrolledLocationsCount}} локацій мають Локальні каталоги — скасуйте ці додатки перед зменшенням кількості локацій",
        "billing_surveys_disabled": "Опитування не включені у ваш поточний тариф",
        "billing_campaigns_disabled": "Кампанії не включені у ваш поточний тариф",
        "billing_coupons_disabled": "Купони не включені у ваш поточний тариф",
        "billing_plan_not_found": "Тарифний план не знайдено",
        "billing_stripe_subscription_not_found": "Підписку не знайдено",
        "billing_stripe_subscription_email_is_empty": "У підписки немає збереженої електронної пошти",
        "subscription_expired": "Ваша підписка закінчилася — поновіть її, щоб продовжити",
        "maximum_custom_domains_reached": "Ви досягли максимальної кількості власних доменів для вашого тарифу",
        "billing_listing_directories_disabled": "Каталоги лістингів недоступні у вашому поточному тарифі",
        "email_template_name_taken": "Шаблон із такою назвою вже існує.",
        "email_template_not_found": "Email-шаблон не знайдено. Можливо, його було видалено.",
        "email_template_required": "Email-кампанії типу «повідомлення» потребують шаблон із бібліотеки.",
        "email_template_archived": "Цей шаблон заархівовано, його не можна вибрати. Спершу розархівуйте його в бібліотеці.",
        "email_template_read_only": "Стартові дизайни доступні лише для читання. Продублюйте шаблон, щоб редагувати.",
        "email_template_invalid_design": "Дизайн шаблону некоректний. Перевірте вміст блоків, посилання та довжину полів.",
        "email_template_dynamic_link_required": "Кампаніям з опитуванням чи купоном потрібен шаблон із кнопкою динамічного посилання.",
        "email_template_dynamic_link_not_supported": "Шаблони з кнопкою динамічного посилання можна використовувати лише в кампаніях з опитуванням або купоном.",
        "email_template_link_type_mismatch": "Кнопки-посилання цього шаблону ведуть на інший тип призначення, тому він не підходить для цієї кампанії.",
        "email_template_links_locked_while_in_use": "Кнопки динамічного посилання цього шаблону використовуються в кампаніях або автоматизаціях. Видаліть ці посилання або продублюйте шаблон.",
        "whatsapp_template_required": "Кампанії WhatsApp потребують шаблон повідомлення.",
        "email_template_in_use": "Цей шаблон використовується в кампаніях або автоматизаціях і не може бути видалений. Спочатку видаліть ці посилання.",
        "whatsapp_template_delete_blocked": "Цей шаблон використовується в кампаніях або автоматизаціях і не може бути видалений. Видаліть ці посилання або заархівуйте шаблон.",
        "whatsapp_template_in_use": "Цей шаблон використовується в запланованих або активних кампаніях чи активних автоматизаціях. Дублюйте його та редагуйте копію або спочатку видаліть ці посилання.",
        "whatsapp_template_copy_code_requires_coupon": "Кнопка копіювання коду цього шаблону потребує кампанії з купонами, яка надасть код.",
        "whatsapp_template_header_media_missing": "Заголовок-зображення цього шаблону ще не має зображення. Спочатку завершіть його налаштування в Бібліотеці.",
        "whatsapp_template_not_found": "WhatsApp-шаблон не знайдено. Можливо, його було видалено.",
        "whatsapp_template_name_taken": "Шаблон із такою назвою та мовою вже існує.",
        "whatsapp_template_invalid_content": "Вміст шаблону некоректний. Перевірте змінні, кнопки та довжину полів.",
        "whatsapp_template_not_editable": "Цей шаблон не можна редагувати в поточному статусі.",
        "whatsapp_template_unavailable": "Цей WhatsApp-шаблон наразі недоступний — його може бути призупинено, вимкнено або йому бракує обовʼязкових налаштувань.",
        "whatsapp_template_not_approved": "У кампаніях можна використовувати лише схвалені WhatsApp-шаблони.",
        "whatsapp_template_not_mapped": "У шаблоні є неналаштовані змінні. Спершу завершіть налаштування в бібліотеці.",
        "whatsapp_template_archived": "Цей шаблон заархівовано, його не можна вибрати. Спершу розархівуйте його в бібліотеці.",
        "whatsapp_template_waba_mismatch": "Цей шаблон належить іншому акаунту WhatsApp Business, ніж вибраний канал.",
        "whatsapp_template_disconnected": "Акаунт WhatsApp Business цього шаблону відключено.",
        "whatsapp_template_link_required": "Кампаніям з опитуванням чи купоном потрібен шаблон із кнопкою динамічного посилання.",
        "whatsapp_template_link_not_supported": "Цей шаблон має кнопку з динамічним посиланням, тому його можна використовувати лише в кампаніях з опитуваннями або купонами.",
        "whatsapp_template_link_type_mismatch": "Кнопка з посиланням цього шаблону веде на інший тип призначення, ніж потрібно цьому відправленню.",
        "whatsapp_template_links_locked_while_in_use": "Не можна додати чи прибрати кнопку посилання, поки шаблон використовується в кампаніях або автоматизаціях. Видаліть ці посилання або продублюйте шаблон.",
        "automation_invalid_trigger": "Автоматизація повинна мати рівно один тригер.",
        "automation_trigger_no_events": "Оберіть принаймні одну тригерну подію.",
        "automation_no_action": "Додайте принаймні одне повідомлення або опитування, до якого веде тригер.",
        "automation_wait_invalid": "Крок очікування повинен мати тривалість більшу за нуль.",
        "automation_survey_missing": "Оберіть шаблон опитування для кроку з опитуванням.",
        "automation_message_empty": "Додайте вміст до кроку з повідомленням.",
        "automation_condition_incomplete": "У фільтрі бракує поля або значення.",
        "automation_too_large": "Автоматизація не може мати більше ніж 100 кроків.",
        "automation_unreachable_node": "Кожен крок має бути з'єднаний із тригером.",
        "automation_has_cycle": "Автоматизація не може містити цикли.",
        "automation_invalid_edge": "З'єднання вказує на неіснуючий крок.",
        "automation_branch_edge_invalid": "Шляхи розгалуження мають бути позначені як так або ні.",
        "automation_branch_duplicate": "Розгалуження може мати щонайбільше один шлях «так» і один шлях «ні».",
        "automation_multiple_next": "Крок може мати щонайбільше один наступний крок.",
        "automation_unexpected_branch_key": "Лише розгалуження можуть мати позначені шляхи.",
        "automation_invalid_node_id": "У кроку автоматизації відсутній id.",
        "automation_duplicate_node_id": "Кроки автоматизації повинні мати унікальні id.",
        "automation_node_channel_required": "Оберіть канал для кожного кроку з повідомленням та опитуванням.",
        "automation_node_channel_invalid": "Крок використовує недійсний або неготовий канал.",
        "automation_node_survey_invalid": "Крок використовує недійсний шаблон опитування.",
        "automation_node_coupon_invalid": "Крок використовує недійсний шаблон купона.",
        "automation_channel_type_unsupported": "Цей тип каналу не підтримується в автоматизаціях.",
        "automation_segment_in_use": "Цей сегмент використовується в автоматизації. Приберіть його з автоматизації перед видаленням.",
        "facebook_profile_id_missing": "У цьому посиланні Facebook немає id профілю. Скопіюйте повну адресу сторінки разом із частиною ?id=",
        "google_place_id_missing": "Це посилання Google не містить id місця",
        "profile_url_invalid": "Введіть повну веб-адресу, що починається з http:// або https://",
        "social_platform_managed_as_link": "Ця соціальна мережа керується через соціальні посилання локації, а не як профіль відгуків",
        "ubereats_store_url_invalid": "Введіть адресу сторінки закладу в Uber Eats, наприклад https://www.ubereats.com/store/name/id",
        "bbb_profile_url_invalid": "Введіть адресу профілю компанії на BBB, наприклад https://www.bbb.org/us/tx/san-antonio/profile/category/name-0825-1000132336",
        "thefork_restaurant_url_invalid": "Введіть адресу сторінки ресторану в TheFork, наприклад https://www.thefork.com/restaurant/name-r123",
        "booking_profile_url_invalid": "Вкажіть адресу сторінки готелю на Booking.com, наприклад https://www.booking.com/hotel/ua/name.html",
        "expedia_group_profile_already_connected": "Ця локація вже має Expedia / Hotels.com. Щоб перейти на інший сайт, видаліть його й додайте нову адресу.",
        "expedia_group_profile_url_invalid": "Введіть адресу сторінки об’єкта на Expedia або Hotels.com, наприклад https://www.hotels.com/ho123456",
        "booking_extranet_url_invalid": "Вкажіть посилання на Екстранет Booking.com для цього обʼєкта або його числовий ID.",
        "media_dimensions_too_large": "Файл не має перевищувати {{maxWidth}}×{{maxHeight}} пікселів для вибраних платформ",
        "video_invalid": "Цей файл не є дійсним відео",
        "video_too_long": "Відео довше за максимальну тривалість для вибраних платформ",
        "video_too_short": "Відео коротше за мінімум у 3 секунди",
        "video_too_large": "Відео перевищує максимальний розмір завантаження",
        "video_too_small": "Відеофайл порожній або замалий, щоб бути дійсним відео",
        "video_format_unsupported": "Підтримуються лише відеофайли MP4",
        "video_processing_failed": "Не вдалося обробити відео. Спробуйте експортувати його знову у форматі MP4.",
        "video_codec_unsupported": "Відео має бути закодоване у H.264 або HEVC — експортуйте його знову як стандартний MP4",
        "video_audio_unsupported": "Аудіо відео має бути AAC — експортуйте його знову як стандартний MP4",
        "video_too_large_for_platform": "Це відео завелике для однієї з вибраних платформ — перегляньте попередження вище",
        "video_too_small_for_platform": "Це відео менше за мінімальний розмір однієї з вибраних платформ",
        "video_too_long_for_platform": "Це відео задовге для однієї з вибраних платформ — перегляньте попередження вище",
        "video_too_short_for_platform": "Це відео коротше за мінімум у 3 секунди",
        "video_too_wide_for_platform": "Роздільна здатність цього відео зависока для однієї з вибраних платформ — перегляньте попередження вище",
        "video_not_supported_by_platform": "Одна з вибраних платформ не підтримує відеопублікації",
        "video_link_untrusted": "Це відео потрібно завантажити через Pluspoint, перш ніж використовувати",
        "video_external_not_supported_by_tiktok": "TikTok публікує лише відео, завантажені через Pluspoint — завантажте файл або приберіть TikTok",
        "tiktok_settings_required": "Не вибрано налаштування TikTok. Відкрийте публікацію та виберіть їх.",
        "tiktok_disclosure_incomplete": "Потрібно вказати, чи ваш контент рекламує вас, третю сторону або обох.",
        "video_too_long_for_creator": "Відео довше, ніж дозволяє підключений акаунт TikTok.",
        "tiktok_privacy_unavailable": "Вибраний варіант приватності більше не доступний у підключеному акаунті TikTok. Повторіть спробу, коли акаунт знову його запропонує, або заплануйте нову публікацію з іншою аудиторією.",
        "tiktok_branded_private": "Брендований контент не можна публікувати з видимістю Лише я.",
        "tiktok_cannot_post_now": "TikTok зараз не приймає публікації від цього акаунта. Спробуйте пізніше.",
        "tiktok_unaudited": "Застосунок TikTok від Pluspoint ще не схвалено для публічних публікацій.",
        "tiktok_account_not_resolved": "Ця локація не вказує, який акаунт TikTok публікує для неї. Виберіть його у профілі локації.",
        "tiktok_auth_removed": "Акаунт TikTok було відключено. Підключіть його знову та спробуйте ще раз.",
        "tiktok_media_pull_failed": "TikTok не зміг завантажити медіа. Спробуйте ще раз.",
        "tiktok_media_rejected": "TikTok відхилив медіа. Перевірте формат, роздільну здатність і тривалість, а потім заплануйте нову публікацію.",
        "tiktok_publish_cancelled": "Публікацію скасовано в TikTok.",
        "video_too_wide": "Роздільна здатність цього відео перевищує можливості будь-якої підтримуваної платформи (макс. 4096 пікс. на довшій стороні)",
        "review_reply_draft_unusable": "Pulse AI повернув чернетку з незаповненими заповнювачами. Спробуйте «Написати відповідь» ще раз.",
        "recovery_form_unresolved": "Форма відновлення недоступна для цього відгуку. Приберіть її заповнювач з відповіді.",
        "description_contains_url": "Посилання в описах бізнесу не дозволені.",
        "special_hours_times_required": "Відкрита особлива дата потребує годин роботи.",
        "special_hours_times_not_allowed": "Закрита особлива дата не може мати годин роботи.",
        "special_hours_invalid_time_range": "Проміжок часу має закінчуватися після початку.",
        "location_not_found": "Ця локація більше не існує.",
        "concurrency_conflict": "Хтось інший змінив або видалив цю локацію одночасно з вами. Відкрийте її знову й спробуйте ще раз.",
        "bulk_update_conflict": "Хтось інший змінив одну з цих локацій, поки застосовувалася зміна. Нічого не збережено. Застосуйте зміну ще раз.",
        "email_domain_taken": "Цей домен уже зареєстровано. Зверніться в підтримку, якщо він ваш.",
        "email_domain_suspended": "Надсилання з цього домену призупинено. Зверніться в підтримку.",
        "email_domain_public": "Це публічний поштовий сервіс. Використовуйте домен, який належить вашому бізнесу.",
        "email_domain_reserved": "Домени Pluspoint підключити не можна.",
        "email_domain_invalid": "Введіть коректний домен, наприклад acme.com.",
        "email_domain_return_path_invalid": "Субдомен Return-Path може містити лише літери, цифри та дефіси.",
        "hosted_email_capacity": "Зараз не вдається підключити пошту на власному домені. Зверніться в підтримку.",
        "email_domain_return_path_fixed": "У цього домену вже є субдомен Return-Path. Вимкніть власний субдомен, щоб використати наявний.",
        "email_address_invalid": "Введіть коректну адресу електронної пошти на власному домені.",
        "email_channel_address_locked": "Адресу цього поштового каналу не можна змінити.",
        "email_channel_hosted_create": "Поштові канали на власному домені створюються через налаштування домену.",
        "email_domain_in_use": "Спочатку видаліть канали цього домену.",
        "hosted_email_unavailable": "Пошта на власному домені недоступна в цьому середовищі.",
        "channel_not_ready": "Цей канал ще чекає на підтвердження свого домену.",
        "channel_throttled": "Сервіс надсилання перевантажений. Спробуйте ще раз за хвилину.",
        "email_domain_check_failed": "Зараз не вдалося перевірити записи. Спробуйте ще раз за хвилину.",
        "invalid_website": "Введіть домен, зі шляхом або без нього, наприклад help.example.com або example.com/help",
        "document_too_many_pages": "Файл не повинен перевищувати {{pages}} сторінок",
        "document_too_many_rows": "Кожен аркуш не повинен перевищувати {{rows}} рядків",
        "knowledge_base_document_limit": "Ці агенти вже мають максимальну кількість документів: {{errors}}",
        "knowledge_base_website_limit": "Ці агенти вже мають максимальну кількість вебсайтів: {{errors}}",
        "knowledge_base_conflict": "Хтось інший змінив цей вміст у той самий час. Нічого не збережено. Спробуйте ще раз.",
        "file_required": "Виберіть файл",
        "no_active_account": "Ви більше не маєте доступу до акаунта Pluspoint. Попросіть власника акаунта запросити вас знову.",
        "invalid_sex": "Стать має бути Жінка або Чоловік: {{errors}}",
        "invalid_date_of_birth": "Дата народження має бути РРРР-ММ-ДД або ММ-ДД без року, від 1900 року і не в майбутньому: {{errors}}",
        "invalid_language": "Мова має бути кодом мови, наприклад en або pt: {{errors}}",
        "birth_year_required": "Дата народження, введена вручну, потребує року",
        "automation_trigger_date_invalid": "Оберіть коректні дату й час для тригера.",
        "automation_condition_invalid": "Фільтр має значення, яке не можна використати.",
        "automation_trigger_date_passed": "Ця одноразова дата вже минула.",
        "automation_condition_event_on_date": "Фільтри подій не застосовуються до автоматизації, що починається в дату."
    },
    "AnalyticsConversion": {
        "conversion": "Конверсія",
        "sentSurveys": "Надіслано опитувань",
        "responsesReceived": "Відповідей на опитування",
        "reviewsReceived": "Отриманих відгуків",
        "openedSurveys": "Відкриті опитування",
        "responses": "Відповідей на опитування",
        "proceededToReviewSite": "Переходів на сайти відгуків",
        "responseRate": "Конверсія у відповіді",
        "reviewRate": "Конверсія у відгуки",
        "reviewRateTooltip": "Показник включає всі відгуки для обраних локацій, а не лише ті, що надійшли через опитування. Фактична конверсія з опитувань може відрізнятися.",
        "fromPreviousPeriod": "ніж в минулому періоді",
        "reviewsLifecycle": "Воронка конверсії",
        "overall": "Підсумки",
        "surveyInvitations": "Відправлені опитування",
        "qrCodes": "QR коди",
        "conversionTrend": "Тенденція конверсії"
    },
    "AnalyticsKeywords": {
        "tableTitle": "Аналітика по ключовим словам",
        "keyword": "Ключове слово",
        "avgRating": "Середній рейтинг",
        "numberOfReviews": "Кількість відгуків",
        "sentiment": "Оцінка",
        "positiveKeywords": "Топ позитивних ключових слів",
        "negativeKeywords": "Топ негативних ключових слів"
    },
    "AnalyticsOperationalInsights": {
        "topStrengths": "Найсильніші сторони",
        "topStrengthsSubtitle": "Категорії, в яких клієнти найчастіше залишають відгуки на 5 зірок.",
        "topIssues": "Найпоширеніші проблеми",
        "topIssuesSubtitle": "Категорії, які найчастіше згадуються у відгуках з низькими оцінками.",
        "incidents": "Інциденти",
        "incidentsSubtitle": "Відсоток негативних відгуків у кожній категорії. Вищі значення свідчать про більшу концентрацію незадоволеності клієнтів.",
        "sentimentScore": "Оцінка задоволеності",
        "sentimentScoreSubtitle": "Загальний баланс між позитивними та негативними відгуками для кожної категорії. Позитивні оцінки вказують на сильні сторони; негативні — на проблемні зони."
    },
    "AnalyticsReviews": {
        "averageRating": "Середня оцінка",
        "reviews": "Відгуків",
        "totalReviews": "Всього відгуків",
        "totalReplies": "Відсоток відповідей",
        "totalRepliesPercentage": "Відсоток відповідей",
        "totalResponses": "Всього відповідей",
        "reviewsRatingDistribution": "Розподіл оцінок",
        "responsesRatingDistribution": "Розподіл відповідей",
        "stars1": "1 зірка",
        "stars2": "2 зірки",
        "stars3": "3 зірки",
        "stars4": "4 зірки",
        "stars5": "5 зірок",
        "ratingsTimeline": "Динаміка оцінок",
        "ratingsTimelineTooltip": "Динаміка оцінок показує орієнтовні історичні значення. Фактичні оцінки на платформах можуть відрізнятися.",
        "reviewIndex": "Індекс відгуків",
        "reviewIndexTooltip": "Оцінка зі 100 можливих того, як клієнти оцінюють ваші локації на сайтах відгуків, де нові відгуки важать більше. З’являється, коли є достатньо нових відгуків з оцінкою.",
        "sentimentTrend": "Оцінки відгуків",
        "positiveReviews": "Позитивних оцінок",
        "positiveResponses": "Позитивних відповідей",
        "negativeReviews": "Негативних оцінок",
        "negativeResponses": "Негативних відповідей",
        "reviewSitesTrend": "Сайти відгуків",
        "fromPreviousPeriod": "ніж в минулому періоді",
        "others": "Iнші",
        "nps": "Net Promoter Score",
        "reviewsByDay": "Відгуки за днями",
        "reviewsByDaypart": "Відгуки за частиною дня",
        "sunday": "Нд",
        "monday": "Пн",
        "tuesday": "Вт",
        "wednesday": "Ср",
        "thursday": "Чт",
        "friday": "Пт",
        "saturday": "Сб",
        "morning": "Ранок",
        "afternoon": "День",
        "evening": "Вечір"
    },
    "AnalyticsConversations": {
        "responseRate": "Розмови з відповіддю",
        "responseTime": "Час відповіді (годин)",
        "resolutionTime": "Час вирішення (годин)",
        "resolutionRate": "Вирішені розмови",
        "newConversations": "Нові розмови",
        "resolvedConversations": "Вирішені розмови",
        "openConversations": "Відкриті розмови",
        "unassignedConversations": "Непризначені розмови",
        "conversationsTrend": "Тенденція розмов",
        "channelsBreakdown": "Розподіл каналів",
        "totalConversations": "Всього розмов",
        "messagesPerConversation": "Повідомлень на розмову",
        "conversationsHandled": "Опрацьовані розмови",
        "averageHandleTime": "Середній час обробки розмови (годин)"
    },
    "AnalyticsSocialPosts": {
        "posts": "Публікації",
        "followers": "Підписники",
        "reach28": "Охоплення за 28 днів",
        "rateByReach": "Рівень залучення за охопленням",
        "rateByFollowers": "Рівень залучення за підписниками",
        "reach": "Охоплення",
        "likes": "Вподобання",
        "comments": "Коментарі",
        "shares": "Поширення",
        "engagements": "Залучення",
        "clicks": "Кліки",
        "saves": "Збереження",
        "percentagePoints": "{{value}} в. п."
    },
    "AnalyticsPresence": {
        "searchAppearances": "Пошукові покази",
        "views": "Перегляди",
        "calls": "Дзвінки",
        "directions": "Перегляди маршрутів",
        "websiteClicks": "Переходи на сайт",
        "devicesBreakdown": "Розподіл за пристроями",
        "googleSearchMobile": "Пошук Google - Мобільний",
        "googleMapsMobile": "Карти Google - Мобільний",
        "googleSearchDesktop": "Пошук Google - Настільний",
        "googleMapsDesktop": "Карти Google - Настільний",
        "searchKeywords": "Ключові слова",
        "totalViews": "Всього переглядів"
    },
    "AnalyticsVisibility": {
        "pageTitle": "Відстежуйте свою видимість у локальному пошуку",
        "pageSubtitle": "Дивіться, як кожна локація ранжується в результатах Google Maps на сітці точок навколо неї. Порівнюйте локації, стежте за змінами позицій з часом, запускайте сканування за потреби та відкривайте локацію, щоб побачити мапу по точках і конкурентів.",
        "reportTitle": "Звіт про видимість",
        "vs90DaysAgo": "порівняно з 90 днями тому",
        "loadError": "Не вдалося завантажити дані видимості. Спробуйте ще раз.",
        "averageVisibility": "Середня видимість",
        "locationsInTop3": "Локації в локальному топ-3",
        "averageMapRank": "Середня позиція на мапі",
        "location": "Локація",
        "visibility": "Видимість",
        "avgRank": "Середня позиція",
        "rankTrend": "Тренд позиції",
        "rankTrendHint": "Середня позиція на мапі за місяць протягом останніх 12 місяців, від найдавнішого до найновішого. Місяці без сканувань відображаються як пропуски.",
        "delta90d": "Зміна позиції (90 дн)",
        "delta90dHint": "Як змінилася середня позиція на мапі порівняно зі скануванням близько 90 днів тому. Зелений — піднялися ближче до №1, червоний — опустилися.",
        "inTop3": "У топ-3",
        "inTop3Hint": "Частка просканованих точок сітки, де цей бізнес потрапив у локальний топ-3 під час останнього сканування.",
        "avgMapRank": "Середня позиція на мапі",
        "top3Points": "Точки в топ-3",
        "trackedKeywords": "Відстежувані ключові слова",
        "whoWinsHere": "Хто перемагає тут",
        "business": "Бізнес",
        "rating": "Рейтинг",
        "you": "ви",
        "runNewScan": "Запустити нове сканування",
        "printReport": "Роздрукувати звіт",
        "scanInProgress": "Сканування триває",
        "scanDate": "Дата сканування",
        "googleProfile": "Профіль Google",
        "address": "Адреса",
        "phone": "Телефон",
        "website": "Вебсайт",
        "mapRankTitle": "Позиція на мапі — {{keyword}}",
        "gridSpacing": "крок {{km}} км",
        "top3": "Топ 3",
        "fourToTen": "4–10",
        "elevenToTwenty": "11–20",
        "notInTop20": "Поза топ-20",
        "noDataYet": "Результатів поки немає — налаштуйте відстеження для локації, щоб запустити перше сканування",
        "noCoordinates": "Заповніть адресу, щоб увімкнути сканування",
        "rescanConflict": "Сканування цієї локації вже триває",
        "gridSettings": "Налаштування сітки",
        "gridSizeLabel": "Розмір сітки",
        "gridSpacingLabel": "Відстань між точками",
        "spacingKm": "{{km}} км",
        "addKeywordLabel": "Додати ключове слово",
        "keywordsRequired": "Додайте принаймні одне ключове слово",
        "excludePinsHint": "Натисніть на точку, щоб виключити її з відстеження; натисніть на виключену точку, щоб повернути її.",
        "keepOnePin": "Принаймні одна точка має залишатися відстежуваною",
        "settingsApplyNote": "Зміни набудуть чинності з наступного сканування.",
        "settingsSaved": "Налаштування видимості збережено",
        "settingsSavedScanStarted": "Налаштування збережено — перше сканування запущено",
        "autoScan": "Щомісячне сканування",
        "autoScanHint": "Якщо увімкнено, ця локація автоматично сканується щомісяця.",
        "autoScanConfigureFirst": "Спершу налаштуйте відстеження для цієї локації",
        "viewReports": "Переглянути звіти",
        "runScan": "Запустити сканування",
        "scanStarted": "Сканування запущено",
        "configure": "Налаштувати",
        "reviews": "Відгуки",
        "reviewsHint": "Загальна кількість відгуків Google; значення в дужках — місячна зміна, оцінена за різницею між двома останніми скануваннями.",
        "categories": "Категорії",
        "googleMapsLink": "Профіль",
        "openOnGoogleMaps": "Відкрити в Google Maps",
        "competitorPinHint": "★ — розташування цього конкурента"
    },
    "alertMessages": {
        "popupBlocked": "Дозвольте спливні вікна, щоб відкрити форму скарги Google",
        "createSuccess": "Успішно створено",
        "createFail": "Не вдалося створити",
        "editSuccess": "Успішно відредаговано",
        "editFail": "Не вдалося відредагувати",
        "deleteSuccess": "Успішно видалено",
        "deleteFail": "Не вдалося видалити",
        "updateSuccess": "Успішно оновлено",
        "updateFail": "Не вдалося оновити",
        "retrySuccess": "Повторну спробу заплановано",
        "retryFail": "Не вдалося запланувати повторну спробу",
        "downloadFail": "Не вдалося завантажити",
        "printFail": "Не вдалося роздрукувати",
        "sendSuccess": "Успішно надіслано",
        "conversationCreated": "Розмову створено",
        "sendFail": "Не вдалося надіслати",
        "importSuccess": "Успішно імпортовано",
        "importFail": "Не вдалося імпортувати",
        "importPartial": "Імпортовано {{imported}} локацій, пропущено {{skipped}}",
        "cancelSuccess": "Успішно скасовано",
        "cancelFail": "Не вдалося скасувати",
        "uploadSuccess": "Успішно завантажено",
        "uploadFail": "Не вдалося завантажити",
        "connectIntegrationSuccess": "Інтеграцію успішно підключено",
        "connectIntegrationFail": "Не вдалося підключити інтеграцію",
        "ifoodConnectRequestSent": "Запит на підключення iFood надіслано. Інтеграцію буде активовано, щойно iFood надасть доступ",
        "disconnectIntegrationSuccess": "Інтеграцію успішно відключено",
        "disconnectIntegrationFail": "Не вдалося відключити інтеграцію",
        "tooManyFiles": "Ви можете завантажити максимум {{limit}} файлів",
        "loadFail": "Не вдалося завантажити дані"
    },
    "buttons": {
        "moveConversation": "Перемістити розмову",
        "cancel": "Скасувати",
        "close": "Закрити",
        "discard": "Відхилити",
        "clearFilters": "Очистити фільтри",
        "copy": "Копіювати",
        "open": "Відкрити",
        "delete": "Видалити",
        "edit": "Редагувати",
        "create": "Створити",
        "revoke": "Відкликати",
        "save": "Зберегти",
        "saveChanges": "Зберегти зміни",
        "merge": "Об'єднати",
        "mergeContacts": "Об'єднати контакти",
        "filters": "Фільтри",
        "applyFilters": "Застосувати",
        "addLocation": "Додати локацію",
        "addLocationManually": "Додати локацію вручну",
        "sendMessage": "Надіслати",
        "reopen": "Відкрити",
        "resolve": "Вирішити",
        "enable": "Активувати",
        "pause": "Призупинити",
        "continue": "Продовжити",
        "back": "Назад",
        "done": "Закінчити",
        "cheduleCampaign": "Створити розсилку",
        "getCode": "Отримати код",
        "reply": "Відповідь",
        "publish": "Опублікувати",
        "connect": "Підключити",
        "disable": "Вимкнути",
        "disconnect": "Відключити",
        "reconnect": "Перепідключити",
        "sendSurveys": "Надіслати опитування",
        "replaceCSV": "Замінити файл",
        "uploadCSVFile": "Вибрати файл",
        "addChannel": "Додати канал",
        "importFromGoogle": "Імпортувати з Google",
        "upgradePlan": "Вибрати тариф",
        "managePlan": "Керувати тарифом",
        "changePlan": "Змінити тариф",
        "talkToSales": "Зв'язатися з продажем",
        "addUser": "Додати користувача",
        "addRule": "Додати нове правило",
        "createCampaign": "Створити розсилку",
        "import": "Імпортувати",
        "contact": "ЗВЕРНУТИСЬ У ПІДТРИМКУ",
        "setUpSurveys": "Налаштувати опитування",
        "viewResponses": "Переглянути відповіді",
        "newTicket": "Нова задача",
        "viewTicket": "Дивитись задачу",
        "sendLink": "Надіслати",
        "manageMicrosites": "Керувати мікросайтами",
        "seeSurveyResponse": "Дивитися відповіді",
        "resolveComplaints": "Вирішувати скарги",
        "replyToReviews": "Відповісти на відгуки",
        "download": "Завантажити",
        "print": "Роздрукувати",
        "viewReviews": "Див. відгуки",
        "logIn": "Увійти",
        "createNewMicrosite": "Створити новий мікросайт",
        "replace": "Замінити",
        "upload": "Завантажити",
        "add": "Додати",
        "localization": "Локалізація",
        "addLanguage": "Додати мову",
        "addCategory": "Додати категорію",
        "addManually": "Додати вручну",
        "connectAnotherAccount": "Змінити обліковий запис",
        "complete": "Завершити",
        "addTemplate": "Додати новий шаблон",
        "changePassword": "Змінити пароль",
        "signupButton": "Реєстрація",
        "addSurvey": "Створити опитування",
        "createQrCode": "Створити QR-код",
        "copyCode": "Скопіювати",
        "replaceSecret": "Замінити секрет",
        "generateSecret": "Згенерувати секрет",
        "copyLink": "Скопіювати посилання",
        "preview": "Перегляд",
        "exportAsCSV": "Зберегти у CSV",
        "exportAsExcel": "Зберегти у Excel",
        "logout": "Вийти",
        "deleteSite": "Видалити мікросайт",
        "configure": "Налаштувати",
        "documentation": "Документація",
        "viewMore": "Переглянути більше",
        "confirm": "Підтвердити",
        "createNewPost": "Створити нову публікацію",
        "manage": "Керувати",
        "connectProfile": "Підключити Профіль",
        "viewStatus": "Переглянути Статус",
        "createNewProfile": "Створити Новий Профіль",
        "manageProfile": "Керувати Профілем",
        "publishProfile": "Опублікувати Профіль",
        "schedulePost": "Запланувати публікацію",
        "updateLocations": "Оновлення локацій",
        "validate": "Перевірити",
        "bulkUpdateCSV": "Імпорт (CSV)",
        "bulkEdit": "Масове редагування",
        "selectAll": "Вибрати всі",
        "deselectAll": "Відмінити вибір",
        "send": "Надіслати",
        "addNewTemplate": "Додати новий шаблон повідомлення",
        "export": "Експорт",
        "startSync": "Почати синхронізацію",
        "syncing": "Синхронізація..",
        "importing": "Імпортування..",
        "addNewDate": "Додати нову дату",
        "report": "Оскаржити",
        "undoReport": "Скасувати скаргу",
        "viewOnGoogle": "Переглянути в Google",
        "connectWithMeta": "Підключити Meta Business",
        "saveDraft": "Зберегти чернетку",
        "hideAllNotifications": "Приховати всі сповіщення",
        "hide": "Приховати",
        "markAsReplied": "Додати відповідь",
        "copyAndOpen": "Скопіювати та відкрити",
        "addContent": "Додати контент",
        "createBrand": "Створити новий бренд",
        "addAgent": "Додати агента",
        "reset": "Скинути",
        "joinConversation": "Приєднатися до розмови",
        "join": "Приєднатися",
        "tryForFree": "Спробувати безкоштовно",
        "resend": "Надіслати код знову",
        "cropImage": "Підтвердити зображення",
        "assignAgents": "Призначити агентів",
        "upgrade": "Оформити"
    },
    "AutomationsPage": {
        "create": "Створити автоматизацію",
        "editor": {
            "channel": "Канал",
            "oncePerContact": "Один раз на контакт",
            "save": "Зберегти",
            "nameRequired": "Дайте назву автоматизації",
            "saved": "Автоматизацію збережено",
            "addStep": "Додати крок",
            "branchYes": "Так",
            "branchNo": "Ні",
            "namePlaceholder": "Автоматизація без назви",
            "fixIssues": "Деякі кроки містять помилки. Виправте виділені кроки перед збереженням."
        },
        "palette": {
            "send": "Надсилання",
            "flow": "Потік"
        },
        "paletteHint": {
            "sendMessage": "Надіслати SMS, WhatsApp або email",
            "sendCoupon": "Надіслати купон контакту",
            "sendSurvey": "Надіслати опитування контакту",
            "wait": "Пауза перед наступним кроком",
            "branch": "Розділити шлях за умовою"
        },
        "trigger": {
            "whoCanEnter": "Хто може увійти",
            "byEvent": "Подія",
            "byDate": "Дата",
            "date": "Дата",
            "contactBirthday": "День народження контакту",
            "fixedDate": "Фіксована дата",
            "month": "Місяць",
            "day": "День",
            "year": "Рік",
            "everyYear": "Щороку",
            "timing": "Коли",
            "onTheDay": "У цей день",
            "before": "До",
            "offsetDaysBefore": "Днів до",
            "after": "Після",
            "offsetDaysAfter": "Днів після",
            "sendAt": "Час",
            "birthday": "День народження",
            "whichSegments": "Сегменти (залиште порожнім для будь-якого)",
            "daysBefore_one": "За {{count}} день",
            "daysBefore_few": "За {{count}} дні",
            "daysBefore_many": "За {{count}} днів",
            "daysBefore_other": "За {{count}} дня",
            "daysAfter_one": "Через {{count}} день",
            "daysAfter_few": "Через {{count}} дні",
            "daysAfter_many": "Через {{count}} днів",
            "daysAfter_other": "Через {{count}} дня"
        },
        "nodes": {
            "trigger": "Тригер",
            "branch": "Якщо / то",
            "sendMessage": "Надіслати повідомлення",
            "sendCoupon": "Надіслати купон",
            "sendSurvey": "Надіслати опитування",
            "wait": "Очікування",
            "exit": "Вихід",
            "setDuration": "Вказати тривалість",
            "noMessage": "Повідомлення ще немає",
            "pickSurvey": "Оберіть опитування",
            "surveySelected": "Опитування обрано",
            "pickCoupon": "Оберіть купон",
            "couponSelected": "Купон обрано",
            "setCondition": "Задати умову",
            "pickEvents": "Оберіть події",
            "eventCount": "{{count}} подія(-ї)",
            "conditionCount": "{{count}} умова(-и)",
            "exitSubtitle": "Тут контакти виходять з автоматизації"
        },
        "drawer": {
            "customEventType": "Тип власної події (необовʼязково)",
            "branchHint": "Шлях «так» обирається, коли виконуються ці умови",
            "wait": "Очікування"
        },
        "table": {
            "steps": "Кроки",
            "enrolled": "Залучені контакти",
            "enrolledHint": "Контакти, які потрапили в цю автоматизацію",
            "failedFixHint": "Ця автоматизація завершилася з помилкою. Відкрийте її та виправте проблему, щоб увімкнути знову."
        },
        "conditions": {
            "everyoneEnters": "Усі, хто запустить цю автоматизацію, увійдуть.",
            "matchAllHint": "Лише контакти, що відповідають усім умовам:",
            "matchAnyHint": "Контакти, що відповідають будь-якому зі сценаріїв:",
            "addFilter": "Додати фільтр",
            "addAlternative": "Додати альтернативу «АБО»",
            "scenario": "Сценарій {{number}}",
            "and": "і",
            "or": "або",
            "segment": "Сегмент",
            "segments": "Сегменти",
            "eventField": "Поле події",
            "jsonPathPlaceholder": "JSON-шлях, напр. order.total",
            "value": "Значення",
            "valuePlaceholder": "значення",
            "operators": {
                "isAnyOf": "є будь-яким із",
                "isNoneOf": "не є жодним із",
                "is": "дорівнює",
                "isNot": "не дорівнює",
                "isOneOf": "є одним із",
                "contains": "містить",
                "notContains": "не містить",
                "isKnown": "вказано",
                "isUnknown": "не вказано",
                "greaterThan": "більше ніж",
                "lessThan": "менше ніж"
            },
            "listPlaceholder": "значення, через кому",
            "tooComplex": "Ці фільтри створені в старому редакторі та занадто складні для відображення. Очистіть їх, щоб створити заново.",
            "clearFilters": "Очистити фільтри",
            "deletedSegment": "(видалений сегмент)",
            "incompleteFilter": "Заповніть цей фільтр або видаліть його",
            "eventFields": {
                "provider": "Платіжний сервіс",
                "account": "Платіжний обліковий запис",
                "location": "Локація",
                "amount": "Сума оплати",
                "currency": "Валюта",
                "firstPurchase": "Перша покупка",
                "paymentCount": "Кількість покупок",
                "brand": "Бренд"
            },
            "unavailableOption": "(більше недоступно)",
            "age": "Вік",
            "contactLocation": "Локація контакту"
        },
        "triggers": {
            "contactCreated": "Контакт створено",
            "surveyResponded": "Відповідь на опитування",
            "surveySent": "Опитування надіслано",
            "conversationResolved": "Розмову вирішено",
            "reviewLeft": "Залишено відгук",
            "integrationEvent": "Подія інтеграції",
            "customEvent": "Власна подія",
            "couponRedeemed": "Купон використано",
            "formSubmitted": "Форму надіслано",
            "integrationCoverManager": "Бронювання CoverManager",
            "integrationVtex": "Замовлення VTEX",
            "paymentCompleted": "Оплату завершено",
            "bookingStarted": "Бронювання розпочато",
            "bookingEnded": "Бронювання завершено",
            "addedToSegment": "Додано до сегмента"
        },
        "units": {
            "minutes": "хвилин",
            "hours": "годин",
            "days": "днів"
        },
        "issues": {
            "triggerEvents": "Оберіть принаймні одну подію тригера",
            "channelRequired": "Оберіть канал",
            "channelUnavailable": "Обраний канал відключено або недоступний",
            "messageRequired": "Додайте повідомлення",
            "emailTemplateRequired": "Оберіть email-шаблон",
            "whatsAppTemplateRequired": "Оберіть шаблон WhatsApp",
            "surveyRequired": "Оберіть опитування",
            "couponRequired": "Оберіть купон",
            "waitInvalid": "Вкажіть тривалість очікування",
            "conditionIncomplete": "Заповніть або видаліть незавершені фільтри",
            "segmentMissing": "Фільтр використовує сегмент, якого більше немає",
            "noAction": "Додайте крок повідомлення або опитування, до якого веде тригер",
            "triggerDate": "Оберіть дату, з якої починається ця автоматизація",
            "eventFieldOnDate": "Видаліть фільтри подій: автоматизація, що починається в дату, не має події для фільтрації",
            "triggerSegmentMissing": "Тригер використовує сегмент, якого більше не існує"
        }
    },
    "CampaignsPage": {
        "title": "Управляйте своїми розсилками",
        "subtitle": "Інформуйте своїх клієнтів про важливі новини чи акції за допомогою текстових розсилок",
        "audience": "Сегмент",
        "audienceHint": "Залиште порожнім, щоб охопити всі контакти.",
        "name": "Назва",
        "createTitle": "Створити розсилку",
        "editTitle": "Редагувати розсилку",
        "viewTitle": "Деталі розсилки",
        "contactsNumber": "Вибрано контактів: {{count}}",
        "triggerEvent": "Тригерні події",
        "triggerExplanation": "Виберіть події, які ініціюватимуть вашу кампанію розсилки. Якщо відбудеться кілька подій, затримка буде відраховуватися від останньої події.",
        "surveySent": "Опитування надіслано",
        "status0": "Заплановано",
        "status1": "У процесі",
        "status2": "Завершено",
        "status3": "Скасовано",
        "status5": "Призупинено",
        "warningMessage": "Щоб зменшити ризик блокування в WhatsApp, рекомендується обмежувати розмір маркетингової кампанії до 50 контактів.",
        "addCoverPhoto": "Додати обкладинку",
        "coverPhotoFormat": "Формат: JPG або PNG. Мінімальна ширина: 600 px",
        "imageFormat": "Формат: JPG або PNG.",
        "addCTAButton": "Додати кнопку заклику до дії",
        "buttonTitle": "Назва кнопки",
        "addImage": "Додати зображення"
    },
    "common": {
        "unsavedChangesTitle": "Відхилити незбережені зміни?",
        "unsavedChangesDescription": "У вас є незбережені зміни, які буде втрачено, якщо закрити це вікно.",
        "enabled": "Увімкнено",
        "unknown": "Невідомий користувач",
        "noOptions": "Немає варіантів",
        "noData": "Немає даних",
        "noNotifications": "Немає нових сповіщень",
        "timeframe": "Період",
        "allTime": "Весь час",
        "today": "Сьогодні",
        "previous": "Попередній",
        "next": "Наступний",
        "last7Days": "Останні 7 днів",
        "lastWeek": "Минулий тиждень",
        "last30Days": "Останні 30 днів",
        "last90Days": "Останні 90 днів",
        "thisMonth": "Цей місяць",
        "lastMonth": "Минулий місяць",
        "thisYear": "Цей рік",
        "exportError": "Не вдалося зберегти дані у CSV",
        "zapierIntegration": "Інтеграція з Zapier",
        "clipboardCopied": "Скопійовано в буфер обміну",
        "clipboardFailed": "Помилка під час копіювання",
        "image": "Зображення",
        "imageUploadFormat": "Формати файлів: JPG, PNG. Макс. розмір: {{size}}",
        "images": "Зображення",
        "users": "Користувачі",
        "location": "Локація",
        "locations": "Локації",
        "allLocations": "Всі локації",
        "channel": "Канал",
        "survey": "Опитування",
        "surveys": "Опитування",
        "reviewSites": "Сайти відгуків",
        "rating": "Оцінка",
        "status": "Статус",
        "update": "Оновлення",
        "keywords": "Ключові слова",
        "replyTemplates": "Підключені шаблони",
        "all": "Всі",
        "url": "URL",
        "or": "або",
        "name": "Iм'я",
        "firstName": "Ім'я",
        "lastName": "Прізвище",
        "lastNameOpt": "Прізвище (опціонально)",
        "fullName": "Повне ім'я",
        "phoneNumber": "Телефон",
        "email": "Email",
        "emailAddress": "Електронна пошта",
        "login": "Логін",
        "password": "Пароль",
        "outOf": "{{total}} із доступних {{max}}",
        "saving": "Збереження...",
        "edit": "Редагувати",
        "delete": "Видалити",
        "view": "Переглянути",
        "duplicate": "Копіювати",
        "deleteTitle": "Підтвердження видалення",
        "deleteDescription": "Ви впевнені, що хочете видалити це? Цю дію не можна скасувати.",
        "delay": "Затримка",
        "refresh": "Оновити",
        "contactCreated": "Контакт створено",
        "liveChat": "Live-чат",
        "left": "Ліворуч",
        "right": "Праворуч",
        "file": "Файл",
        "audio": "Аудіо",
        "video": "Відео",
        "monday": "Понеділок",
        "tuesday": "Вівторок",
        "wednesday": "Середа",
        "thursday": "Четвер",
        "friday": "П'ятниця",
        "saturday": "Субота",
        "sunday": "Неділя",
        "open": "Відкрито",
        "closed": "Закрито",
        "24hours": "24 години",
        "story": "Історія",
        "user": "Користувач",
        "new_other": "Нові",
        "new_one": "Нове",
        "unassigned": "Непризначені",
        "title": "Назва",
        "scheduledTime": "Запланований час",
        "scheduled": "Заплановано",
        "published": "Опубліковано",
        "unpublished": "Неопубліковано",
        "publishing": "Публікація",
        "cancelled": "Скасовано",
        "deleted": "Видалено",
        "description": "Опис",
        "completed": "Завершено",
        "cancel": "Скасувати",
        "subscriptionExpiredMsg": "Виникла проблема з вашою підпискою. Перевірте свої платіжні дані або зв'яжіться зі службою підтримки.",
        "upgradeToAdd": "Змініть тариф щоб додати більше",
        "planCancelledUntilPeriodEnd": "Вашу підписку скасовано, вона діє до кінця оплаченого періоду. Зверніться до підтримки, щоб її поновити.",
        "upgradeAskAdmin": "Попросіть адміністратора акаунту оновити тарифний план.",
        "upgradeToUnlock": "Змініть тариф щоб відкрити цю функцію",
        "sms": "SMS",
        "whatsApp": "WhatsApp",
        "liveChatLowercase": "live-чат",
        "facebookMessenger": "Facebook Messenger",
        "instagram": "Instagram",
        "templates": "Шаблони",
        "industry": "Індустрія",
        "impressions": "Враження",
        "reach": "Охоплення",
        "engagement": "Залучення",
        "learnMore": "Дізнатися більше",
        "number": "Номер",
        "text": "Текст",
        "date": "Дата",
        "required": "Обов'язкове",
        "type": "Тип",
        "templateName": "Назва шаблону",
        "author": "Автор",
        "yes": "Так",
        "no": "Ні",
        "labels": "Сегмент",
        "locationLabels": "Групи локацій",
        "logo": "Логотип",
        "low": "Низька",
        "medium": "Середня",
        "high": "Висока",
        "critical": "Критична",
        "average": "Середня",
        "good": "Добра",
        "excellent": "Відмінна",
        "conversations": "Розмови",
        "platform": "Платформа",
        "actionRequired": "Очікує дії",
        "conflict": "Конфлікт",
        "conflicts": "Конфлікти",
        "conflict_one": "Конфлікт",
        "conflict_few": "Конфлікти",
        "conflict_many": "Конфліктів",
        "conflict_other": "Конфліктів",
        "notFound": "Не знайдено",
        "notVerified": "Не верифіковано",
        "disconnected": "Відключено",
        "notPublished": "Не опубліковано",
        "inProgress": "У роботі",
        "synced": "Синхронізовано",
        "syncedWithConflicts": "Синхронізовано з конфліктами",
        "na": "Немає",
        "latitude": "Широта",
        "longitude": "Довгота",
        "none": "Немає",
        "reported": "Оскаржено",
        "report": "Оскаржити",
        "format": "Формат",
        "photo": "Фото",
        "customer": "Клієнт",
        "business": "Бізнес",
        "category_other": "Категорії",
        "category_one": "Категорія",
        "action": "Дії",
        "day": "День",
        "week": "Тиждень",
        "month": "Місяць",
        "year": "Рік",
        "draft": "Чернетка",
        "top": "Топ",
        "bottom": "Останні",
        "notifications": "Cповіщення",
        "complaint_other": "Скарг(и)",
        "complaint_one": "Скарга",
        "review_other": "Відгуків(и)",
        "review_one": "Відгук",
        "location_other": "Локацій(ї)",
        "location_one": "Локація",
        "profile_other": "Профілів(і)",
        "profile_one": "Профіль",
        "message_other": "Повідомлень(я)",
        "message_one": "Повідомлення",
        "subject": "Тема",
        "cc": "Копія",
        "bcc": "Прихована копія",
        "link": "Посилання",
        "microsite": "Мікросайт",
        "color_one": "Колір",
        "color_other": "Кольори",
        "archived": "Архівовано",
        "assignedTo": "Відповідальний",
        "question": "Питання",
        "answer": "Відповідь",
        "copy": "Копія",
        "brands": "Бренди",
        "brand": "Бренд",
        "failed": "Помилка",
        "actions": "Обрати дію",
        "questions": "Запитання",
        "language": "Мова",
        "localization": "Локалізація",
        "disabled": "Вимкнено",
        "active": "Увімкнено",
        "day(s)": "дня(ів)",
        "hour(s)": "години(ин)",
        "minute(s)": "хвилини(ин)",
        "appearance": "Зовнішній вигляд",
        "settings": "Налаштування",
        "style": "Стиль",
        "font": "Шрифт",
        "button_one": "Кнопка",
        "button_other": "Кнопки",
        "background": "Фон",
        "customEvent": "Зовнішня подія",
        "unverified": "Неперевірений",
        "verify": "Перевірити",
        "noFileSelected": "Немає вибраного файлу",
        "chat": "Чат",
        "customInstructionsOpt": "Індивідуальні інструкції (опціонально)",
        "activity": "Активність",
        "information": "Інформація",
        "newMessage": "Новe повідомлення",
        "frequency": "Частота",
        "currency": "Валюта",
        "coupon": "Купон",
        "service": "Послуга",
        "paymentMethods": "Методи оплати",
        "externalId": "Зовнішній ID",
        "public": "Публічний",
        "publicLink": "Публічне посилання",
        "private": "Приватний",
        "sharedTemplate": "Спільний шаблон",
        "template": "Шаблон",
        "teams": "Команди",
        "createdOn": "Створено",
        "platforms": "Платформи",
        "emoji": "Емодзі",
        "attachFile": "Прикріпити файл",
        "menu": "Меню",
        "form": "Форма",
        "team": "Команда",
        "recoveryForm": "Форма відновлення",
        "removedPersonName": "{{name}} (видалено)",
        "notSpecified": "Не вказано",
        "timesInZone": "Час у часовому поясі {{timeZone}}."
    },
    "ContactsPage": {
        "createdOn": "Створено",
        "deleteContactsDescription": "Ви впевнені, що хочете беззворотньо видалити {{selectedContacts}} контактів?",
        "facebookProfile": "Профіль Facebook",
        "instagramProfile": "Профіль Instagram",
        "createTitle": "Створити контакт",
        "createSubtitle": "Додайте основні відомості про контакт",
        "editTitle": "Редагувати",
        "editContactsTitle": "Редагувати контакти",
        "editBulkContactsSubtitle": "Виберіть поля для редагування. Зміни буде застосовано до всіх вибраних контактів.",
        "editSubtitle": "Змінити основні відомості про контакт",
        "mergeContactsTitle": "Об'єднати контакти",
        "mergeContactsSubtitle": "Усуньте дублікати, об'єднавши два профілі в один, разом з їх атрибутами та активністю. У разі конфлікту атрибути основного контакту матимуть перевагу.",
        "mergeContactPrimary": "Основний контакт (буде збережено)",
        "mergeContactSecondary": "Контакт для об'єднання (буде видалено)",
        "unsubscribe": "Відписатись",
        "unsubscribed": "Відписався",
        "lastActiveOn": "Востаннє активний",
        "importTitle": "Імпорт нових контактів",
        "importSubtitle": "Імпорт контактів зі CSV файлу.",
        "importConsent": "Я підтверджую, що ці контакти погодилися отримувати повідомлення від мого бізнесу, а список не було куплено, орендовано чи отримано від третіх осіб.",
        "bulkFileLink": "Завантажте приклад CSV.",
        "csvFile": "CSV файл",
        "importFile": "Імпортувати",
        "id": "ID",
        "dataVerificationDescription": "Перевірте дані з файлу CSV. Щоб вони були імпортовані, вони не повинні містити жодних помилок.\n Якщо ви знайшли помилку, закрийте це вікно, виправте помилку та повторно завантажте файл.",
        "validate": "Перевірити",
        "numberToImport": "Буде додано: {{diff}}. Буде оновлено: {{duplicates}}",
        "contactsToAdd": "Контактів для додавання",
        "contactsToUpdate": "Контактів для оновлення",
        "noContacts": "Нові контакти не знайдено",
        "search": "Пошук",
        "searchLabel": "Пошук за ім'ям, телефоном або поштою",
        "activitySurveySent": "Опитування надіслано: {{template}}",
        "activityFormSubmitted": "Надіслано форму {{name}}",
        "activitySurveyReminder": "Нагадування про опитування надіслано: {{template}}",
        "activitySurveyResponded": "Залишив на {{template}} {{rating}} зірок",
        "activityMessageSent": "Повідомлення надіслано через {{channel}}",
        "activityConversationStarted": "Розмова почалася",
        "activityConversationClosed": "Розмова вирішена {{name}}",
        "activityConversationReopened": "Розмова відкрита {{name}}",
        "activityReviewLeft": "Залишив відгук у {{reviewType}}",
        "activityIntegrationEvent": "Подія від {{integration}}",
        "contacts": "контакти",
        "contactsSelected": "Вибрано {{selectedContacts}} контактів",
        "mergeSuccess": "Контакти успішно об'єднано",
        "mergeFail": "Не вдалося об'єднати контакти",
        "activityPaymentCompleted": "Оплату завершено",
        "paymentDetails": {
            "amount": "Сума",
            "location": "Локація",
            "paidAt": "Оплачено",
            "method": "Спосіб оплати",
            "account": "Платіжний обліковий запис",
            "purchase": "Покупка",
            "firstPurchase": "Перша",
            "purchaseNumber": "№ {{count}}",
            "viewReceipt": "Переглянути чек",
            "sources": {
                "CARD": "Картка",
                "BANK_ACCOUNT": "Банківський рахунок",
                "WALLET": "Цифровий гаманець",
                "BUY_NOW_PAY_LATER": "Купуй зараз, плати потім",
                "SQUARE_ACCOUNT": "Баланс Square",
                "CASH": "Готівка",
                "EXTERNAL": "Інше"
            }
        },
        "sex": "Стать",
        "sexFemale": "Жінка",
        "sexMale": "Чоловік",
        "dateOfBirth": "Дата народження",
        "language": "Мова",
        "dateOfBirthWithoutYear": "Збережено як {{date}}, без року",
        "leaveUnchanged": "Залишити без змін",
        "activityAddedToSegment": "Додано до сегмента {{name}}"
    },
    "ErrorsPages": {
        "titleSomethingWrong": "Не вдалося завантажити сторінку",
        "textSomethingWrong": "Нам відомо про цю проблему і наша команда вже намагається вирішити її. Якщо проблема не вирішена, зверніться до нашої технічної підтримки за адресою help@pluspoint.io.",
        "notFoundPage": "Нам не вдалося знайти сторінку, яку ви шукаєте"
    },
    "FeedbackResponses": {
        "newReviews": "Доступні нові відгуки. <0>{{update}}</0>",
        "update": "ОНОВИТИ",
        "noDataMessage": "Немає даних",
        "onlyRating": "Клієнт не написав коментарій, а залишив лише оцінку.",
        "aiReviewTags": "Найбільше сподобалося",
        "contactDetailsOnly": "Клієнт залишив контактні дані без повідомлення.",
        "copyNumber": "Скопіювати номер",
        "callNumber": "Зателефонувати",
        "chatViber": "Зв'язатися через Viber",
        "chatWhatsApp": "Зв'язатися через WhatsApp",
        "copyEmail": "Скопіювати",
        "chatEmail": "Зв'язатися з автором",
        "ticketStatus": "Статус задачі",
        "completed": "Завершено",
        "viaCoverManager": "CoverManager",
        "hideAnonimous": "Приховати анонімні відповіді",
        "linkedReview": "Пов'язаний відгук"
    },
    "FeedbackSurveys": {
        "created": "Опитувань створено:",
        "createdQrOnly": "QR-кодів створено:",
        "title": "Налаштування опитувань",
        "subtitle": "Налаштовуйте опитування, щоб отримати цінні поради від клієнтів, краще розуміти їхні потреби та вживати заходів, щоб клієнти залишалися лояльними та рекомендували ваш бізнес іншим",
        "titleQrOnly": "Збирайте відгуки розумніше",
        "subtitleQrOnly": "Перейдіть на Pluspoint Professional, щоб отримувати більше користі від збору відгуків. Надсилайте опитування email, SMS або WhatsApp, заохочуйте задоволених клієнтів залишати публічні відгуки, збирайте приватний фідбек і відстежуйте динаміку NPS.",
        "responses": "Відповідей:",
        "views": "Перегляди:",
        "modalTitle": "Редагувати опитування — {{surveyName}}",
        "surveyName": "Назва опитування",
        "contactDetails": "Дані контакта",
        "contactEmail": "Контактний email",
        "contactPhone": "Контактний телефон",
        "contactName": "Ім'я контакту",
        "contactFormPlacement": "Показувати контактну форму на",
        "contactFormMainScreen": "Головному екрані",
        "contactFormMainScreenDescription": "Контактну форму бачать усі, хто ставить оцінку.",
        "contactFormNegativeScreen": "Негативному екрані",
        "contactFormNegativeScreenDescription": "Контактну форму бачать лише ті, чия оцінка нижча за поріг.",
        "contactFormNoFields": "Увімкніть хоча б одне поле нижче, щоб показувати контактну форму.",
        "addField": "Додати поле",
        "deleteField": "Видалити поле",
        "reviewSites": "Сайти відгуків",
        "fillColor": "Основний",
        "topText": "Верхній текст",
        "bottomText": "Нижній текст",
        "messageTemplate": "Шаблон повідомлення",
        "emailSubject": "Тема листа",
        "protectionLabel": "Необхідний час між опитуваннями",
        "protectionTooltip": "Вкажіть протягом якого часу система не повинна надсилати опитування тому самому контакту.",
        "day": "1 день",
        "days3": "3 дні",
        "week": "1 тиждень",
        "weeks2": "2 тиждня",
        "month": "1 місяць",
        "months3": "3 місяці",
        "months6": "6 місяців",
        "year": "1 рік",
        "followUpLabel": "Нагадування пройти опитування",
        "followUpDescription": "Автоматичне нагадування про опитування, якщо відповідь не надана протягом заданого проміжку часу",
        "wait": "Зачекати",
        "days": "днів, потім надіслати",
        "followUpMessage": "Шаблон нагадування",
        "main": "Головна",
        "positive": "Позитивне",
        "negative": "Негативне",
        "neutral": "Нейтральне",
        "tabSettings": "Налаштування",
        "tabSharing": "Поширення",
        "qrCode": "QR код",
        "enableSendSurveys": "Увімкнути надсилання опитувань",
        "enableSendSurveysDescription": "Дозволити надсилання цього опитування клієнтам через кампанії, вхідні та функцію Надіслати опитування",
        "customizeQrCodeDesign": "Налаштуйте вигляд QR",
        "surveyQuestions": "Персоналізовані запитання",
        "addQuestion": "Додати запитання",
        "questionsDescription": "Створюйте персоналізовані запитання для опитування, щоб краще зрозуміти потреби клієнтів.",
        "brandSettings": "Налаштуваннях бренду",
        "changeAppearance": "Ви можете змінити вигляд у <0>{{brandSettings}}</0>.",
        "addFirstQuestion": "Додайте запитання, щоб увімкнути попередній перегляд.",
        "page": "Сторінка",
        "addPage": "Додати сторінку",
        "emptyPageHint": "Перетягніть запитання сюди",
        "nps": "Увімкнути оцінювання задоволеності (NPS)",
        "customerSatisfaction": "Запитувати оцінку",
        "ratingScale": "Шкала оцінювання:",
        "fiveStar": "1–5 Зірок",
        "npsScale": "0–10 Балів",
        "enableNpsToAddQuestions": "Увімкніть оцінювання задоволеності в Налаштуваннях, щоб додати запитання",
        "sendableSurveyRequired": "Потрібне опитування з увімкненим надсиланням опитувань",
        "satisfactionSurveyThreshold": "Перехоплювати негативні коментарі, якщо оцінка менше ніж:",
        "labelsTitle": "Сегменти",
        "labelsSubtitle": "Призначити сегменти контактам, зібраним через це опитування",
        "typeRating": "Оцінка",
        "typeSingleChoice": "Один варіант",
        "typeYesNo": "Так / Ні",
        "typeMultiSelect": "Кілька варіантів",
        "typeShortAnswer": "Коротка відповідь",
        "typeParagraph": "Довгий текст",
        "typeDate": "Дата",
        "questionType": "Question type",
        "addOption": "Add option",
        "optionLabel": "Option",
        "gateQuestion": "Питання-фільтр",
        "gateQuestionTooltip": "Пропустити решту питань, якщо обрано «Ні».",
        "gateRequiresTooltip": "Недоступно, коли увімкнено питання-фільтр.",
        "showConditionally": "Показувати залежно від попередньої відповіді",
        "showConditionallyTooltip": "Показувати це питання лише коли на попередні питання дано конкретні відповіді. Кілька правил працюють за логікою І (всі мають збігатися).",
        "conditionShowIf": "Показати це питання лише якщо",
        "conditionAndIf": "ТА якщо",
        "conditionMatches": "дорівнює",
        "addCondition": "Додати умову",
        "star": "зірка",
        "stars": "зірок",
        "yes": "Так",
        "no": "Ні",
        "other": "Інше",
        "includeOtherOption": "Додати варіант \"Інше\"",
        "customWording": "Власний текст опитування",
        "aiReviewSuggestions": "Підказки відгуків від ШІ",
        "aiReviewSuggestionsTooltip": "Відвідувачі, які високо вас оцінили, обирають, що їм сподобалося, а Pulse AI пише короткий відгук, який вони можуть скопіювати в Google та на інші сайти відгуків.",
        "aiReviewTags": "Теги, які можуть обрати відвідувачі",
        "addReviewTag": "Додати тег",
        "reviewTagNamePlaceholder": "Назва тегу",
        "createReviewTag": "Створити",
        "editReviewTagTitle": "Редагувати тег",
        "deleteReviewTagTitle": "Видалити тег?",
        "deleteReviewTagDescription": "«{{name}}» буде видалено для всього акаунта та прибрано з усіх опитувань.",
        "useCustomWording": "Використовувати власний текст",
        "customWordingTooltip": "Додайте власний текст для кожної мови, якою має бути доступне опитування. Мова з’явиться в опитуванні лише якщо для неї вказано текст.",
        "positiveMessage": "Позитивне повідомлення",
        "negativeMessage": "Негативне повідомлення",
        "localizationSingleLanguage": "Додайте мови в розділі «Власний текст опитування» в Налаштуваннях, щоб перекладати запитання"
    },
    "filters": {
        "labels": "Групи локацій",
        "companies": "Компанії",
        "locations": "Компанії",
        "surveys": "Опитування",
        "integrations": "Сайти відгуків",
        "channels": "Канали",
        "platforms": "Платформи",
        "timeframe": "Період",
        "rating": "Оцінка",
        "statuses": "Статус",
        "views": "Статус",
        "hideAnonimous": "Увімкніть, щоб бачити лише відповіді з контактною інформацією",
        "keywords": "Ключові слова",
        "withoutReplies": "Відгуки без відповідей",
        "onlyFeatured": "Вибрані відгуки",
        "formats": "Формат",
        "categories": "Категорії",
        "authors": "Автор",
        "contactLabels": "Сегмент",
        "grouping": "Групувати за",
        "brands": "Бренди",
        "showUnreadOnly": "Показати лише непрочитані розмови",
        "sorting": "Сортувати за",
        "teams": "Команди",
        "sexes": "Стать",
        "languages": "Мова",
        "birthMonths": "Місяць народження",
        "ageBracket": "Вік",
        "anyAge": "Будь-який вік"
    },
    "ForgotPasswordPage": {
        "title": "Забули пароль?",
        "description": "Введіть вашу електронну адресу. Ми надішлемо посилання для встановлення нового паролю.",
        "backToLogin": "Повернутися на сторінку Входу",
        "confirmationSuccess": "Якщо цей профіль існує в Pluspoint, ви отримаєте листа на вашу email скриньку з інструкціями"
    },
    "Header": {
        "home": "Головна",
        "reviewsOverview": "Перегляд",
        "templates": "Шаблони",
        "responses": "Усі відповіді",
        "surveys": "Опитування",
        "reviewsManage": "Усі відгуки",
        "reviewsTemplates": "Шаблони відповідей",
        "reviewsAutoreplies": "Автовідповіді",
        "reviewsAutomation": "Автоматизація",
        "messagingInbox": "Вхідні",
        "messagingTemplates": "Шаблони повідомлень",
        "microsites": "Мікросайти",
        "menus": "Меню",
        "forms": "Форми",
        "analytics": "Аналітика",
        "analyticsConversion": "Конверсія",
        "analyticsReviews": "Відгуки",
        "analyticsSurveys": "Опитування",
        "analyticsConversations": "Розмови",
        "analyticsPresence": "Присутність",
        "settings": "Налаштування",
        "onboarding": "Попереднє налаштування",
        "reviewsWidgets": "Віджети для вебсайта",
        "socialPosts": "Публікації",
        "keywords": "Ключові слова та оцінка",
        "ordersIfood": "Замовлення",
        "campaigns": "Розсилки",
        "campaignsAutomated": "Автоматизовані",
        "campaignsOneTime": "Одноразові",
        "contacts": "Контакти",
        "presence": "Присутність",
        "presenceProfiles": "Профілі",
        "presenceMedia": "Фото та відео",
        "locationsManage": "Керувати локаціями",
        "locationsProfiles": "Профілі",
        "locationsMedia": "Фото та Відео",
        "visibilityScanner": "Сканер видимості",
        "locationsAnalytics": "Аналітика Локацій",
        "login": "Увійти",
        "signup": "Зареєструватися",
        "resetPassword": "Змінити пароль",
        "forgotPassword": "Забули пароль?",
        "verifyEmail": "",
        "acceptInvitation": "Прийняти запрошення",
        "error": "Помилка",
        "pulseAI": "Pulse AI",
        "coupons": "Купони",
        "campaignsLibrary": "Бібліотека"
    },
    "HomePage": {
        "leaderboard": "Рейтинг локацій",
        "5LocationsBy": "5 локацій за",
        "rating": "оцінками",
        "reviews": "відгуками",
        "nps": "NPS",
        "inbox": "Вхідні",
        "surveys": "Відповіді на опитування",
        "recommendations": "Рекомендації",
        "presence": "Присутність онлайн",
        "locations": "Присутність онлайн",
        "synchronization": "Синхронізація профілів",
        "optimizationScoreSubtitle": "Знайдіть локації з неповними профілями, щоб підвищити видимість і довіру клієнтів",
        "locationsSubtitle": "Дізнайтеся, як клієнти знаходять ваші локації та взаємодіють з ними у мережі",
        "synchronizationSubtitle": "Зберігайте дані бізнесу узгодженими скрізь, де вас шукають клієнти",
        "leaderboardSubtitle": "Дізнайтеся, які локації лідирують, а яким потрібна підтримка для покращення показників",
        "inboxSubtitle": "Відповідайте на повідомлення клієнтів з усіх каналів в одному місці",
        "reviewsSubtitle": "Слідкуйте за новими відгуками та покращуйте репутацію, швидко відповідаючи",
        "surveysSubtitle": "Збирайте відгуки, щоб вчасно виявляти скарги та покращувати досвід клієнтів",
        "socialSubtitle": "Залучайте аудиторію постійними публікаціями та відстежуйте, що доходить до клієнтів",
        "surveysTitle": "Керувати відгуками та скаргами клієнтів",
        "unreplied": "Без відповідей",
        "vsPrevMonth": "<0>{{percentage}}</0> порівняно з минулим місяцем",
        "getStarted": "Розпочніть з {{steps}} простих кроків",
        "continueOnboarding": "Продовжуйте налаштування",
        "googleTitle": "Інтеграція з Google My Business (5 хв)",
        "googleDescription": "Відповідайте на відгуки клієнтів та тримайте вашу публічну інформацію актуальною.",
        "brandTitle": "Створити бренд (5 хв)",
        "brandDescription": "Об’єднайте локації для зручного керування та налаштуйте їхній вигляд на платформі.",
        "channelsTitle": "Налаштування каналів зв'язку (20 хв)",
        "channelsDescription": "Відповідайте на повідомлення клієнтів у різних месенджерах в одному вікні.",
        "templatesTitle": "Створення шаблонів опитувань (10 хв)",
        "templatesDescription": "Збирайте зворотний зв'язок та отримуйте більше позитивних відгуків завдяки опитуванням.",
        "qrCodesTitle": "Створіть QR-коди для відгуків (5 хв)",
        "qrCodesDescription": "Згенеруйте QR-коди для чеків, столів або вітрин, щоб клієнти могли одразу залишити відгук.",
        "autoRepliesTitle": "Налаштування автовідповідей на відгуки (10 хв)",
        "autoRepliesDescription": "Автоматизуйте персоналізовані відповіді на відгуки для підвищення задоволеності клієнтів.",
        "usersTitle": "Запрошення інших користувачів (5 хв)",
        "usersDescription": "Розширте можливості вашої команди, запрошуючи колег на платформу.",
        "recommendation1Title": "Залиште відповіді на відгуки",
        "recommendation1Subtitle": "Є відгуки без відповіді.",
        "recommendation1Text": "Заохочуючи клієнтів залишати позитивні відгуки та відповідаючи на них, ви підвищуєте рейтинг локацій.",
        "recommendation1UrlText": "Перейти до відгуків",
        "recommendation2Title": "Оновіть фотографії у профілях",
        "recommendation2Subtitle": "Фотографії в галереї не оновлювалися більше місяця.",
        "recommendation2Text": "Актуальні фотографії допоможуть покращити вашу онлайн присутність.",
        "recommendation2UrlText": "Перейти до фотографій",
        "recommendation3Title": "Додайте описи до локацій",
        "recommendation3Subtitle": "У вас є локації без описів.",
        "recommendation3Text": "Заповнений опис локації покращує позиції вашого профілю в пошуковій видачі.",
        "recommendation3UrlText": "Перейти до налаштувань",
        "recommendationLocationsUrlText": "Перейти до локацій",
        "recommendation4Title": "Розв'яжіть конфлікти та опублікуйте відсутні профілі",
        "recommendation4Subtitle": "Деякі профілі потребують вашої уваги.",
        "recommendation4Text": "Розв'яжіть конфлікти, щоб дані залишались узгодженими, та опублікуйте профілі, яких ще немає онлайн, щоб клієнти могли вас знайти.",
        "recommendation4UrlText": "Перейти до профілів",
        "recommendation5Title": "Дайте відповідь на повідомлення",
        "recommendation5Subtitle": "У вас є непрочитані повідомлення, які потребують вашої уваги.",
        "recommendation5Text": "Швидка відповідь підвищує задоволеність ваших клієнтів.",
        "recommendation5UrlText": "Перейти до вхідних",
        "recommendation6Title": "Опублікуйте соціальний пост",
        "recommendation6Subtitle": "Деякі профілі давно не мали нових постів.",
        "recommendation6Text": "Регулярні соціальні публікації підтримують залучення вашої аудиторії та покращують вашу онлайн-присутність.",
        "recommendation6UrlText": "Перейти до публікацій",
        "recommendation7Title": "Перегляньте недавні скарги",
        "recommendation7Subtitle": "Є нові скарги від ваших клієнтів.",
        "recommendation7Text": "Швидке вирішення скарг допомагає покращити задоволеність клієнтів та довіру до вашої компанії.",
        "recommendation7UrlText": "Перейти до скарг",
        "recommendation8Title": "Інтеграцію відключено",
        "recommendation8Text": "Інтеграція між платформою відгуків і Pluspoint наразі відключена. Будь ласка, підключіть її знову, щоб продовжити використання інтеграції.",
        "recommendation9Title": "Канал відключено",
        "recommendation9Text": "Канал зв’язку наразі відключено. Підключіть його знову, щоб забезпечити безперервну доставку повідомлень клієнтам.",
        "recommendation10Title": "Автоматизовану розсилку не виконано",
        "recommendation10Text": "Автоматизовану розсилку не вдалося виконати. Перевірте налаштування автоматизації.",
        "recommendation10UrlText": "Перейти до розсилок",
        "recommendation11Title": "Одноразову розсилку не виконано",
        "recommendation11Text": "Вашу одноразову розсилку не було надіслано. Перевірте деталі розсилки та спробуйте ще раз.",
        "showAllRecommendation": "Показати всі рекомендації",
        "showLessRecommendation": "Не показувати приховані рекомендації"
    },
    "IfoodOrders": {
        "accountId": "ID запису",
        "createdAt": "Дата створення",
        "customerName": "Клієнт",
        "customerPhoneNumber": "Телефон клієнта",
        "merchant": "Торговець",
        "orderId": "ID замовлення",
        "orderType": "Тип замовлення",
        "paymentInformation": "Інформація про оплату",
        "expireAt": "дата закінчення:"
    },
    "Listings": {
        "modalTitleGoogle": "Керування профілем Google My Business",
        "modalTitleFacebook": "Керування профілем Facebook",
        "about": "Загальні відомості",
        "name": "Назва",
        "openingDate": "Дата відкриття",
        "contact": "Контактні дані",
        "primaryPhone": "Основний телефон",
        "additionalPhone": "Додатковий телефон",
        "website": "Веб-сайт",
        "businessHours": "Графік",
        "categories": "Категорії",
        "primaryCategory": "Основна категорія",
        "secondaryCategory_one": "Додаткова категорія",
        "secondaryCategory_other": "Додаткові категорії",
        "enableProfileSync": "Увімкнути синхронізацію профілю",
        "disableProfileSync": "Вимкнути синхронізацію профілю",
        "connectMainPage": "Підключити головну сторінку",
        "storeLocation": "Магазин",
        "connectStoreLocation": "Підключити магазин",
        "ignoredFields": "Ігноровані поля",
        "ignoredFieldsHint": "Pluspoint не надсилає ці поля до цього профілю та не повідомляє про розбіжності в них.",
        "currentlyDifferent": "зараз відрізняється"
    },
    "LoginPage": {
        "title": "З поверненням!",
        "description": "Керуйте локаціями, відгуками та повідомленнями в одному кабінеті.",
        "forgotPassword": "Забули пароль?",
        "notRegistered": "Ще не зареєстровані? <0>{{link}}</0>",
        "signUp": "Зареєструватися",
        "terms": "Умовами використання,",
        "privacy": "Політикою конфіденційності",
        "dpa": "Угодою про обробку даних",
        "signinWithGoogle": "Увійти з Google",
        "termsConditions": "Використовуючи Pluspoint, ви погоджуєтеся з <0>{{terms}}</0> <1>{{privacy}}</1> та <2>{{dpa}}</2>",
        "googleUserNotFound": "Акаунт з цією електронною поштою не знайдено. <0>{{link}}</0>, щоб почати."
    },
    "LogoutModal": {
        "logOutConfirmation": "Вийти з Pluspoint?",
        "logOutConfirmationDescription": "Вас буде повернено на екран входу"
    },
    "DnsRecordCard": {
        "type": "Тип:",
        "name": "Назва:",
        "value": "Значення:",
        "status": "Статус:",
        "notChecked": "Не перевіряється"
    },
    "MicrositesPage": {
        "createCustomLending": "Налаштовуйте персональні посадкові сторінки для кожної локації",
        "createCustomLendingSubTitle": "Створюйте мобільні посадкові сторінки для кожної локації, щоб надавати клієнтам персональну інформацію, як-от контакти, список послуг, бронювання та посилання на соціальні мережі.",
        "created": "Мікросайтів створено:",
        "content": "Контент",
        "modalTitle": "Редагувати мікросайт",
        "codeName": "Назва мікросайту",
        "displaySocialMediaLinks": "Показувати соціальні мережі",
        "showReviews": "Показувати відгуки і рейтинги",
        "links": "Посилання, опитування і форми",
        "linksSubtitle": "Створіть мікросайт, додавши посилання, опитування та форми",
        "visits": "Відвідувань:",
        "additionalSettings": "Додаткові налаштування",
        "showLiveChat": "Показувати live-chat",
        "surveyNotAvailableForBrand": "Опитування не підтримуються для брендів. Видаліть це посилання.",
        "micrositeNotAvailableForLocation": "Посилання на мікросайти не підтримуються для локацій. Видаліть це посилання.",
        "surveyNotAvailableForLocation": "Опитування недоступне для цієї локації. Оберіть інше або видаліть.",
        "micrositeNotAvailableForBrand": "Мікросайт недоступний для цього бренду. Оберіть інший або видаліть.",
        "customDomain": "Власний домен",
        "customDomainCaption": "Публікуйте цей мікросайт на власному домені замість plsp.io",
        "useCustomDomain": "Використовувати власний домен",
        "domain": "Домен",
        "statusPending": "Очікує",
        "statusActive": "Активний",
        "statusFailed": "Помилка",
        "noDomainsInAccount": "Немає доменів у вашому обліковому записі",
        "noDomainsAvailable": "Немає доступних доменів. Зверніться до адміністратора, щоб додати власний домен.",
        "addNewDomain": "Додати новий домен",
        "addCustomDomain": "Додати власний домен",
        "enterDomainDescription": "Введіть домен, який ви хочете використовувати для своїх мікросайтів.",
        "domainOwnershipNote": "Домен повинен бути вашим. Для верифікації потрібно додати CNAME-запис. Для використання кореневого домену ваш DNS-провайдер повинен підтримувати CNAME flattening.",
        "dnsInstructions": "Додайте цей CNAME-запис у вашого провайдера домену, щоб спрямувати домен на Pluspoint.",
        "domainRequired": "Домен є обов'язковим",
        "domainLengthError": "Домен повинен бути від 4 до 253 символів",
        "domainInvalidFormat": "Введіть дійсний домен",
        "domainPluspoint": "Домени Pluspoint не можна використовувати як власні домени",
        "addDomain": "Додати домен",
        "editDomain": "Редагувати домен — {{hostname}}",
        "status": "Статус:",
        "lastChecked": "Остання перевірка:",
        "micrositesUsingDomain": "Мікросайтів на цьому домені:",
        "checkStatus": "Перевірити статус",
        "checking": "Перевірка...",
        "checkStatusError": "Не вдалося перевірити статус домену. Спробуйте ще раз.",
        "deleteCustomDomain": "Видалити власний домен",
        "deleteConfirm": "Назавжди видалити {{hostname}}?",
        "deleteImpact": "Цей домен використовується {{count}} мікросайтом(ами). Вони втратять свою URL-адресу і будуть доступні лише через plsp.io.",
        "deleteWarning": "Цю дію неможливо скасувати. Щоб використовувати домен знову, його потрібно буде додати і верифікувати повторно.",
        "domainDeleted": "Власний домен видалено",
        "deleteError": "Не вдалося видалити домен",
        "addDomainError": "Не вдалося зареєструвати домен. Спробуйте пізніше.",
        "loadError": "Не вдалося завантажити власні домени",
        "menuNotAvailable": "Меню недоступне для цього мікросайту. Оберіть інше або видаліть.",
        "formNotAvailable": "Форма недоступна для цього мікросайту. Оберіть іншу або видаліть.",
        "menuNotAvailableForBrand": "Меню недоступні на брендових мікросайтах. Видаліть це посилання."
    },
    "ContactFieldsSettings": {
        "identifyingFieldRequired": "Телефон або email мають залишатися обов'язковими"
    },
    "FormsPage": {
        "title": "Перетворюйте візити на тривалі відносини",
        "subtitle": "Збирайте дані клієнтів за допомогою налаштовуваних форм і використовуйте їх для створення списків контактів, сегментації аудиторій та запуску таргетованих кампаній.",
        "created": "Створено форм:",
        "createForm": "Створити форму",
        "modalTitle": "Форма",
        "internalName": "Назва форми",
        "downloadSubmissions": "Завантажити відповіді",
        "confirmationMessage": "Повідомлення після надсилання",
        "defaultConfirmationMessage": "Дякуємо за надсилання форми",
        "views": "Перегляди:",
        "submissions": "Надсилання:",
        "contactFields": "Контактні поля",
        "contactFieldsSubtitle": "Оберіть, які дані запитує форма та які з них обов'язкові.",
        "deleteForm": "Видалити форму"
    },
    "LocalizeItemModal": {
        "defaultLanguages": "Основна мова",
        "additionalLanguages": "Додаткова мова"
    },
    "multiSelectLabels": {
        "done": "Закінчити",
        "manage": "Керувати",
        "createNewLabel": "Створити новий сегмент",
        "searchLabel": "Знайти або створити сегмент"
    },
    "GoogleLocationsList": {
        "searchLabel": "Пошук",
        "hideConnected": "Приховати вже підключені",
        "hideUnverified": "Приховати неперевірені",
        "noMatches": "Немає відповідних локацій",
        "allConnected": "Усі локації вже підключені"
    },
    "OnboardingPage": {
        "titleFirst": "Вітаємо у Pluspoint!",
        "subtitleFirst": "Почнімо з основної інформації, щоб налаштувати ваш робочий простір і персоналізувати досвід у Pluspoint.",
        "titleSecond": "Підключити Google",
        "subtitleSecond": "Зв’яжіть свій профіль Google Business, щоб імпортувати та керувати локаціями в Pluspoint. Обов’язково надайте всі дозволи — це забезпечить коректну синхронізацію локацій і дасть змогу керувати відгуками від вашого імені.",
        "buttonConnectWithGoogle": "Підключити Google",
        "titleGoogleEmpty": "Локація не знайдена",
        "subtitleGoogleEmpty": "Ми не знайшли жодної локації Google Business, пов’язаної з цим акаунтом. Підключіть інший Google-акаунт або переконайтеся, що під час авторизації були надані всі дозволи.",
        "titleManual": "Додайте свою першу локацію",
        "subtitleManual": "Введіть назву та адресу вашої локації. Пізніше ви зможете додати більше локацій у налаштуваннях",
        "titleGoogle": "Виберіть локації для імпорту",
        "subtitleGoogle": "Виберіть локації для імпорту в Pluspoint. Можна імпортувати одну або кілька локацій і відразу почати керувати відгуками, повідомленнями та профілями.",
        "canTryNextFull": "Не має локацій, які ви шукаєте? Ви можете спробувати наступне:",
        "canTryNext": "Не бачите потрібного списку? Підключіть інший Google-акаунт.",
        "success": "Виконано"
    },
    "AcceptInvitationPage": {
        "title": "Налаштуйте свій акаунт",
        "description": "Вас запрошено приєднатися до Pluspoint",
        "continueWithGoogle": "Продовжити з Google",
        "emailMismatch": "Електронна пошта облікового запису Google не збігається з електронною поштою запрошення. Спробуйте ще раз з правильним обліковим записом.",
        "tokenExpired": "Термін дії цього посилання-запрошення закінчився. Зверніться до адміністратора для отримання нового запрошення.",
        "alreadyAccepted": "Це запрошення вже було прийнято. Увійдіть в систему."
    },
    "ResetPasswordPage": {
        "titleReset": "Змінити пароль",
        "titleChanged": "Пароль змінено",
        "descriptionReset": "Введіть новий пароль для вашого профілю",
        "descriptionChanged": "Ваш пароль було успішно змінено. Ви можете увійти у обліковий запис використовуючи новий пароль.",
        "confirmPassword": "Підтвердити пароль"
    },
    "ReviewsAutoreplies": {
        "instantlyRespond": "Миттєво відповідайте на кожний відгук",
        "googleConnected": "Налаштуйте автовідповіді на відгуки Google, що будуть виконуватися при певних правилах",
        "subtitleWithManualSupport": "Налаштуйте AI-відповіді для відгуків клієнтів. Персоналізуйте пропозиції на всіх платформах і автоматично публікуйте відповіді на відгуки Google.",
        "created": "Створено автовідповідей:",
        "ruleName": "Назва",
        "containsMessage": "Не містить текст",
        "addRule": "Додати нове правило",
        "editRule": "Редагувати автовідповідь",
        "viewRule": "Деталі авто-відповіді",
        "reviewType": "Тип відгуку",
        "withComment": "З коментарем",
        "withoutComment": "Без коментаря",
        "applyToPastReviews": "Застосувати до минулих відгуків без відповіді",
        "enableAI": "Увімкнути авто-відповіді Pulse AI для нових відгуків",
        "enableAIDescription": "Авто-відповіді Pulse AI можуть створювати неточні або недоречні відповіді. Активуючи цю опцію, ви усвідомлюєте ризики та берете на себе відповідальність за контроль і управління відповідями.",
        "pulseAiDescription": "Додайте власні інструкції, щоб формувати згенеровані ШІ відповіді. Вони застосовуються, коли ви натискаєте «Написати відповідь» у будь-якому відгуку, і до авто-відповідей на відгуки Google, коли перемикач нижче увімкнено.",
        "createNewTemplate": "Створити новий шаблон",
        "sendRecoveryForm": "Надсилати форму відновлення",
        "sendRecoveryFormDescription": "Відповіді на відгуки з оцінкою від 1 до 4 завершуються посиланням на приватну форму, де клієнт може залишити свої контакти."
    },
    "ReviewsEmptyFeed": {
        "reviewsNotSelectedTitle": "Ви не вибрали жодного сайту відгуків",
        "integrationDescription": "сайт відгуків",
        "surveyDescription": "опитування",
        "reviewsAreLoadingTitle": "Ваші відгуки завантажуються в Pluspoint",
        "reviewsAreLoadingDescription": "Зазвичай це займає кілька хвилин",
        "reviewsNotSelectedDescription": "Виберіть існуючу локацію, {{feedback}} та рейтинг у фільтрі",
        "reviewsNotExistTitle": "Ви ще не отримали жодного відгуку",
        "reviewsNotExistDescriptionEx": "Натисніть <0>{{sendSurveys}}</0> або <1>{{setupSurvey}}</1>, щоб отримати відгуки",
        "sendSurveys": "Запит відгуків",
        "setupSurvey": "Налаштуйте опитування"
    },
    "ReviewsManage": {
        "newReviews": "Доступні нові відгуки. <0>{{update}}</0>",
        "update": "ОНОВИТИ",
        "withoutReplies": "Лише відгуки без відповідей",
        "noTextMsg": "Немає даних",
        "onlyRating": "Клієнт не написав відгук, а залишив лише оцінку.",
        "repliedOn": "Отримана відповідь {{date}}",
        "replied": "Отримана відповідь",
        "repliedOnByUser": "Відповідь від {{name}}, {{date}}",
        "repliedByUser": "Відповідь від {{name}}",
        "viewOn": "Переглянути на {{integration}}",
        "editReply": "Редагувати відповідь",
        "unverifiedListingNotice": "Цей профіль не підтверджено в Google Business Profile, тому Google не приймає відповіді.",
        "verifyListingAction": "Підтвердити профіль",
        "replyingAsOwner": "Відповісти як власник бізнесу",
        "publishReply": "Опублікувати відповідь",
        "yourReply": "Ваша відповідь",
        "unresolvedPlaceholders": "Ваша відповідь містить заповнювач, який неможливо заповнити: {{placeholders}}. Приберіть його перед публікацією.",
        "viaOn": "{{integration}} {{date}}",
        "locationsCount": "{{count}} локації(й)",
        "assignContact": "Призначити контакт",
        "markAsReplied": "Додати відповідь",
        "replyingOnExternal": "Відповісти на зовнішній платформі",
        "manuallyRepliedOn": "Відповідь додано {{date}}",
        "manuallyReplied": "Відповідь додано",
        "manuallyRepliedOnByUser": "Відповідь додано вручну від {{name}}, {{date}}",
        "manuallyRepliedByUser": "Відповідь додано вручну від {{name}}",
        "translate": "Перекласти",
        "showOriginal": "Показати оригінал",
        "translatedByGoogle": "Перекладено Google",
        "markAsFeatured": "Додати до вибраних",
        "removeFromFeatured": "Прибрати з вибраних",
        "markAsDeleted": "Позначити як видалений",
        "unmarkAsDeleted": "Зняти позначку видаленого",
        "markedAsDeleted": "Відгук позначено як видалений",
        "unmarkedAsDeleted": "Позначку видаленого знято",
        "reviewStatus": {
            "updated": "Оновлений",
            "deleted": "Видалений",
            "featured": "Вибраний"
        }
    },
    "RespondTemplate": {
        "insertTemplate": "Вибрати шаблон",
        "noSavedTemplates": "Немає шаблонів",
        "saveReplyAsTemplate": "Зберегти як новий шаблон",
        "deleteTemplate": "Видалити шаблон",
        "overwriteTemplate": "Перезаписати шаблон",
        "saveAsNewTemplate": "Зберегти як новий шаблон",
        "saveNewTemplate": "Зберегти новий шаблон",
        "editTemplate": "Редагувати шаблон?",
        "editTemplateDescription": "Це призведе до заміни шаблону."
    },
    "ReviewsReplyTemplates": {
        "tenfoldProductivity": "Налаштовуйте шаблони відповідей",
        "googleConnected": "Відповідайте на відгуки Google більш ефективно, використовуючи шаблони відповідей.",
        "created": "Шаблонів створено:",
        "templateMessage": "Текст відповіді",
        "linkedAutoreplies": "Зв'язані автовідповіді",
        "addTemplate": "Додати новий шаблон",
        "editTemplate": "Редагувати шаблон відповіді",
        "viewTemplate": "Деталі шаблону відповіді",
        "messageInputText": "Додайте повідомлення нижче. Ви можете використовувати [name] і [location], які будуть автоматично замінені іменем автора відгуку та назвою вашої локації, де було залишено відгук. Додайте посилання на форму відновлення з того самого меню, щоб запросити клієнта залишити свої контакти."
    },
    "SendInvites": {
        "sendSurvey": "Надіслати опитування",
        "sendSurveys": "Запит опитувань",
        "personal": "Особистий",
        "bulk": "Груповий",
        "phoneEmail": "Моб. номер чи email",
        "from": "Від",
        "messageSent": "Опитування надіслано",
        "messagesSent": "опитувань надіслано",
        "bulkDescription1": "Ви можете надіслати опитування групі осіб імпортувавши контакти з файлу формату csv.",
        "bulkDescription2": "Розсилка не може перевищувати 1,000 контактів.",
        "bulkFileLink": "Завантажити приклад csv файлу",
        "dataVerification": "Перевірка даних",
        "dataVerificationDescription": "Перевірте отримані дані. Для успішності операції, вони не повинні містити помилок. Якщо ви виявили помилку, виправьте її та повторно завантажте файл. У випадку коли контакт має email та номер телефону, буде надіслано SMS повідомлення.",
        "id": "№",
        "import": "Імпортувати {{amount}} контактів",
        "contactsAdded": "контактів додано.",
        "viewContacts": "Переглянути контакти",
        "addedContacts": "Додані контакти"
    },
    "SettingsTabs": {
        "profile": "Профіль",
        "general": "Обліковий запис",
        "companies": "Локації",
        "channels": "Канали",
        "integrations": "Інтеграції"
    },
    "mcpConnections": {
        "title": "Підключення MCP",
        "subtitle": "Застосунки, які можуть підключатися до вашого облікового запису Pluspoint через Model Context Protocol. Відкличте ті, що ви більше не використовуєте.",
        "row": {
            "authorizedBy": "Авторизовано {{name}} · {{when}}",
            "authorizedByNoDate": "Авторизовано {{name}}",
            "lastUsed": "Останнє використання: {{when}}",
            "lastUsedNever": "Останнє використання: ніколи",
            "verified": "Перевірений постачальник"
        },
        "empty": {
            "title": "Підключень MCP ще немає.",
            "body": "Вставте {{url}} у Claude.ai, ChatGPT або інший MCP-клієнт, щоб підключитися. Спочатку ми попросимо вас авторизуватися."
        },
        "howTo": {
            "title": "Як підключитися",
            "body": "Вставте цей URL у ваш MCP-клієнт:",
            "guide": "Покрокова інструкція для Claude, ChatGPT та інших асистентів"
        },
        "revoke": {
            "confirmTitle": "Відкликати це підключення?",
            "confirmBody": "{{name}} більше не зможе отримувати доступ до вашого облікового запису Pluspoint. Активні сесії можуть тривати ще до 1 години, поки спливає термін дії наявних токенів доступу. Підключення доведеться авторизувати знову, щоб відновити доступ.",
            "success": "{{name}} відкликано."
        },
        "errors": {
            "fetchFailed": "Не вдалося завантажити підключення MCP.",
            "revokeFailed": "Не вдалося відкликати це підключення."
        }
    },
    "SettingsIntegrations": {
        "manageIntegration": {
            "title": "Керувати інтеграцією",
            "subtitle": "Підключіть кожен профіль цього облікового запису до локації Pluspoint.",
            "connectToLocation": "Підключити до локації",
            "dontConnect": "Не підключати",
            "createNew": "Створити нову локацію",
            "emptyProfiles": "Профілі для цього облікового запису не знайдено.",
            "loadError": "Не вдалося завантажити профілі цього облікового запису. Спробуйте ще раз.",
            "retry": "Повторити",
            "singleProfilePrompt": "Виберіть локацію, щоб прив'язати цей обліковий запис",
            "inactiveLocation": "Неактивна в Square"
        },
        "connected": "Підключено",
        "notConnected": "Не підключено",
        "integrations": "Інтеграції",
        "googleNoLocations": "Локації не знайдено. Виберіть інший обліковий запис Google.",
        "iFoodSubtitle": "Керуйте відгуками iFood і надсилайте опитування клієнтам iFood",
        "iFoodTitle": "Підключити iFood",
        "iFoodInstructions": "Введіть CNPJ кожної локації в iFood.",
        "vtexTitle": "Підключення облікового запису VTEX",
        "vtexSubtitle": "Щоб інтегрувати ваш обліковий запис VTEX з нашою платформою та увімкнути автоматизовані опитування після покупки, треба надати необхідні права доступу. До них відносяться App Key і App Token. <0>{{link}}</0>.",
        "instructionsLink": "Див. деталі в документації",
        "accountName": "Назва облікового запису",
        "appToken": "Application Token",
        "appKey": "Application Key",
        "coverManagerTitle": "Підключення облікового запису CoverManager",
        "coverManagerSubtitle": "Введіть свій ApiKey, щоб підключити обліковий запис CoverManager до Pluspoint",
        "apiKey": "apiKey",
        "deleteIntegration": "Видалити інтеграцію?",
        "deleteIntegrationMessage": "Цю інтеграцію буде видалено з вашого акаунту. Бажаєте продовжити?",
        "addIntegration": "Додати інтеграцію",
        "columnPlatform": "Платформа",
        "columnAccount": "Обліковий запис",
        "columnStatus": "Статус",
        "columnActions": "Дії",
        "noIntegrationsTitle": "Інтеграцій ще немає",
        "noIntegrationsDescription": "Підключіть першу інтеграцію, щоб почати синхронізацію даних.",
        "searchPlaceholder": "Пошук інтеграцій",
        "requestIntegrationTitle": "Не знайшли потрібну інтеграцію?",
        "requestIntegrationDescription": "Надішліть запит, і ми її розглянемо, або підключіться через Zapier чи наш API.",
        "requestIntegrationSuccess": "Дякуємо! Ваш запит на інтеграцію надіслано.",
        "requestIntegrationError": "Не вдалося надіслати запит",
        "connectViaApi": "Підключити через API",
        "connectViaZapier": "Підключити через Zapier",
        "headerTitle": "Підключіть свої платформи",
        "headerSubtitle": "Підключіть платформи, якими ви вже користуєтесь — Google, соцмережі, месенджери та CRM — щоб синхронізувати відгуки, публікувати дописи, керувати листуванням і зберігати дані клієнтів в одному місці.",
        "requestNamed": "Запросити додавання «{{name}}»"
    },
    "SettingsProfile": {
        "alertsAndReports": "Оповіщення та звіти",
        "settingsTitle": "Особисті налаштування",
        "profilePhoto": "Фото профілю",
        "generalInfo": "Загальна інформація",
        "systemLanguage": "Мова системи",
        "currentPassword": "Попередній пароль",
        "newPassword": "Новий пароль",
        "confirmPassword": "Підтвердити пароль",
        "passwordResetText": "Забули пароль?",
        "passwordResetUrl": "Встановіть новий пароль",
        "everyHour": "Щогодини",
        "everyDay": "Щодня",
        "everyWeek": "Щотижня",
        "everyMonth": "Щомісяця",
        "emptyNumberTooltip": "Введіть свій номер телефону, щоб отримувати SMS-сповіщення",
        "emailNotifications": "Email-сповіщення",
        "emailNotificationsDescription": "Нові сповіщення в обліковому записі.",
        "profileSyncConflicts": "Конфлікти синхронізації профілів",
        "newReviews": "Нові відгуки",
        "newMessages": "Непризначені повідомлення",
        "newSurveyResponses": "Нові відповіді опитувань",
        "performanceReports": "Звіти про результати",
        "performanceReportsDescription": "Переглядайте регулярні звіти про результати роботи.",
        "smsNotifications": "SMS-сповіщення про скарги",
        "smsNotificationsDescription": "Отримувати SMS при отриманні скарги.",
        "browserNotifications": "Сповіщення у браузері",
        "browserNotificationsDescription": "Отримувати сповіщення про нові повідомлення на пристрої.",
        "pushMessagesSnackbar": "Увімкніть сповіщення браузера, щоб отримувати сповіщення про нові повідомлення на своєму пристрої. <0>{{enable}}</0>",
        "serviceWorkerUpdate": "Доступна нова версія Pluspoint. <0>{{refresh}}</0>",
        "bumpVersion": "Доступна нова версія. Будь ласка, оновіть сторінку. <0>{{refresh}}</0>",
        "installApp": "Встановити додаток",
        "installAppDescription": "Встановіть Pluspoint на ваш пристрій для швидкого доступу.",
        "installIosInstructions": "Відкрийте цю сторінку в Safari, натисніть іконку «Поділитися», потім — «На екран «Додому»».",
        "installed": "Встановлено"
    },
    "SettingsGeneral": {
        "apiDocumentation": "Документація API",
        "accountNameOwnership": "Назва та адміністрування",
        "linkTracking": "Відстеження посилань",
        "linkTrackingDescription": "Дивіться в аналітиці, скільки відвідувачів приходить на ваш сайт із ваших профілів у Google, Facebook і довідниках. Pluspoint сам додає теги відстеження до посилання на сайт у кожному профілі.",
        "trackingTagsEnabled": "Позначати посилання профілів",
        "trackingTagsSource": "utm_source",
        "trackingTagsMedium": "utm_medium",
        "trackingTagsCampaign": "utm_campaign",
        "trackingTagsContent": "utm_content",
        "trackingTagsPreview": "Приклад для профілю Google",
        "accountName": "Назва облікового запису",
        "accountOwner": "Власник облікового запису",
        "accountLocale": "Локаль",
        "billing": "Оплата",
        "upgradePluspointSubscription": "Змініть тариф",
        "currentPlan": "Поточний тариф",
        "endsOn": "закінчується:",
        "endedOn": "закінчився:",
        "daysLeft_one": "дн. залишився",
        "daysLeft_other": "дн. залишилося",
        "upgradeDescription": "Виберіть тариф, період і кількість локацій, щоб продовжити:",
        "numberOfCompanies": "Кількість локацій",
        "annual": "Річний",
        "monthly": "Місячний",
        "proceedToPayment": "Оплатити",
        "pricePerCompany": "Вартість за локацію:",
        "totalPrice": "Всього",
        "month": "мiсяць",
        "year": "рік",
        "nextPaymentOn": "Наступний платіж",
        "cancelsOn": "Скасовується",
        "talkToSales": "Отримати консультацію",
        "upgradePlan": "Вибрати тариф",
        "changePlan": "Змінити тариф",
        "changeDescription": "Виберіть тарифний план, цикл платежів та кількість локацій і користувачів.",
        "numberOfUsers": "Кількість користувачів",
        "onlineListings": "Керування профілями",
        "reviewManagement": "Усі відгуки",
        "inboxAndLiveChat": "Вхідні повідомлення та Live-chat",
        "socialPosting": "Соціальні публікації",
        "microsites": "Мікросайти",
        "analytics": "Аналітика",
        "surveysAndTickets": "Опитування та задачі",
        "campaigns": "Розсилки",
        "additionalUsers": "Додаткові користувачі",
        "currentPrice": "Поточна вартість",
        "newPrice": "Нова вартість",
        "dueToday": "До сплати сьогодні",
        "proratedOnNextInvoice": "Пропорційні нарахування в наступному рахунку",
        "pulseAICredits": "Pulse AI кредити",
        "recurrentCredits": "Регулярні кредити",
        "recurrentCreditsDescription": "Використання регулярних кредитів, які оновлюються на початку кожного платіжного циклу.",
        "additionalCredits": "Додаткові кредити",
        "additionalCreditsDescription": "Доступні додаткові кредити. Вони не мають терміну дії й можуть бути використані в будь-який час.",
        "buyCredits": "Купити кредити",
        "enableAutoPay": "Увімкнути автооплату",
        "autoPayDescription": "Автоматично купувати кредити, коли баланс опускається нижче встановленого ліміту.",
        "creditsLeft": "Залишилось {{amount}} кредитів",
        "creditLimit": "Кредитний ліміт",
        "creditsToPurchase": "Кредитів докупити",
        "selectAccount": "Вибрати обліковий запис",
        "twoMonthsFree": "2 місяці безкоштовно",
        "perLocationPer": "локацію / {{period}}",
        "pluspointFeatureEverything": "Усі функції включено — без рівнів і обмежень",
        "pluspointFeatureReviews": "Відгуки: відстежуйте, відповідайте та отримуйте більше з ШІ",
        "pluspointFeatureInbox": "Омніканальна скринька з ШІ-чатботом 24/7",
        "pluspointFeatureEngage": "Публікації в соцмережах, кампанії, опитування та купони",
        "pluspointFeatureAllowances": "{{users}} користувачі та {{credits}} AI-кредитів / місяць включено",
        "minimumLocations": "Мінімум {{count}} локації",
        "usersIncluded": "{{count}} включено",
        "summaryPlan_one": "{{count}} локація",
        "summaryPlan_few": "{{count}} локації",
        "summaryPlan_many": "{{count}} локацій",
        "summaryPlan_other": "{{count}} локації",
        "summaryAdditionalUsers_one": "{{count}} додатковий користувач",
        "summaryAdditionalUsers_few": "{{count}} додаткові користувачі",
        "summaryAdditionalUsers_many": "{{count}} додаткових користувачів",
        "summaryAdditionalUsers_other": "{{count}} додаткових користувачів",
        "billToSubscription": "Списувати з підписки",
        "directoriesNoneEnrolled": "Поки що жодної локації не підключено.",
        "directoriesManagedPerLocation": "Додавайте або скасовуйте Локальні каталоги для кожної локації на її сторінці керування.",
        "openLocations": "Відкрити локації",
        "locationsEnrolled_one": "{{count}} локація підключена",
        "locationsEnrolled_other": "{{count}} локацій підключено"
    },
    "SettingsCompanies": {
        "movedTitle": "Локації переміщено",
        "movedDescription": "Тепер ви можете керувати локаціями з головного меню.",
        "goToLocations": "Перейти до Локацій",
        "degree": "Кваліфікація",
        "office": "Офіс",
        "menus": "Меню",
        "menuAssignmentFailed": "Локацію збережено, але не вдалося призначити меню. Спробуйте ще раз.",
        "headshotUrl": "Фото профілю",
        "locationName": "Назва локації",
        "internalName": "Внутрішня назва",
        "primaryPhone": "Основний телефон",
        "phoneExtension": "Вн.",
        "addChat": "Додати чат",
        "email": "Електронна пошта підтримки",
        "website": "Веб-сайт",
        "contact": "Контактні дані",
        "additionalInformation": "Додаткова інформація",
        "descriptionShort": "Короткий опис",
        "descriptionMedium": "Середній опис",
        "descriptionLong": "Довгий опис",
        "openingDate": "Дата відкриття",
        "businessHours": "Графік",
        "specialHours": "Змінений графік роботи",
        "specialHoursNeedBusinessHours": "Змінений графік потребує графіка роботи. Увімкніть графік і відкрийте хоча б один день, щоб додати дати.",
        "coverPhoto": "Обкладинка",
        "nationalHealthProviderId": "National Health Provider ID",
        "storeCode": "Код магазину",
        "certifications": "Сертифікації",
        "categoriesAndServices": "Категорії та послуги",
        "address": "Адреса",
        "city": "Місто",
        "channels": "Канали",
        "pending": "В очікуванні",
        "createChannel": "Додати новий канал",
        "showAddress": "Показувати адресу бізнесу клієнтам",
        "locatedInToggle": "Розташований всередині іншого бізнесу",
        "locatedInNeedsPin": "Поставте маркер на мапі, щоб знайти бізнеси поруч",
        "locatedIn": "Розташовано в",
        "relationIndependent": "Незалежний бізнес",
        "locatedInRelationLabel": "Тип відносин",
        "relationDepartment": "Відділ",
        "viewOnGoogleMaps": "Переглянути в Google Maps",
        "addressLine1": "Адреса рядок 1",
        "addressLine2": "Адреса рядок 2",
        "postalCode": "Індекс",
        "state": "Область",
        "country": "Країна",
        "countryLockedByListings": "Заблоковано, поки каталоги підключено",
        "countryLockedByGoogle": "Заблоковано, поки підключено Google-лістинг",
        "pinFollowsGoogle": "Позначка на карті відповідає вашому Google-лістингу. Перемістіть її у своєму Google Business Profile",
        "publishedDirectories_one": "Опубліковано ({{count}} каталог)",
        "publishedDirectories_few": "Опубліковано ({{count}} каталоги)",
        "publishedDirectories_many": "Опубліковано ({{count}} каталогів)",
        "publishedDirectories_other": "Опубліковано ({{count}} каталогів)",
        "optimizationScore": "Оцінка оптимізації",
        "optimizationScoreTooltip": "Показує, наскільки добре локацію оптимізовано для пошуку онлайн — на основі заповненості полів профілю. Вищий бал покращує видимість.",
        "integrationName": "Назва інтеграції",
        "disconnectIntegration": "Відключити інтеграцію?",
        "disconnectIntegrationMessage": "Ви не зможете збирати відгуки через Pluspoint на цій платформі та переглядати аналітику. Ви хочете продовжити?",
        "integrations": "Інтеграції",
        "onlineProfiles": "Онлайн профілі",
        "socialLinks": "Соціальні мережі",
        "managedByConnection": "Керується підключенням",
        "connected": "Підключено",
        "notConnected": "Не підключено",
        "published": "Опубліковано",
        "notPublished": "Не опубліковано",
        "generalInfo": "Загальні відомості",
        "profileURL": "URL профілю",
        "uberEatsReviewsHint": "Uber Eats публікує лише частину 5-зіркових відгуків закладу. Кількість і середні оцінки в Pluspoint відображають цю вибірку.",
        "bookingExtranetLink": "Посилання на Екстранет Booking.com",
        "bookingExtranetHint": "Необовʼязково. Вставте будь-яке посилання з Екстранету цього обʼєкта (admin.booking.com) або ID обʼєкта. Відповіді відкриватимуть сторінку відгуків Екстранету напряму.",
        "connectIntegration": "Підключити",
        "editProfile": "Редагувати профіль",
        "reviewPlatforms": "Платформи відгуків",
        "addReviewPlatform": "Додати платформу відгуків",
        "connectIntegrationMsg": "Профіль додано",
        "locationPublishedMsg": "Локацію опубліковано. Оновлення можуть з’явитися на зовнішніх сайтах протягом кількох днів.",
        "profileDisconnected": "Профіль вимкнено",
        "atLeastOneProfile": "Принаймні одна інтеграція має бути увімкнена",
        "selectLocation": "Вибрати локацію",
        "connectLocation": "Підключити локацію",
        "goToIntegrations": "Перейти до інтеграцій",
        "importCompanies": "Імпортувати локації",
        "importCompaniesCount": "Імпортувати {{count}} локацію(ї)",
        "selectCompanies": "Виберіть локації, які ви хочете імпортувати зі свого облікового запису Google:",
        "linkedTo": "Привʼязана до",
        "googleAutocomplete": "Знайти бізнес у Google",
        "addLocationTitle": "Додати нову локацію",
        "addLocationDescription": "Виберіть локацію Google, яку ви хочете додати у Pluspoint і натисніть Додати локацію.",
        "connectDrawerDescription": "Виберіть відповідний елемент зі списку, щоб пов'язати його з локацією.",
        "connectDrawerNotConnected": "Інтеграція не підключена",
        "connectDrawerNotConnectedDescription": "Підключіть свій обліковий запис у налаштуваннях інтеграції, щоб продовжити (необхідні 'Global Admin' права).",
        "iFoodPendingTitle": "Підключення iFood в процесі",
        "iFoodPendingDescription": "Запит на підключення надіслано в iFood. Ви зможете прив'язати локації, щойно iFood надасть доступ.",
        "title": "Керуйте всіма локаціями в одному місці",
        "subtitle": "Тримайте дані про бізнес, графік роботи, адреси та контактну інформацію точними й узгодженими для всіх локацій. Додавайте нові локації, редагуйте масово або імпортуйте з Google — все необхідне для зручного управління.",
        "additionalPhone": "Додатковий телефон",
        "additionalPhones": "Додаткові телефони",
        "addPhone": "Додати телефон",
        "geoModifier": "Геомодифікатор",
        "addFeatureMessage": "Додати промо-повідомлення",
        "healthcareFacility": "Медичний заклад",
        "healthcareProfessional": "Медичний працівник",
        "hotel": "Готель",
        "restaurant": "Ресторан",
        "listingDirectories": "Каталоги лістингів",
        "listingDirectoriesDescription": "Публікуйте й синхронізуйте вашу локацію на 200+ платформах.",
        "findOnGoogle": "Знайти в Google",
        "enterManually": "Ввести вручну",
        "googleAccountRequired": "Підключіть свій обліковий запис Google в налаштуваннях інтеграції, щоб продовжити",
        "facebookAccountRequired": "Підключіть свій обліковий запис Facebook в налаштуваннях інтеграції, щоб продовжити",
        "tiktokAccountRequired": "Підключіть свій обліковий запис TikTok в налаштуваннях інтеграції, щоб продовжити",
        "xAccountRequired": "Підключіть свій обліковий запис X в налаштуваннях інтеграції, щоб продовжити",
        "whatsappAccountRequired": "Підключіть свій обліковий запис WhatsApp в налаштуваннях інтеграції, щоб продовжити",
        "createGoogleProfileTitle": "Створити профіль у Google",
        "createGoogleProfileDescription": "Виберіть, у якому обліковому записі Google та групі локацій буде створено цей профіль.",
        "googleAccount": "Обліковий запис Google",
        "googleLocationGroup": "Група локацій",
        "selectAccountToLink": "Виберіть, у якому підключеному обліковому записі публікуватиме ця локація.",
        "account": "Обліковий запис",
        "localDirectories": "Локальні каталоги",
        "addLocalDirectories": "Додати Локальні каталоги",
        "cancelLocalDirectories": "Скасувати Локальні каталоги",
        "cancelLocalDirectoriesDescription": "Публікація триватиме до кінця оплаченого періоду, після чого лістинги цієї локації буде видалено. Кошти не повертаються.",
        "directoriesValueCopy": "Опублікуйте цю локацію у 200+ каталогах — від Apple Maps і Bing до TripAdvisor та Yelp — і тримайте години роботи, фото й дані синхронізованими автоматично. Узгоджені дані всюди — саме те, на що спираються локальний пошук і ШІ-відповіді на кшталт ChatGPT, тож вас знаходять першими й ви отримуєте більше клієнтів.",
        "directoriesPromoTitle": "Будьте знайденими у 200+ локальних каталогах",
        "directoriesPromoDescription": "Опублікуйте {{location}} у 200+ каталогах — Apple Maps, Bing, TripAdvisor, Yelp та інші — із завжди синхронізованими даними. Будьте першими в локальному пошуку та ШІ-відповідях на кшталт ChatGPT.",
        "seeAllDirectories": "Переглянути всі каталоги",
        "perLocation": "за локацію",
        "directoriesMinimumTermNotice": "Можна скасувати через 3 місяці.",
        "chargedTodayProrated": "Списання сьогодні (пропорційно)",
        "thenFrom": "Далі з {{date}}",
        "addForToday": "Додати за {{amount}} сьогодні",
        "subscribeAndAddLocation": "Оформити підписку та додати локацію",
        "directoriesRequiresSubscription": "Локальні каталоги потребують активної підписки. Оформіть тариф і додайте цю локацію за один крок.",
        "directoriesSinceCancellableAfter": "Публікується з {{since}} · можна скасувати після {{cancellableAfter}}",
        "directoriesCancellableAfter": "Можна скасувати після {{date}}",
        "directoriesEndsOn": "Публікується до {{date}}",
        "directoriesIncludedInPlan": "Включено у ваш тариф",
        "viewListings": "Переглянути каталоги",
        "directoriesAddedMsg": "Локальні каталоги додано. Публікацію розпочато.",
        "directoriesCancelledMsg": "Локальні каталоги скасовано. Публікація триватиме до кінця оплаченого періоду."
    },
    "ScorePanel": {
        "recommendations": "Рекомендації",
        "allDone": "Усе, що впливає на оцінку, заповнено",
        "suggest": "Запропонувати",
        "write": "Написати",
        "dismiss": "Відхилити",
        "replace": "Замінити",
        "undo": "Скасувати",
        "waitForAi": "Зачекайте, доки Pulse AI завершить",
        "thinking": "Pulse AI працює над цим…",
        "failed": "Не вдалося згенерувати пропозиції. Спробуйте ще раз.",
        "noSuggestions": "Pulse AI не має пропозицій для цієї локації.",
        "reviewBeforeSave": "Перегляньте у формі. Нічого не зберігається, доки ви не натиснете «Зберегти».",
        "aiServices": "Pulse AI · на основі ваших категорій та опису",
        "aiCategories": "Pulse AI · на основі даних про ваш бізнес",
        "aiSpecialHours": "Pulse AI · державні свята: {{country}}",
        "aiDescription": "Pulse AI · запропонований опис",
        "specialHoursNote": "Дати додаються як «Закрито». Перемкніть дату на «Відкрито» та вкажіть години, якщо працюєте цього дня.",
        "addServices_zero": "Додати послуги",
        "addServices_one": "Додати {{count}} послугу",
        "addServices_few": "Додати {{count}} послуги",
        "addServices_many": "Додати {{count}} послуг",
        "addServices_other": "Додати {{count}} послуги",
        "addCategories_zero": "Додати категорії",
        "addCategories_one": "Додати {{count}} категорію",
        "addCategories_few": "Додати {{count}} категорії",
        "addCategories_many": "Додати {{count}} категорій",
        "addCategories_other": "Додати {{count}} категорії",
        "addDates_zero": "Додати дати",
        "addDates_one": "Додати {{count}} дату",
        "addDates_few": "Додати {{count}} дати",
        "addDates_many": "Додати {{count}} дат",
        "addDates_other": "Додати {{count}} дати",
        "drafted": {
            "shortDescription": "Короткий опис згенеровано",
            "mediumDescription": "Середній опис згенеровано",
            "longDescription": "Довгий опис згенеровано"
        },
        "rec": {
            "locationName": "Додайте назву локації",
            "practitioner": "Заповніть дані спеціаліста",
            "certifications": "Додайте сертифікацію",
            "phone": "Додайте номер телефону",
            "email": "Додайте email",
            "website": "Додайте вебсайт",
            "address": "Заповніть адресу",
            "workingHours": "Налаштуйте графік",
            "specialHours": "Додайте змінений графік роботи",
            "shortDescription": "Додайте короткий опис",
            "mediumDescription": "Додайте середній опис",
            "longDescriptionAdd": "Додайте довгий опис",
            "longDescriptionExtend": "Розширте довгий опис",
            "openingDate": "Додайте дату відкриття",
            "engagement": "Додайте виділене повідомлення",
            "categoriesAdd": "Додайте категорію",
            "categoriesMore": "Додайте ще одну категорію",
            "servicesAdd": "Додайте послуги",
            "servicesMore": "Додайте більше послуг",
            "paymentMethods": "Виберіть методи оплати",
            "logo": "Завантажте логотип",
            "cover": "Завантажте обкладинку",
            "socialAdd": "Додайте соціальну мережу",
            "socialMore": "Додайте ще одну соціальну мережу"
        }
    },
    "SettingsChannels": {
        "historyImportRunning": "Імпортуємо попередні чати…",
        "historyImportCompleted": "Попередні чати імпортовано",
        "historyImportDeclined": "Попередніми чатами не поділилися",
        "historyImportFailed": "Не вдалося імпортувати попередні чати або контакти",
        "headerTitle": "Налаштування каналів зв'язку",
        "headerSubtitle": "Об’єднайте всі свої канали зв'язку, щоб централізовано взаємодіяти з клієнтами з інтерфейсу Pluspoint.",
        "firstStepTitle": "Додати канал",
        "firstStepSubtitle": "Виберіть тип каналу, який ви хочете додати",
        "createChannelTitle": "Створити новий {{channelType}} канал",
        "editChannelTitle": "Редагувати {{channelType}} канал",
        "editChannelSubtitle": "Надавайте миттєву підтримку своїм клієнтам завдяки інтеграції {{channelType}}",
        "linkChannelToLocation": "Прив'язати цей канал до локації або бренду",
        "channelName": "Назва каналу",
        "senderId": "Альфа ім'я",
        "provider": "Провайдер",
        "accountSid": "Account SID",
        "authToken": "Auth token",
        "apiToken": "HTTP API Token",
        "customGateway": "Власний шлюз",
        "whatsAppNumber": "Номер WhatsApp",
        "senderIdNotice": "Альфа ім'я вказує відправника SMS повідомлення. Воно може містити до 11 символів, включаючи великі та малі літери, цифри та пробіл.",
        "isNewWhatsAppAcc": "Новий WhatsApp номер?",
        "whatsAppSuccess": "WhatsApp успішно підключено!",
        "whatsAppFail": "Номер уже існує під цим обліковим записом",
        "whatsAppTooltip": "Увімкніть цю опцію, якщо ваш номер WhatsApp було зареєстровано менше ніж 30 днів тому. Це зменшить ймовірність його блокування під час автоматичного масового надсилання повідомлень. Якщо ввімкнено, Pluspoint встановлює обмеження для повідомлень, надісланих через цей канал, до 2 запитів на день. Цей ліміт поступово збільшують у 1,5 рази щодня (наприклад, 2, 3, 5, 7, 10 тощо).",
        "whatsAppInstruction1": "1. Відкрийте WhatsApp на телефоні з вказаним номером",
        "whatsAppInstruction2": "2. Натисніть на <strong>{{settings}}</strong>, а потім виберіть <strong>{{qrIcon}}</strong>",
        "qrIcon": "QR",
        "whatsAppInstruction3": "3. Натисніть на <strong>{{scan}}</strong> і наведіть телефон на цей QR код",
        "scan": "Сканувати",
        "pending": "В очікуванні",
        "welcomeTagline": "Привітання",
        "businessHoursSwitch": "Налаштувати робочий час",
        "offlineMessage": "Офлайн повідомлення",
        "widgetPosition": "Розположення віджету live-чату",
        "widgetOffsetX": "Горизонтальний відступ (px)",
        "widgetOffsetY": "Вертикальний відступ (px)",
        "addCodeBelow": "Додайте наведений нижче код до HTML head розділу вашого веб-сайту.",
        "messagesTab": "Повідомлення",
        "contactDetailsHint": "Запитуються в чаті після першого повідомлення відвідувача. Принаймні одне з полів — електронна пошта або телефон — має бути обов'язковим.",
        "assignLocationSwitch": "Призначати розмови локації",
        "assignLocationHint": "Кожна розмова призначається локації. Якщо в списку більше однієї локації, відвідувачів просять обрати локацію, до якої вони звертаються.",
        "allLocationsCount": "Усі локації ({{number}})",
        "selectedLocations": "Вибрані локації",
        "reachVisitorsTitle": "Зв'язок із відвідувачами, які пішли",
        "missedRepliesSwitch": "Сповіщати про пропущені відповіді",
        "missedRepliesHint": "Коли агент відповідає після того, як відвідувач закрив сторінку, той отримує коротке повідомлення з посиланням назад у чат.",
        "followUpRequiresContact": "Потрібне обов'язкове поле електронної пошти або телефону",
        "followUpChannelCleared": "Вибраний канал більше не відповідає полям контакту; оберіть інший",
        "followUpChannelUnavailable": "Канал для зв'язку відключено або видалено; оберіть інший",
        "followUpChannelOtherTeam": "Канал іншої команди",
        "welcomeButtons": "Кнопки",
        "welcomeButton": "Кнопка {{number}}",
        "addButton": "Додати кнопку",
        "welcomePopupSwitch": "Автоматично показувати привітання поруч із кнопкою чату",
        "welcomePopupHint": "З'являється через кілька секунд після завантаження сторінки, один раз для кожного відвідувача. На телефоні або коли вимкнено, відвідувачі бачать його, коли відкривають чат.",
        "showOfflineMessage": "Показувати офлайн повідомлення",
        "offlineHoursHint": "Публікується в чаті поза годинами, вказаними нижче.",
        "websiteWidget": "Віджет для сайту",
        "chatLink": "Посилання на чат",
        "chatLinkHint": "Відкриває цей чат на окремій сторінці. Поширюйте його як посилання або QR-код там, де віджет не встановити: меню, чеки, підписи в листах, профілі в соцмережах.",
        "chatLinkParams": "Додайте ?locationId= з ідентифікатором локації, щоб пропустити запитання про локацію, ?language= з кодом мови, щоб відкрити чат цією мовою, або ?start= із повідомленням, щоб заповнити перше повідомлення відвідувача.",
        "allowedSites": "Дозволені сайти",
        "allowedSitesHint": "Домени, на яких може з’являтися віджет, включно з піддоменами. Залиште список порожнім, щоб дозволити будь-який сайт. Ваші мікросайти та посилання на чат дозволені завжди.",
        "allowedSiteInvalid": "Введіть домен, наприклад example.com",
        "signedInCustomers": "Авторизовані клієнти",
        "signingSecretHint": "Підписуйте дані клієнта на своєму сервері цим секретом, щоб клієнти, які увійшли на ваш сайт, пропускали форму.",
        "signingSecret": "Секрет підпису",
        "replaceSecretTitle": "Замінити секрет підпису?",
        "replaceSecretBody": "Дані, підписані поточним секретом, одразу перестають прийматися. Оновіть секрет на своєму сайті.",
        "followUpWarning": "Попередження",
        "logoUrl": "URL логотипу",
        "smtpHost": "SMTP Host",
        "smtpPort": "SMTP Port",
        "username": "Ім'я користувача",
        "encryption": "Метод шифрування",
        "saveInstagramReplies": "Отримувати згадування у історії",
        "createNewChannel": "Створити новий канал",
        "enableIncomingEmail": "Отримувати листи у вхідних (IMAP)",
        "enableIncomingEmailHint": "Отримувати та відповідати на листи клієнтів безпосередньо з вхідних",
        "imapHost": "IMAP Host",
        "imapPort": "IMAP Port",
        "imapUsername": "IMAP логін",
        "imapUsernamePlaceholder": "Залиште порожнім, щоб використовувати SMTP логін",
        "imapPassword": "IMAP пароль",
        "imapPasswordPlaceholder": "Залиште порожнім, щоб використовувати SMTP пароль",
        "signature": "Підпис електронного листа",
        "facebookPage": "Сторінка Facebook",
        "hostedEmailSubtitle": "Надсилайте кампанії, опитування та відповіді з Inbox з адреси на власному домені.",
        "receiveEmailsInInbox": "Отримувати листи в Inbox",
        "forwardingAddress": "Адреса для пересилання",
        "receiveRepliesHint": "Налаштуйте пересилання з {{email}} на цю адресу у вашій поштовій службі. Відповіді з'являтимуться в Inbox, і ви відповідатимете звідси.",
        "fromNameHint": "Відображається як ім’я відправника",
        "emailAddress": "Адреса електронної пошти",
        "emailAddressLocked": "Адресу не можна змінити після створення каналу",
        "returnPathSubdomain": "Субдомен Return-Path",
        "customReturnPath": "Використовувати власний субдомен Return-Path",
        "customReturnPathHint": "Повернені листи надходять через цей субдомен. Змінюйте типовий, лише якщо ваш домен уже його використовує.",
        "returnPathSubdomainReused": "{{domain}} уже підключено. Нова адреса використовує ті самі DNS-записи та субдомен Return-Path.",
        "returnPathSubdomainInvalid": "Використовуйте лише літери, цифри та дефіси",
        "verifyDomainTitle": "Підтвердьте {{domain}}",
        "verifyDomainSubtitle": "Додайте ці записи у свого DNS-провайдера. Канал стане доступним, коли всі вони будуть підтверджені.",
        "dnsRecordsHint": "Ці два DNS-записи підтверджують, що домен ваш, і дають поштовим сервісам підстави довіряти вашим листам. Запис TXT підписує листи; запис CNAME обробляє повернення.",
        "dnsPropagationNote": "Примітка: зміни DNS можуть поширюватися до 48 годин.",
        "showDnsRecords": "Показати DNS-записи",
        "hideDnsRecords": "Сховати DNS-записи",
        "recordVerified": "Підтверджено",
        "statusSuspended": "Призупинено",
        "domainSuspended": "Надсилання з цього домену призупинено. Зверніться в підтримку, щоб відновити.",
        "ringCentralAccount": "Обліковий запис RingCentral",
        "ringCentralNumber": "Номер RingCentral",
        "ringCentralNoNumbers": "У цього користувача RingCentral немає номера, з якого можна надсилати SMS",
        "ringCentralNumbersInUse": "Усі номери цього облікового запису RingCentral уже використовують інші канали",
        "ringCentralDisconnected": "Обліковий запис RingCentral цього каналу відключено. Підключіть його знову в розділі <0>{{link}}</0>, щоб відновити надсилання.",
        "ringCentralIntegrations": "Інтеграції"
    },
    "SettingsUsers": {
        "addedOn": "Доданий",
        "lastLogin": "Востаннє заходив",
        "generalInfo": "Загальні відомості",
        "editUser": "Редагувати користувача",
        "accessLevel": "Рівень доступу",
        "owner": "Власник",
        "global": "Глобальний",
        "role": "Роль",
        "superAdmin": "Супер адміністратор",
        "admin": "Адміністратор",
        "user": "Користувач",
        "permissions": "Права доступу",
        "permissionsDescription": "Виберіть роль: Супер адміністратори можуть змінювати глобальні налаштування та керувати інтеграціями облікового запису. Адміністратори можуть налаштовувати локації, опитування, шаблони та кампанії. Користувачі відповідають за щоденні операції. Ця роль підходить для операційного персоналу.",
        "accessDescription": "Виберіть рівень доступу: Глобальний надає доступ до всієї організації, Бренд надає доступ до вибраної групи локацій, а Локація надає доступ лише до певних локацій.",
        "globalAccess": "Глобальний рівень доступу",
        "brandAccess": "Рівень доступу для бренду",
        "locationAccess": "Рівень доступу для локації"
    },
    "SettingsTeams": {
        "createTeam": "Створити команду",
        "editTeam": "Редагувати команду",
        "teamName": "Назва команди",
        "permissions": "Дозволи",
        "permissionsDescription": "Керуйте можливостями кожної команди. Обмежений дозволяє переглядати та виконувати базові дії, тоді як Повний відкриває редагування, створення та управління в кожному модулі. Налаштування акаунту також можна встановити на Немає, щоб повністю приховати налаштування.",
        "restricted": "Обмежений",
        "full": "Повний",
        "none": "Немає",
        "noneTooltip": "Немає доступу — функція прихована для цієї команди",
        "globalPermission": "Глобальний",
        "scope": "Рівень доступу",
        "scopeDescription": "Визначте, до яких локацій має доступ ця команда. Глобальний рівень надає доступ до всіх локацій, Бренд обмежує доступ до локацій обраних брендів, а Локація надає доступ лише до конкретних локацій.",
        "scopeScopedOnlyNote": "Рівень доступу застосовується лише до дозволів з обмеженим рівнем. Глобальні дозволи (Контакти, Налаштування акаунту) завжди охоплюють весь акаунт.",
        "members": "Учасники",
        "membersDescription": "Оберіть користувачів для додавання до цієї команди. Учасників можна змінити пізніше.",
        "addMember": "Додати учасника",
        "enabledPermissionsCount": "{{count}} дозволів",
        "messagingRestricted": "Перегляд, Відповідь, Перепризначення, Вирішення/Повторне відкриття, Експорт, Аналітика",
        "messagingFull": "AI-агенти, База знань",
        "accountSettings": "Налаштування акаунту",
        "tooltipRestricted": "Обмежений",
        "tooltipFull": "Повний",
        "contactsRestricted": "Перегляд усіх контактів облікового запису",
        "contactsFull": "Створення, Редагування, Видалення, Масові дії, Імпорт, Експорт",
        "locationsRestricted": "Перегляд локацій та профілів, Завантаження/Видалення медіа, Експорт CSV",
        "locationsFull": "Додавання/Імпорт локацій, Редагування, Видалення, Масове редагування, Експорт/Імпорт, Синхронізація, Аналітика",
        "reviewsRestricted": "Перегляд, Відповідь на відгуки, Використання шаблонів, Аналітика, Віджети",
        "reviewsFull": "Управління автовідповідями та шаблонами відповідей",
        "postsRestricted": "Перегляд публікацій, Аналітика",
        "postsFull": "Створення, Редагування, Видалення, Планування публікацій",
        "micrositesRestricted": "Перегляд веб-сторінок",
        "micrositesFull": "Створення, Редагування, Видалення веб-сторінок",
        "surveysRestricted": "Перегляд відповідей, Розмови, Тікети, Перегляд шаблонів",
        "surveysFull": "Управління шаблонами опитувань",
        "campaignsRestricted": "Перегляд кампаній",
        "campaignsFull": "Створення, Редагування, Видалення кампаній",
        "couponsRestricted": "Перегляд купонів",
        "couponsFull": "Створення, Редагування, Видалення купонів",
        "settingsNoneTooltip": "Лише сторінка профілю",
        "settingsRestrictedTooltip": "Управління користувачами: запрошення, редагування, видалення",
        "settingsFullTooltip": "Усі налаштування: Загальні, Білінг, Бренди, Користувачі, Команди, Канали, Інтеграції"
    },
    "SettingsBrands": {
        "title": "Групуйте локації за допомогою брендів",
        "subtitle": "Легко керуйте декількома локаціями, об’єднуючи їх під одним брендом. Централізуйте свої повідомлення, відгуки, кампанії та опитування для зручного управління всіма локаціями.",
        "editBrand": "Редагувати бренд",
        "shared": "Спільний",
        "gradient": "Градієнт",
        "solid": "Суцільний",
        "sharp": "Гострі",
        "softlyRounded": "Злегка заокруглені",
        "rounded": "Заокруглені",
        "fontColor": "Колір шрифту",
        "automaticallyAssignBrand": "Автоматично призначати новим локаціям",
        "brandIsAlreadyAssigned": "Бренд за замовчуванням уже встановлено",
        "createNewBrand": "Створити новий бренд",
        "previewDisclaimer": "Це лише демонстрація того, як ваш бренд виглядає для клієнтів."
    },
    "ShowcaseWidgets": {
        "title": "Віджети відгуків клієнтів",
        "subtitle": "Демонструйте позитивні відгуки клієнтів на сторінках свого веб-сайту за допомогою віджетів.",
        "popup": "Спливаюче вікно",
        "grid": "Сітка",
        "popupWidget": "Віджет — спливаюче вікно",
        "gridWidget": "Віджет — сітка",
        "reviewsSorting": "Сортировка відгуків",
        "random": "Випадкові",
        "recent": "Недавні",
        "reviewsToShow": "Кількість відгуків для показу",
        "reviewsMode": "Які відгуки показувати",
        "topRatedReviews": "Відгуки з 5 зірками та коментарем",
        "featuredReviews": "Вибрані відгуки",
        "noFeaturedReviews": "Ще немає вибраних відгуків. Позначте відгуки як вибрані на сторінці відгуків",
        "widgetPosition": "Розташування віджета",
        "widgetCode": "Код віджета",
        "addCodeSubtitle": "Додайте код нижче в HTML вашого вебсайту, де ви хотіли б розмістити віджет"
    },
    "Sidebar": {
        "bookmarks": "Закладки",
        "addBookmark": "Додати до закладок",
        "removeBookmark": "Видалити із закладок",
        "home": "Головна",
        "responses": "Усі відповіді",
        "templates": "Шаблони",
        "surveys": "Опитування",
        "surveysQrOnly": "QR-коди",
        "analytics": "Аналітика",
        "analyticsConversion": "Конверсія",
        "analyticsNpsOverview": "Огляд NPS",
        "analyticsSurveyInsights": "Аналітика опитувань",
        "analyticsSurveys": "NPS та опитування",
        "analyticsConversations": "Розмови",
        "analyticsPresence": "Присутність",
        "analyticsSocialPosts": "Соціальні публікації",
        "performance": "Ефективність",
        "insights": "Інсайти",
        "reviews": "Відгуки",
        "reviewsManage": "Усі відгуки",
        "reviewsTemplates": "Шаблони відповідей",
        "reviewsAutoreplies": "Автовідповіді",
        "reviewsAutomation": "Автоматизація",
        "microsites": "Мікросайти",
        "messaging": "Повідомлення",
        "messagingInbox": "Вхідні",
        "reviewsWidgets": "Віджети відгуків",
        "social": "Соціальні мережі",
        "socialPosts": "Публікації",
        "profile": "Профіль",
        "helpCenter": "Довідка",
        "logout": "Вийти",
        "switchAccount": "Змінити акаунт",
        "accountMenu": "Меню акаунта",
        "ordersIfood": "Замовлення",
        "campaigns": "Розсилки",
        "campaignsAutomated": "Автоматизовані",
        "campaignsOneTime": "Одноразові",
        "contacts": "Контакти",
        "presence": "Присутність",
        "presenceProfiles": "Профілі",
        "presenceMedia": "Фото та відео",
        "locations": "Локації",
        "locationsManage": "Керувати локаціями",
        "locationsProfiles": "Профілі",
        "locationsMedia": "Фото та Відео",
        "visibilityScanner": "Сканер видимості",
        "pulseAI": "Pulse AI",
        "knowledgeBase": "База знань",
        "agents": "Агенти",
        "referral": "Реферальна програма",
        "coupons": "Купони",
        "expand": "Розгорнути",
        "collapse": "Згорнути",
        "webPages": "Веб-сторінки",
        "menus": "Меню",
        "forms": "Форми",
        "campaignsLibrary": "Бібліотека"
    },
    "SignupPage": {
        "title": "Створити обліковий запис",
        "description": "Почніть керувати локаціями, відгуками та спілкуванням із клієнтами в одному кабінеті.",
        "alreadyRegistered": "Вже зареєстровані? <0>{{link}}</0>",
        "logIn": "Увійти",
        "terms": "Умовами використання,",
        "privacy": "Політикою конфіденційності",
        "dpa": "Угодою про обробку даних",
        "termsConditions": "Використовуючи Pluspoint, ви погоджуєтеся з <0>{{terms}}</0> <1>{{privacy}}</1> та <2>{{dpa}}</2>",
        "confirmationTitle": "Перевірте свою email скриньку",
        "confirmationDescription": "Ми надіслали email з підтвердженням реєстрації. Якщо вам не надійшов лист, спробуйте перевірити чи потрапив він до спаму.",
        "returnToHomepage": "Повернутися на головну",
        "signupWithGoogle": "Зареєструватися із Google",
        "signupWithGoogleCaption": "Обов'язково увімкніть всі опції, щоб отримати повну функціональність",
        "or": "або"
    },
    "Table": {
        "allOnPageSelected": "Вибрано всі {{selected}} {{entity}} на цій сторінці.",
        "selectAll": " Виберіть всі {{data}} {{entity}}",
        "allDataSelected": "Вибрано всі {{data}} {{entity}}.",
        "clearSelection": " Очистити вибір.",
        "moreThan": "більше ніж",
        "of": "з",
        "rowsPerPage": "Показувати записів"
    },
    "FeedbackToolbar": {
        "reviewsTicketToggle": "Лише відгуки без задач",
        "createTicket": "Створити задачу",
        "viewTicket": "Дивитись задачу",
        "ticketAssignedTo": "Задача призначена для:",
        "ticketStatus": "Статус задачі:",
        "completed": "Завершено",
        "empty": "Немає",
        "price": "Ціна",
        "quality": "Якість",
        "cleanliness": "Чистота",
        "communication": "Комунікація",
        "ticketDescription": "Деталі"
    },
    "AuthLayout": {
        "title": "Керуйте своєю <0>{{reputation}}</0>",
        "onlineReputation": "онлайн-репутацією",
        "block1Title": "Більше відгуків",
        "block1Description": "Автоматично отримуйте позитивні відгуки від задоволених клієнтів.",
        "block2Title": "Економія часу",
        "block2Description": "Відповідайте на відгуки, повідомлення та публікуйте новини з одного зручного кабінету.",
        "block3Title": "Зростання трафіку",
        "block3Description": "Залучайте більше трафіку, розміщуючи ваш бізнес на понад 200 платформах."
    },
    "validation": {
        "minPasswordLength": "Ваш пароль повинен мати більше 8 символів",
        "wrongPasswordFormat": "Ваш пароль повинен містити літери і цифри",
        "confirmPasswordMatch": "Пароль не співпадає, спробуйте ще раз",
        "minLength4": "Це поле повинно мати не меньше 4 символів",
        "minLength8": "Це поле повинно мати не меньше 8 символів",
        "wrongEmailFormat": "Введіть дійсну email адресу",
        "wrongFile": "Некоректний формат файлу",
        "maxLength": "Повинно мати не більше {{count}} символів",
        "trackingTagSlug": "Використовуйте малі літери, цифри та дефіси",
        "trackingTagPaidMedium": "Аналітика зарахує цей utm_medium як платний трафік",
        "trackingTagShoppingCampaign": "Аналітика зарахує цю кампанію як трафік покупок",
        "numberRange": "Введіть значення від {{min}} до {{max}}",
        "descriptionContainsUrl": "Посилання в описі заборонені",
        "hexFormat": "Повинно бути у HEX форматі",
        "onlyAlphanumericSpace": "Може містити лише літери, цифри, пробіл",
        "onlyNumbers": "Може містити лише цифри",
        "invalidURL": "Недійсна URL",
        "takenURL": "Недоступно",
        "required": "Не може бути пустим",
        "wrongPhoneFormat": "Має бути в міжнародному форматі",
        "specialHoursNeedBusinessHours": "Видаліть особливі дати або увімкніть графік роботи",
        "specialHoursDuplicateDate": "Ця дата вже є у списку. Залиште один запис на дату",
        "specialHoursReversedRange": "Проміжок часу має закінчуватися після початку",
        "duplicatePhone": "Цей номер уже є в списку",
        "timeRangeExceeded": "Інтервал часу перевищено",
        "completeAllFields": "Заповніть обов’язкові поля, щоб продовжити",
        "platformWithoutDirectCompany": "Кожна вибрана платформа потребує принаймні однієї безпосередньо підключеної локації",
        "unsupportedPlaceholders": "Непідтримуваний(і) заповнювач(і): {{tokens}}",
        "dateOfBirthOutOfRange": "Введіть дату від 1900 року, яка не в майбутньому"
    },
    "VerifyEmail": {
        "message": "Ваша email адреса не підтверджена. Ми надіслали інструкції щодо підтвердження на {{email}}. Якщо ви не отримали лист, ви можете надіслати його повторно, натиснувши <1>{{link}}</1>.",
        "link": "ПІДТВЕРДИТИ EMAIL",
        "resendSuccess": "Email успішно відправлено",
        "resendFail": "Не вдалося відправити email"
    },
    "InboxPage": {
        "sentFromWhatsAppBusinessApp": "Застосунок WhatsApp Business",
        "sentFromWhatsAppApp": "Застосунок WhatsApp",
        "sentFromMetaBusinessSuite": "Meta Business Suite",
        "sentFromExternalApp": "Зовнішній застосунок",
        "unsupportedMessage": "Це повідомлення не можна показати тут. Перегляньте його в застосунку WhatsApp Business.",
        "mediaNotImported": "Фото чи файл не імпортовано",
        "viewFullContact": "Переглянути повний контакт",
        "conversationsCount_one": "{{count}} розмова",
        "conversationsCount_few": "{{count}} розмови",
        "conversationsCount_many": "{{count}} розмов",
        "conversationsCount_other": "{{count}} розмови",
        "viewDetails": "Переглянути деталі",
        "createdAt": "Створено",
        "resolvedAt": "Вирішено",
        "pulseAgent": "Pulse",
        "views": "Перегляди",
        "myConversations": "Мої розмови",
        "allConversations": "Усі розмови",
        "moveToTeam": "Перемістити до команди",
        "moveToTeamTitle": "Перемістити до іншої команди",
        "moveToTeamDescription": "Розмова та вся її історія переміщуються разом. Інша команда отримає сповіщення.",
        "moveToTeamAssigneeKept": "{{name}} є учасником команди {{team}} і залишиться відповідальним.",
        "moveToTeamAssigneeCleared": "{{name}} не є учасником команди {{team}}. Розмова стане непризначеною та потрапить у чергу цієї команди.",
        "internalNoteOptional": "Внутрішня нотатка (необовʼязково)",
        "internalNote": "Внутрішня нотатка",
        "teamChangedBy": "{{date}} — {{name}} перемістив(ла) цю розмову з {{fromTeam}} до {{toTeam}}",
        "teamChangedAuto": "{{date}} — Розмову переміщено з {{fromTeam}} до {{toTeam}} після зміни команди каналу",
        "deletedTeam": "видаленої команди",
        "conversationAssignedToUser": "Ця розмова призначена {{name}}. Ви можете приєднатися, щоб спілкуватися з клієнтом напряму.",
        "movedToTeam": "Розмову переміщено до {{team}}",
        "allStatuses": "Усі статуси",
        "open": "Відкриті",
        "resolved": "Вирішені",
        "viewContact": "Переглянути контакт",
        "messageLabel": "Введіть своє повідомлення тут",
        "noConversations": "Немає існуючих розмов.",
        "noConversationsSelected": "Будь ласка, виберіть розмову на лівій панелі.",
        "resolvedBy": "{{date}} — Вирішена {{name}}",
        "reopenedBy": "{{date}} — Відкрита {{name}}",
        "conversationStarted": "{{date}} — Розмова розпочата",
        "download": "Завантажити",
        "resend": "Повторити",
        "emptyChannelsTitle": "Всі ваші розмови в одному місці",
        "emptyChannelsSubtitle": "Переглядайте всі розмови з клієнтами в одній панелі. Підключайте канали — від live-чату на сайті до Facebook, Instagram чи WhatsApp.",
        "emptyChannelsButton": "Підключити канали",
        "storyNotAvailable": "Історія недоступна",
        "showQuotedText": "Показати цитований текст",
        "hideQuotedText": "Сховати цитований текст",
        "mine": "Мої",
        "unassigned": "Непризначені",
        "archivedConversation": "Ця розмова з видаленого каналу. Ви не можете її відкрити знову або отримувати нові повідомлення.",
        "importedConversation": "Цю розмову імпортовано із застосунку WhatsApp Business. Ви не можете відкрити її знову; почніть нову розмову, щоб написати контакту.",
        "disconnectedChannel": "UK: Ця розмова з відключеного каналу. Будь ласка, підключіть канал у <0>{{link}}</0>.",
        "settings": "налаштуваннях",
        "liveChatVisitorUnreachable": "З цим відвідувачем не можна зв'язатися після того, як він піде. Оберіть канал для зв'язку в <0>{{link}}</0>.",
        "closedConversation": "Цю розмову завершено. Ви можете відкрити її знову, щоб продовжити спілкування з контактом.",
        "whatsApp24HoursWindow": "WhatsApp дозволяє відповідати довільним текстом лише протягом 24 годин після останнього повідомлення клієнта. Щоб відновити розмову, <0>{{link}}</0>. Ви зможете відповідати вільно, щойно клієнт напише знову.",
        "useApprovedMessage": "скористайтеся шаблоном повідомлення",
        "messagingWindowClosed": "Meta більше не приймає відповіді в цій розмові. Ви зможете відповісти, щойно клієнт напише знову.",
        "activityNewestFirst": "Активність: Спочатку найновіші",
        "activityOldestFirst": "Активність: Спочатку найстаріші",
        "createdAtNewestFirst": "Створено: Спочатку найновіші",
        "createdAtOldestFirst": "Створено: Спочатку найстаріші",
        "backToAllConversations": "Назад до всіх розмов",
        "messageDeleted": "Видалено",
        "conversationSelected_one": "{{count}} вибрано розмову",
        "conversationSelected_other": "{{count}} вибрано розмов",
        "exportInProgress": "Експорт триває. Очікуйте листа",
        "editConversations": "Редагувати розмови",
        "selectProperty": "Вибрати поле",
        "conversationAssignedOnPulse": "Цю розмову наразі веде Pulse. Приєднайтеся, щоб спілкуватися з клієнтом безпосередньо.",
        "replyTab": "Відповісти",
        "noteTab": "Нотатка",
        "notePlaceholder": "Додати внутрішню нотатку…",
        "noteVisibilityHint": "Клієнт цього ніколи не побачить",
        "noteSnippet": "Нотатка: {{text}}",
        "collaborators": "Співучасники",
        "addCollaborator": "Додати",
        "tags": "Теги",
        "addTag": "Додати",
        "createNewTag": "Створити",
        "tagNamePlaceholder": "Назва тегу",
        "deleteTagTitle": "Видалити тег?",
        "deleteTagDescription": "«{{name}}» буде видалено для всього акаунта та прибрано з усіх розмов.",
        "editTagTitle": "Редагувати тег",
        "tagColor": "Колір",
        "keepMeAsCollaborator": "Залишити мене співучасником",
        "collaborating": "Спільні розмови",
        "collaboratorReadOnly": "Ви стежите за цією розмовою як співучасник — використовуйте внутрішні нотатки",
        "bulkEditPartial": "Оновлено {{updated}} з {{total}} розмов — розмови співучасника залишаються без змін",
        "bulkEditUpdatedCount": "Оновлено {{updated}} з {{total}} розмов"
    },
    "SocialPosts": {
        "title": "Створюйте, налаштовуйте та плануйте публікації на різних платформах",
        "subtitle": "Плануйте, налаштовуйте та призначайте час соціальних публікацій для кожної підключеної локації та платформи з одного місця.",
        "editPost": "Редагувати публікацію",
        "viewPost": "Деталі публікації",
        "tableView": "Таблиця",
        "calendarView": "Календар",
        "moreCount": "+{{count}} ще",
        "rescheduleSuccess": "Допис перенесено",
        "rescheduleFail": "Не вдалося перенести допис",
        "book": "Зарезервувати",
        "orderOnline": "Замовити онлайн",
        "buy": "Купити",
        "signUp": "Зареєструватися",
        "callNow": "Зателефонувати",
        "imageFormat": "Зображення: Формат: JPG або PNG. Розмір: 10KB - 10MB. Більші зображення оптимізуються автоматично.",
        "videoFormatDynamic": "Відео: Формат: MP4. Роздільна здатність: до {{maxResolution}}. Розмір: до {{maxSize}}. Тривалість: від {{minDuration}} до {{maxDuration}}.",
        "videoConstrainedBy": "Обмеження задає {{platform}}.",
        "noMediaPreview": "Завантажте зображення або відео, щоб побачити попередній перегляд",
        "content": "Контент",
        "contentDescription": "Почніть зі спільної публікації, а потім налаштуйте контент, медіа та параметри для кожної платформи.",
        "allPlatforms": "Усі платформи",
        "customizeFor": "Налаштувати для {{platform}}",
        "media": "Медіа",
        "customized": "Налаштовано",
        "messageRequired": "Додайте повідомлення",
        "tiktokAutoAddMusic": "Автоматично додавати музику",
        "tiktokAutoAddMusicHint": "TikTok додає рекомендований звук до публікацій із зображеннями. Пізніше його можна змінити в застосунку TikTok.",
        "videoTooLongForCreator": "Довше, ніж дозволяє {{handle}} у TikTok (макс. {{limit}})",
        "tiktok": {
            "loadingCreatorInfo": "Завантаження налаштувань акаунта TikTok…",
            "cannotPostNow": "TikTok зараз не приймає публікації від {{handle}}. Спробуйте пізніше.",
            "creatorInfoFailed": "Не вдалося завантажити налаштування акаунта TikTok.",
            "retry": "Повторити",
            "privacy": "Хто може переглядати цю публікацію",
            "privacyHint": "Варіанти надходять із підключених акаунтів.",
            "privacyLevels": {
                "PUBLIC_TO_EVERYONE": "Усі",
                "MUTUAL_FOLLOW_FRIENDS": "Друзі",
                "FOLLOWER_OF_CREATOR": "Підписники",
                "SELF_ONLY": "Лише я"
            },
            "privacyNoCommonOption": "Ці акаунти TikTok не мають спільного варіанта приватності. Приберіть {{handle}} або заплануйте окремо.",
            "privacyNoCommonOptionAny": "Ці акаунти TikTok не мають спільного варіанта приватності. Заплануйте їх окремо.",
            "privacyChooseAgain": "Виберіть, хто може переглядати цю публікацію.",
            "interactions": "Дозволити глядачам",
            "allowComment": "Коментувати",
            "allowDuet": "Дует",
            "allowStitch": "Stitch",
            "interactionDisabled": "Вимкнено в налаштуваннях TikTok {{handle}}",
            "interactionDisabledForSome": "{{handle}} вимкнув це в TikTok, тому його публікація вийде без цієї опції.",
            "commercial": "Позначити комерційний контент",
            "commercialHint": "Увімкніть, якщо ця публікація рекламує ваш бізнес, бренд, товар або послугу.",
            "yourBrand": "Ваш бренд",
            "brandedContent": "Брендований контент",
            "labelPromotional": "Ваше {{media}} буде позначено як 'Рекламний контент'",
            "labelPaidPartnership": "Ваше {{media}} буде позначено як 'Платне партнерство'",
            "mediaWordVideo": "відео",
            "mediaWordPhoto": "фото",
            "commercialIncomplete": "Потрібно вказати, чи ваш контент рекламує вас, третю сторону або обох.",
            "brandedNotPrivate": "Видимість брендованого контенту не може бути приватною.",
            "consent": "Публікуючи, ви погоджуєтеся з <musicLink>Music Usage Confirmation</musicLink> TikTok",
            "consentBranded": "Публікуючи, ви погоджуєтеся з <bcLink>Branded Content Policy</bcLink> та <musicLink>Music Usage Confirmation</musicLink> TikTok",
            "processingNote": "TikTok може показати публікацію в профілі лише через кілька хвилин після публікації.",
            "publishingTooltip": "TikTok обробляє цю публікацію. Вона може з'явитися в профілі через кілька хвилин.",
            "unauditedBanner": "У цьому середовищі можна публікувати лише приватні публікації TikTok.",
            "noTikTokLocation": "Виберіть локацію з підключеним акаунтом TikTok.",
            "noCreators": "Жодна з вибраних локацій зараз не може публікувати в TikTok.",
            "reconnectAccount": "Повторно підключіть {{handle}} у Налаштуваннях, Інтеграції, перш ніж планувати.",
            "thisAccount": "цей акаунт TikTok",
            "chooseAccount": "Виберіть, який акаунт TikTok публікує для цієї локації, у профілі локації."
        },
        "messageTooLong": "Повідомлення перевищує обмеження в {{count}} символів для цієї платформи",
        "mediaRequired": "Для цієї платформи потрібно щонайменше одне зображення або відео",
        "videoTooLarge": "Відео перевищує ліміт розміру {{limit}} для цієї платформи",
        "videoTooLong": "Відео перевищує ліміт тривалості {{limit}} для цієї платформи",
        "videoTooSmall": "Відео менше за мінімальний розмір {{limit}} для цієї платформи",
        "videoTooLargeSummary": "Відео завелике для: {{platforms}}",
        "videoTooLongSummary": "Відео задовге для: {{platforms}}",
        "videoTooSmallSummary": "Відео замале для: {{platforms}}",
        "checkingVideoLength": "Перевіряємо тривалість відео…",
        "mediaRules": {
            "google": "Максимум одне зображення. Відео не підтримується.",
            "facebook": "Максимум одне відео або до 10 зображень (без змішування).",
            "instagram": "До 10 зображень або відео. Медіа обов'язкове.",
            "tiktok": "Максимум одне відео або до 35 зображень (без змішування). Деякі облікові записи TikTok дозволяють коротші відео, ніж зазначено.",
            "x": "Максимум одне відео або до 4 зображень (без змішування).",
            "facebookStory": "Рівно одне зображення або відео. Рекомендовано 9:16.",
            "instagramStory": "Рівно одне зображення або відео. Рекомендовано 9:16. Зображення конвертуються в JPEG."
        },
        "retry": "Повторити",
        "openPublishedPost": "Переглянути допис",
        "storyMediaOnlyNotice": "Історії публікують лише медіа — текст в історії не з'явиться.",
        "storyAspectWarning": "Це медіа не у форматі 9:16 — {{platform}} обріже його.",
        "storyExpiry": "Переглянути історію (історії зникають через 24 години після публікації)",
        "storyExpired": "Ця історія завершилася — посилання може більше не працювати",
        "queued": "У черзі",
        "removedExternally": "Видалено на платформі",
        "cancelPost": "Скасувати допис",
        "cancelPostTitle": "Скасувати цей допис?",
        "cancelPostDescription": "Цей допис не буде опубліковано.",
        "deletePostTitle": "Видалити цей допис?",
        "deletePostDescription": "Опублікований допис буде видалено з платформи. Цю дію не можна скасувати.",
        "preview": {
            "emptyHint": "Виберіть платформи та локації, потім додайте повідомлення або медіа для попереднього перегляду",
            "seeMore": "Показати більше",
            "like": "Подобається",
            "comment": "Коментувати",
            "share": "Поділитися",
            "more": "більше",
            "likesPlaceholder": "Подобається вашим підписникам",
            "tiktokSound": "Оригінальний звук",
            "storyHint": "Попередній перегляд 9:16 · лише медіа"
        },
        "videoTooWide": "Відео перевищує максимум {{width}}×{{height}} для цієї платформи",
        "videoTooWideSummary": "Роздільна здатність відео зависока для: {{platforms}}"
    },
    "PostDynamicVariables": {
        "title": "Динамічні змінні"
    },
    "UpdateLocations": {
        "title": "Імпорт локацій",
        "subtitle": "Оновлення або створення локацій за допомогою CSV-файлу.",
        "list1Title": "Завантажити шаблон",
        "list1Description": "Завантажте шаблон з існуючими локаціями",
        "list2Title": "Завантажити файл",
        "list2Description": "Завантажте файл. Вкажіть Location ID, щоб оновити існуючу локацію, або залиште поле порожнім, щоб створити нову.",
        "locationsToUpdate": "Оновлених локацій",
        "locationsToAdd": "Локацій для додавання",
        "dataVerificationDescription": "Перегляньте розібрані локації. Рядки «Нова» створять нову локацію; рядки «Оновлення» оновлять існуючу.",
        "showAddress": "Показати адресу",
        "featuredMessage": "Виділене повідомлення",
        "featuredMessageUrl": "URL виділеного повідомлення",
        "showHours": "Показати години",
        "importButton": "Імпортувати {{amount}} локацій",
        "quotaExceeded": "Додавання {{count}} нових локацій перевищує ліміт {{available}}."
    },
    "ImportValidationTable": {
        "showErrorsOnly": "Показати лише помилки",
        "showErrorsOnlyCount": "Показати лише помилки ({{count}} елемент(ів))"
    },
    "BulkEditLocations": {
        "notUpdated": "{{count}} з {{total}} локацій не оновлено:",
        "title": "Масове редагування локацій",
        "subtitle": "Редагуйте кілька локацій одночасно. Зміни будуть застосовані до всіх вибраних локацій.",
        "applyToLocations": "Застосувати до {{count}} локації(й)",
        "services": "Послуги",
        "socialLinkPlatform": "Соціальне посилання: {{platform}}"
    },
    "AIAssistant": {
        "translate": "Перекласти",
        "english": "Англійська",
        "spanish": "Іспанська",
        "portuguese": "Португальська",
        "french": "Французька",
        "german": "Німецька",
        "italian": "Італійська",
        "russian": "Російська",
        "ukrainian": "Українська",
        "polish": "Польська",
        "changeTone": "Змінити тон",
        "professional": "Професійний",
        "friendly": "Дружній",
        "fixGrammar": "Виправити граматику",
        "makeShoter": "Скоротити",
        "makeLonger": "Зробити довшим",
        "writeResponse": "Написати відповідь",
        "writeTemplate": "Написати шаблон",
        "writePost": "Написати пост",
        "optimizeForPlatform": "Оптимізувати для {{platform}}",
        "writeCampaign": "Написати кампанію",
        "writeReply": "Написати відповідь",
        "writeDescription": "Написати опис"
    },
    "industry": {
        "Automotive": "Автомотів",
        "BeautySpaAndSalon": "Краса, спа та салони",
        "ClothingAndApparel": "Одяг та текстиль",
        "Education": "Освіта",
        "Entertainment": "Розваги",
        "EventPlanningAndService": "Концертні заходи",
        "FinanceAndBanking": "Фінанси та банківські послуги",
        "FoodAndGrocery": "Харчування та продукти",
        "Pharmacy": "Аптеки",
        "PublicService": "Державні послуги",
        "HotelAndLodging": "Готелі",
        "HealthcareAndDental": "Медицина та стоматології",
        "ProfessionalServices": "Професійні послуги",
        "ShoppingAndRetail": "Роздрібна торгівля",
        "TravelAndTransportation": "Подорожі та транспортування",
        "Restaurant": "Кафе і ресторани",
        "Veterinary": "Ветеринарні клініки",
        "WellnessAndFitness": "Здоровʼя і фітнес",
        "Other": "Інші"
    },
    "themes": {
        "amenities": "Зручності",
        "atmosphere": "Атмосфера",
        "availability": "Наявність",
        "billing": "Виставлення рахунків",
        "check-in/out": "Заселення/виселення",
        "checkout": "Оформлення покупки",
        "cleanliness": "Чистота",
        "communication": "Комунікація",
        "delivery": "Доставка",
        "experience": "Досвід",
        "expertise": "Компетентність",
        "facilities": "Приміщення",
        "food": "Їжа",
        "location": "Розташування",
        "menu": "Меню",
        "noise": "Шум",
        "policies": "Правила",
        "pricing": "Ціни",
        "products": "Товари",
        "quality": "Якість",
        "quality of care": "Якість обслуговування",
        "results": "Результати",
        "rooms": "Номери",
        "scheduling": "Запис",
        "service": "Обслуговування",
        "staff": "Персонал",
        "transparency": "Прозорість",
        "treatment": "Лікування",
        "value": "Ціна/якість",
        "wait time": "Час очікування"
    },
    "ProfilesPage": {
        "title": "Покращуйте локальне SEO",
        "titleGoogle": "Увімкніть Google для повної синхронізації профілів",
        "titleFreemium": "Оновіться до повної локальної видимості",
        "subtitleFreemium": "Публікуйте та синхронізуйте свої локації в Apple Maps, Bing, ChatGPT і понад 200 провідних платформах та навігаційних сервісах із Pluspoint Starter. Точні та актуальні профілі підсилюють локальне SEO й довіру з боку AI-асистентів.",
        "subtitleGoogle": "Підключіть обліковий запис Google, щоб синхронізувати всі дані профілів, зокрема локації, години роботи, фото та оновлення. Без інтеграції з Google частина інформації може бути неповною або застарілою.",
        "subtitle": "Публікуйте та синхронізуйте профілі вашого бізнесу на 100+ каталогах, картах і пошукових платформах. Узгоджені профілі підвищують вашу видимість для клієнтів, пошукових систем та AI-асистентів.",
        "profiles": "Профілі",
        "profileInformation": "Інформація про профіль",
        "syncStatus": "Стан синхронізації",
        "synced": "Синхронізовано",
        "syncStarted": "Синхронізацію розпочато",
        "syncCompleted": "Синхронізацію завершено",
        "lastSynced": "Остання синхронізація",
        "lastChecked": "Остання перевірка",
        "details": "Деталі",
        "detailsConflictIntegration_one": "{{count}} поле відрізняється між Pluspoint та {{platform}}. Оберіть, які значення залишити, щоб вирішити конфлікт.",
        "detailsConflictIntegration_few": "{{count}} поля відрізняються між Pluspoint та {{platform}}. Оберіть, які значення залишити, щоб вирішити конфлікт.",
        "detailsConflictIntegration_many": "{{count}} полів відрізняються між Pluspoint та {{platform}}. Оберіть, які значення залишити, щоб вирішити конфлікт.",
        "detailsConflictIntegration_other": "{{count}} полів відрізняються між Pluspoint та {{platform}}. Оберіть, які значення залишити, щоб вирішити конфлікт.",
        "detailsConflictScanner_one": "{{count}} поле відрізняється між Pluspoint та {{platform}}. Опублікуйте, щоб оновити профіль.",
        "detailsConflictScanner_few": "{{count}} поля відрізняються між Pluspoint та {{platform}}. Опублікуйте, щоб оновити профіль.",
        "detailsConflictScanner_many": "{{count}} полів відрізняються між Pluspoint та {{platform}}. Опублікуйте, щоб оновити профіль.",
        "detailsConflictScanner_other": "{{count}} полів відрізняються між Pluspoint та {{platform}}. Опублікуйте, щоб оновити профіль.",
        "detailsNotFound": "Не з'являється на {{platform}}. Опублікуйте, щоб клієнти могли вас знайти.",
        "detailsNotVerified": "Профіль на {{platform}} не верифіковано. Верифікуйте, щоб керувати цим профілем.",
        "detailsDisconnected": "{{platform}} відключено. Повторно підключіть, щоб відновити синхронізацію.",
        "detailsSynced": "Усі ключові поля збігаються з джерелом істини Pluspoint.",
        "detailsSyncedWithConflicts_one": "Профіль синхронізовано, але {{count}} поле ігнорується.",
        "detailsSyncedWithConflicts_few": "Профіль синхронізовано, але {{count}} поля ігноруються.",
        "detailsSyncedWithConflicts_many": "Профіль синхронізовано, але {{count}} полів ігноруються.",
        "detailsSyncedWithConflicts_other": "Профіль синхронізовано, але {{count}} полів ігноруються.",
        "detailsDisabled": "Синхронізацію вимкнено для цього профілю.",
        "resolveTitle": "Вирішення конфліктів",
        "resolveSubtitle": "Вирішить конфлікти профілів вибираючи коректну інформацію",
        "syncSuccessMessage": "Синхронізація триває. Ви можете продовжувати користуватися системою.",
        "noAddress": "Немає адреси",
        "field": "Поле",
        "ignore": "Ігнорувати",
        "openProfile": "Відкрити профіль",
        "usePlatformValue": "Використати дані {{source}}",
        "updatePlatformToMatch": "Оновити {{target}} відповідно до {{source}}",
        "noChangesWillBeMade": "Зміни не буде застосовано",
        "restrictedFieldHint": "{{source}} не дозволяє оновлювати це поле з Pluspoint. Оновіть його безпосередньо в {{source}} або використайте значення {{source}}.",
        "noHoursToSendHint": "{{source}} не може показати сторінку без годин роботи, тому надсилати нічого. Використайте значення {{source}} або проігноруйте це поле.",
        "noCoverToSendHint": "У цієї локації немає обкладинки, тому надсилати нічого. Використайте значення {{source}} або проігноруйте це поле.",
        "descriptionContainsUrlHint": "Google не дозволяє посилання в описі бізнесу. Видаліть посилання, щоб синхронізувати його.",
        "rejectedFieldHint": "{{source}} відхилив це значення ({{reasons}}). Виправте його в Pluspoint і повторіть спробу.",
        "socialLinkedElsewhere": "Цей профіль соцмережі вже підключено до іншої локації. Щоб використовувати його у ваших локаціях, поділіться ним з локації, до якої він підключений.",
        "titleScanner": "Огляд вашої онлайн-присутності",
        "subtitleScanner": "Перевірте, де ваша компанія з’являється в каталогах. Опублікуйте, щоб виправити неточності та потрапити в усі каталоги.",
        "notPublished": "Профіль не знайдено",
        "publishAction": "Опублікувати",
        "upgradeToPublish": "Оновіть план, щоб опублікувати ваші записи",
        "upgradeToPublishDescription": "Керуйте інформацією про компанію у понад 100 каталогах, оновивши до плану Starter.",
        "upgradeToPublishAll": "Оновити, щоб опублікувати всі",
        "listingIssuesFound_one": "{{count}} проблема з лістингами потребує уваги",
        "listingIssuesFound_other": "{{count}} проблем з лістингами потребують уваги",
        "listingIssuesDescription": "Відсутні лістинги та неправильні контактні дані знижують позиції в локальному пошуку. Додайте Локальні каталоги до локації, щоб виправити їх і тримати синхронізованими автоматично.",
        "detailsNotFoundScanner": "Не опубліковано на {{platform}} — оформіть підписку для автоматичної публікації"
    },
    "ProfilesMedia": {
        "exterior": "Екстер'єр",
        "interior": "Інтер'єр",
        "product": "Продукт",
        "atWork": "На роботі",
        "foodAndDrink": "Їжа та напої",
        "menu": "Меню",
        "commonArea": "Загальна зона",
        "rooms": "Кімнати",
        "teams": "Команди",
        "authorName": "Автор",
        "profileName": "Профіль",
        "locationsNames": "Локації",
        "categoryName": "Категорія",
        "viewCount": "Перегляди",
        "createdAt": "Дата публікації",
        "reportedAt": "Дата скарги",
        "viewContent": "Переглянути контент",
        "uploadPhotos": "Завантажити фотографії",
        "photosFormat": "Формат: JPG або PNG. Розмір: 10 КБ - 5 МБ. Мінімальна роздільна здатність: 720p у висоту, 720p у ширину."
    },
    "IntegrationRequired": {
        "title": "Необхідна інтеграція",
        "subtitleGoogle": "Щоб активувати цю функціональність, будь ласка, підключіть ваш обліковий запис Pluspoint до Google My Business",
        "subtitleCommon": "Щоб активувати цю функціональність, будь ласка, підключіть ваш обліковий запис Pluspoint до Google My Business або Facebook"
    },
    "KnowledgeBase": {
        "title": "Зробіть Pulse розумнішим завдяки вашим знанням",
        "subtitle": "Додавайте статті до його бази знань, щоб надати йому необхідні відповіді. Від поширених запитань до детальних інструкцій — ваш контент допомагає Pulse давати точні та корисні відповіді клієнтам.",
        "editContent": "Редагувати контент",
        "agents": "Агенти",
        "limitToLocations": "Обмежити конкретними локаціями",
        "items": "елементи контенту",
        "itemsSelected": "Вибрано елементів контенту: {{count}}",
        "faq": "Поширені запитання",
        "document": "Документ",
        "website": "Вебсайт",
        "addFaq": "Додати поширене запитання",
        "addDocument": "Додати документ",
        "addWebsite": "Додати вебсайт",
        "dropFileOr": "Перетягніть файл сюди або",
        "browse": "виберіть його",
        "acceptedFiles": "PDF, Word, Excel, CSV, PowerPoint, текст, Markdown або зображення. До {{size}} {{metric}}, PDF до {{pages}} сторінок, аркуш до {{rows}} рядків.",
        "processing": "Обробляється",
        "ready": "Готово",
        "failed": "Помилка",
        "processingFailed": "Не вдалося обробити файл",
        "websitePlaceholder": "help.example.com або example.com/help",
        "invalidWebsite": "Введіть домен, зі шляхом або без нього, наприклад help.example.com або example.com/help",
        "documentsAtLimit": "Документи досягли ліміту",
        "websitesAtLimit": "Вебсайти досягли ліміту"
    },
    "Agents": {
        "title": "Налаштуйте Pulse під ваш бізнес",
        "subtitle": "Налаштуйте Pulse відповідно до потреб вашої компанії. Створюйте агентів ШІ для різних каналів і локацій, налаштовуючи їхню поведінку, щоб кожна взаємодія з клієнтом отримувала правильну відповідь.",
        "editAgent": "Редагувати агента",
        "activateAgent": "Активувати агента",
        "schedule": "Розклад",
        "answerOutsideBusinessHours": "Відповідати лише поза робочими годинами",
        "activeInBusinessHours": "Активний · Робочі години",
        "contactDetailsDescription": "Виберіть, які контактні дані Pulse має запитувати у клієнтів.",
        "autoCloseTitle": "Покинуті розмови",
        "autoCloseDescription": "Виберіть, як Pulse має обробляти покинуті розмови після певного періоду неактивності.",
        "timeOfClientInactivity": "Час неактивності клієнта перед виконанням дії:",
        "closeConversation": "Закрити розмову",
        "changeToUnassigned": "Змінити на Не призначену",
        "doNothing": "Нічого не робити",
        "conversationHandoff": "Передача розмови",
        "conversationHandoffDescription": "Визначте, як має діяти Pulse, якщо він не може відповісти на запитання або якщо клієнт просить з'єднати з оператором.",
        "conversationHandoffSwitch": "Змінити на Не призначену",
        "handoffResponseTime": "Очікуваний час відповіді",
        "fewMinutes": "Кілька хвилин",
        "withinHour": "Протягом години",
        "fewHours": "Кілька годин",
        "withinDay": "Протягом дня",
        "within2Days": "Протягом 2 днів",
        "notTransferConversationSwitch": "Не передавати розмову",
        "channelTakenByAgent": "Канал вже призначено іншому агенту",
        "customInstructions": "Індивідуальні інструкції",
        "customInstructionsDescription": "Додайте індивідуальні інструкції, яких має дотримуватися агент Pulse AI під час взаємодії з клієнтами.",
        "playgroundAssignContent": "Призначте цьому агенту контент бази знань, щоб почати тестування в пісочниці.",
        "playgroundSaveAgentFirst": "Збережіть агента та призначте йому контент бази знань, щоб почати тестування в пісочниці."
    },
    "InitConversation": {
        "recipient": "Одержувач",
        "newConversation": "Нова розмова",
        "viewConversation": "Переглянути розмову",
        "conversationExistsTitle": "Знайдено відкриту розмову",
        "conversationExistsDescription": "Ви вже маєте відкриту розмову з цим контактом через ту саму локацію та канал. Що бажаєте зробити?",
        "resolveConversation": "Вирішити розмову",
        "goToConversation": "Перейти до розмови"
    },
    "CouponsPage": {
        "title": "Розумні купони для підвищення лояльності та продажів",
        "subtitle": "Створюйте та поширюйте спеціальні пропозиції, щоб винагородити задоволених клієнтів, вирішити проблеми або збільшити продажі. Налаштовуйте знижки, безкоштовні товари та правила використання для різних локацій.",
        "createNewCoupon": "Створити новий купон",
        "createCoupon": "Створити купон",
        "viewCoupon": "Переглянути купон",
        "editCoupon": "Редагувати купон",
        "activateCoupon": "Активувати купон",
        "offerType": "Тип пропозиції",
        "percentageOff": "Знижка у відсотках",
        "amountOff": "Знижка у грошовому еквіваленті",
        "freeItem": "Безкоштовний товар",
        "minimumOrderValue": "Мін. замовлення",
        "offerSchedule": "Розклад пропозиції",
        "offerAndDate": "Дата завершення пропозиції",
        "setFinalIssueDate": "Встановіть останній день, коли купон можна використати.",
        "redemptionPeriod": "Період використання",
        "periodOfValidity": "Скільки днів після видачі купон залишається дійсним.",
        "redemptionPeriodDays": "Період використання (днів)",
        "waitPeriod": "Період очікування",
        "setDelay": "Встановіть затримку перед можливістю використання купона.",
        "waitPeriodHours": "Період очікування (годин)",
        "activationPinCode": "ПІН-код активації",
        "requireStaffForPin": "Вимагати введення ПІН-коду персоналом для підтвердження використання",
        "redeemed": "Використано {{title}}",
        "defaultMessage": "Повідомлення за замовчуванням",
        "issuedCount": "Видано",
        "redeemedCount": "Використано"
    },
    "paymentMethod": {
        "cash": "Готівка",
        "visa": "Visa",
        "mastercard": "Mastercard",
        "applePay": "Apple Pay",
        "androidPay": "Android Pay",
        "paypal": "PayPal",
        "americanExpress": "American Express",
        "discover": "Discover",
        "invoice": "Банківський переказ",
        "bitcoin": "Bitcoin",
        "travelersCheck": "Traveler's Check",
        "dinersClub": "Diners Club",
        "insurance": "Страхування"
    },
    "Paywall": {
        "whatYouGet": "Що ви отримуєте:",
        "unlockThis": "Відкрийте це та багато іншого з Pluspoint Professional.",
        "titleCoupons": "Купони, що формують лояльність і повертають клієнтів",
        "subtitleCoupons": "Заохочуйте клієнтів і давайте їм вагому причину повернутися знову. Купони допомагають повернути незадоволених клієнтів, мотивувати залишати відгуки та перетворювати інтерес на реальні продажі.",
        "proposal1Coupons": "Гнучкі формати купонів: безкоштовні позиції, відсоткові або фіксовані знижки",
        "proposal2Coupons": "Вбудовану аналітику для відстеження використання, ефективності та ROI",
        "proposal3Coupons": "Зручні для мобільних пристроїв інтерактивні купони для швидкого використання та високої конверсії",
        "proposal4Coupons": "Без інтеграції з POS — легко запустити та просто керувати",
        "titleCampaigns": "Розсилки, що стимулюють повторні покупки",
        "subtitleCampaigns": "Надсилайте повідомлення клієнтам у правильний момент через канали, якими вони справді користуються. Налаштовуйте регулярні розсилки, запускайте разові акції та довірте AI обробку відповідей, щоб спілкування не переривалося.",
        "proposal1Campaigns": "Автоматизовані та разові розсилки, налаштовані під ваші цілі",
        "proposal2Campaigns": "Розумну сегментацію на основі даних і поведінки клієнтів",
        "proposal3Campaigns": "Комунікацію через кілька каналів: SMS, email і WhatsApp",
        "proposal4Campaigns": "AI-підтримку для обробки відповідей і ведення діалогів",
        "titleSurveys": "Опитування, що перетворюють відгуки на зростання",
        "subtitleSurveys": "Зробіть зворотний зв’язок частиною щоденної роботи. Автоматизуйте збір відгуків, швидко реагуйте на проблеми та отримуйте більше публічних відгуків від клієнтів із позитивним досвідом.",
        "proposal1Surveys": "Автоматизовані опитування через повідомлення, email, WhatsApp і QR-коди",
        "proposal2Surveys": "Раннє виявлення проблем і своєчасне реагування на скарги",
        "proposal3Surveys": "Більше відгуків від задоволених клієнтів",
        "proposal4Surveys": "Відстеження NPS для вимірювання лояльності та динаміки з часом",
        "titleAutoReplies": "Автоматичні відповіді, яким справді можна довіряти",
        "subtitleAutoReplies": "Відповідайте на кожен відгук швидко й послідовно, без відчуття шаблонності. AI формує персональні відповіді, а ви зберігаєте повний контроль над тоном, правилами та нестандартними кейсами.",
        "proposal1AutoReplies": "AI-відповіді, що звучать природно й персонально",
        "proposal2AutoReplies": "Розумну логіку з урахуванням оцінки та наявності коментаря",
        "proposal3AutoReplies": "Гнучкі AI інструкції для відповідності голосу бренду та політикам",
        "proposal4AutoReplies": "Шаблони відповідей для повного контролю",
        "upgradeForCustomerRating": "Перейдіть на вищий тариф, щоб збирати оцінки клієнтів",
        "upgradeForCustomerRatingDescription": "Скеруйте задоволених клієнтів залишити відгук, а незадоволених — на приватний фідбек.",
        "upgradeForCustomQuestions": "Перейдіть на вищий тариф, щоб додати власні запитання",
        "upgradeForCustomQuestionsDescription": "Додайте до своїх опитувань запитання з оцінкою, вибором із варіантів і відкритими відповідями.",
        "upgradeForSendSurveys": "Перейдіть на вищий тариф, щоб надсилати опитування",
        "upgradeForSendSurveysDescription": "Надсилайте опитування контактам через email або SMS, з нагадуваннями й follow-up повідомленнями."
    },
    "GoogleVerification": {
        "title": "Підтвердження профілю Google Business",
        "verifyOnGoogle": "Підтвердити на Google Business",
        "selectMethod": "Оберіть метод підтвердження",
        "PHONE_CALL": "Телефонний дзвінок",
        "SMS": "SMS",
        "EMAIL": "Електронна пошта",
        "ADDRESS": "Листівка (пошта)",
        "VETTED_PARTNER": "Підтвердження через партнера Google",
        "AUTO": "Автоматичне підтвердження",
        "pinSent": "Google надіслав вам код підтвердження.",
        "pinSentTo": "Код підтвердження надіслано на",
        "pinPlaceholder": "Код підтвердження",
        "postcardMailed": "Google надіслав листівку на адресу вашої компанії.",
        "postcardMailedOn": "Google надіслав листівку на адресу вашої компанії {{date}}.",
        "postcardArrives": "Доставка займе близько {{days}} днів.",
        "postcardComeBack": "Поверніться та введіть код, коли він надійде.",
        "postcardTo": "Листівку буде надіслано на",
        "checkInProgress": "Google перевіряє цей профіль. Профіль буде оновлено після завершення.",
        "lastAttemptFailed": "Ваша попередня спроба ({{method}}) не завершилася.",
        "lastAttemptFailedOn": "Ваша попередня спроба ({{method}}), створена {{date}}, не завершилася.",
        "pinSentOn": "Код підтвердження надіслано {{date}}.",
        "pendingStillOpen": "Підтвердження через {{method}} усе ще відкрите. Обрання іншого способу почне нове.",
        "pendingStillOpenOn": "Підтвердження через {{method}}, створене {{date}}, усе ще відкрите. Обрання іншого способу почне нове.",
        "latestLookupFailed": "Не вдалося перевірити, чи вже триває підтвердження, тому нове може його дублювати.",
        "verificationComplete": "Профіль підтверджено. Запис оновиться за мить.",
        "verificationFailed": "Це підтвердження не завершилося. Спробуйте ще раз або виберіть інший спосіб.",
        "mailboxName": "Назва скриньки",
        "resendPostcard": "Надіслати нову листівку",
        "useAnotherMethod": "Використати інший метод"
    },
    "exports": {
        "exporting": "Експорт даних...",
        "ready": "Експорт готовий",
        "failed": "Помилка експорту"
    },
    "importLoading": {
        "connectingGoogle": "Підключення до вашого облікового запису Google...",
        "fetchingDetails": "Отримання деталей локацій...",
        "settingUp": "Налаштування ваших локацій...",
        "almostDone": "Майже готово, ще трохи...",
        "progress": "Імпортовано {{current}} з {{total}} локацій"
    },
    "MenusPage": {
        "title": "Усі меню ваших закладів в одному місці",
        "subtitle": "Створюйте та оновлюйте меню в одному місці й публікуйте їх на мікросайтах і в профілі Google Business. Підтримуйте актуальність страв, цін і фото в усіх ваших закладах.",
        "createMenu": "Створити меню",
        "importWithAi": "Імпортувати з ШІ",
        "importButton": "Імпортувати",
        "importModalDescription": "Завантажте наявне меню — PDF, фото, таблицю чи документ — і ШІ перетворить його на чернетку меню, яку можна переглянути та відредагувати.",
        "importDropFiles": "Перетягніть файли сюди або натисніть, щоб вибрати",
        "importTooManyFiles": "Можна завантажити до {{count}} файлів",
        "importReadingFiles": "Читаємо ваші файли...",
        "importExtractingItems": "Видобуваємо розділи та страви...",
        "importFetchingImages": "Імпортуємо фото страв...",
        "importAlmostDone": "Майже готово, ще трохи...",
        "editMenu": "Редагувати меню",
        "modalTitle": "Меню",
        "builder": "Конструктор меню",
        "internalName": "Внутрішня назва",
        "internalNameHint": "Видно лише вашій команді",
        "cuisines": "Кухні",
        "locations": "Локації",
        "menuLocalization": "Назва та опис меню",
        "duplicate": "Дублювати",
        "sections": "Розділи",
        "addSection": "Додати розділ",
        "itemsCount": "страв",
        "items": "Страви",
        "publishedOnGoogle": "Опубліковано в Google",
        "untitledSection": "Розділ без назви",
        "addItem": "Додати страву",
        "item": "Страва",
        "untitledItem": "Страва без назви",
        "itemName": "Назва страви",
        "itemPhoto": "Фото страви",
        "itemPhotoFormat": "Формат: JPG або PNG. Розмір: до 10МБ.",
        "price": "Ціна",
        "additionalAttributes": "Додаткові атрибути",
        "addItemOptions": "Додати варіанти страви",
        "option": "Варіант",
        "untitledMenu": "Меню",
        "previewEmpty": "Додайте розділи та страви, щоб побачити попередній перегляд меню.",
        "spiciness": "Гострота",
        "allergens": "Алергени",
        "dietaryRestrictions": "Дієтичні обмеження",
        "preparationMethods": "Способи приготування",
        "ingredients": "Інгредієнти",
        "portionQuantity": "Кількість у порції",
        "portionUnit": "Одиниця порції (напр. шматочки, унції)",
        "servesNumPeople": "Кількість осіб",
        "calories": "Калорії",
        "nutrition": {
            "totalFat": "Жири",
            "cholesterol": "Холестерин",
            "sodium": "Натрій",
            "totalCarbohydrate": "Вуглеводи",
            "protein": "Білки"
        },
        "units": {
            "GRAM": "g",
            "MILLIGRAM": "mg"
        },
        "cuisineValues": {
            "AMERICAN": "Американська",
            "ASIAN": "Азійська",
            "BRAZILIAN": "Бразильська",
            "BREAK_FAST": "Сніданки",
            "BRUNCH": "Бранч",
            "CHICKEN": "Курка",
            "CHINESE": "Китайська",
            "FAMILY": "Сімейна",
            "FAST_FOOD": "Фастфуд",
            "FRENCH": "Французька",
            "GREEK": "Грецька",
            "GERMAN": "Німецька",
            "HAMBURGER": "Гамбургери",
            "INDIAN": "Індійська",
            "INDONESIAN": "Індонезійська",
            "ITALIAN": "Італійська",
            "JAPANESE": "Японська",
            "KOREAN": "Корейська",
            "LATIN_AMERICAN": "Латиноамериканська",
            "MEDITERRANEAN": "Середземноморська",
            "MEXICAN": "Мексиканська",
            "PAKISTANI": "Пакистанська",
            "PIZZA": "Піца",
            "SEAFOOD": "Морепродукти",
            "SPANISH": "Іспанська",
            "SUSHI": "Суші",
            "THAI": "Тайська",
            "TURKISH": "Турецька",
            "VEGETARIAN": "Вегетаріанська",
            "VIETNAMESE": "В'єтнамська",
            "OTHER_CUISINE": "Інша"
        },
        "spicinessValues": {
            "MILD": "М'яка",
            "MEDIUM": "Середня",
            "HOT": "Гостра"
        },
        "allergenValues": {
            "DAIRY": "Молочні продукти",
            "EGG": "Яйця",
            "FISH": "Риба",
            "PEANUT": "Арахіс",
            "SHELLFISH": "Молюски",
            "SOY": "Соя",
            "TREE_NUT": "Горіхи",
            "WHEAT": "Пшениця"
        },
        "dietaryValues": {
            "HALAL": "Халяль",
            "KOSHER": "Кошерне",
            "ORGANIC": "Органічне",
            "VEGAN": "Веганське",
            "VEGETARIAN": "Вегетаріанське"
        },
        "preparationValues": {
            "BAKED": "Запечене",
            "BARBECUED": "Барбекю",
            "BASTED": "Поливане соусом",
            "BLANCHED": "Бланшоване",
            "BOILED": "Варене",
            "BRAISED": "Тушковане",
            "CODDLED": "Томлене",
            "FERMENTED": "Ферментоване",
            "FRIED": "Смажене",
            "GRILLED": "Гриль",
            "KNEADED": "Вимішане",
            "MARINATED": "Мариноване",
            "PAN_FRIED": "Смажене на пательні",
            "PICKLED": "Квашене",
            "PRESSURE_COOKED": "Приготоване під тиском",
            "ROASTED": "Печене",
            "SAUTEED": "Соте",
            "SEARED": "Обсмажене",
            "SIMMERED": "Томлене на повільному вогні",
            "SMOKED": "Копчене",
            "STEAMED": "На пару",
            "STEEPED": "Настояне",
            "STIR_FRIED": "Смажене у воку",
            "OTHER_METHOD": "Інше"
        },
        "issuesTitle": "Щоб зберегти меню, заповніть наступне:",
        "issueInternalName": "Додайте внутрішню назву",
        "issueName": "Додайте назву",
        "issueNameLength": "Назва не має перевищувати 140 символів",
        "issueDescriptionLength": "Опис не має перевищувати 1000 символів",
        "issueIngredientsLength": "Кожен список інгредієнтів не має перевищувати 5000 символів",
        "issueCurrency": "Оберіть валюту",
        "issueLocations": "Призначте принаймні одну локацію",
        "issueSections": "Додайте принаймні один розділ",
        "issueSectionNames": "Назвіть кожен розділ",
        "issueSectionItems": "Кожен розділ має містити принаймні одну страву",
        "issueItemNames": "Назвіть кожну страву",
        "issueItemPrices": "Вкажіть ціну для кожної страви",
        "issueOptionNames": "Назвіть кожен варіант",
        "showOnGoogle": "Показувати в Google Business Profile",
        "showOnGoogleHint": "Поки ввімкнено, це меню опубліковане в Google Business Profile для підключених локацій-ресторанів. Вимкнення прибирає меню з Google.",
        "google": "Google",
        "titleOptional": "Назва (необов'язково)",
        "noItems": "У цьому розділі ще немає страв",
        "editSection": "Редагувати розділ"
    },
    "SubscribeLock": {
        "freemiumRetiredTitle": "Безкоштовний тариф скасовано",
        "freemiumRetiredSubtitle": "Ваші відгуки, контакти та діалоги збережено — оформіть підписку, щоб продовжити з того ж місця.",
        "trialEndedTitle": "Ваш безкоштовний період завершився",
        "trialEndedSubtitle": "Збережіть усе, що налаштували під час пробного періоду — оформіть підписку, щоб продовжити.",
        "askAccountOwner": "Не адміністратор? Попросіть власника акаунта оформити підписку.",
        "directoriesIntentTitle": "Оформіть підписку, щоб додати Локальні каталоги",
        "directoriesIntentSubtitle": "Локальні каталоги потребують активної підписки — оформіть її та додайте {{location}} за один крок."
    },
    "TemplateLibrary": {
        "title": "Бібліотека шаблонів",
        "subtitle": "Готові дизайни для ваших кампаній. Створіть шаблон для email або WhatsApp один раз, збережіть стиль бренду та використовуйте його щоразу, коли запускаєте кампанію.",
        "filterChannelType": "Тип каналу",
        "filterBrands": "Бренди",
        "tabSettings": "Налаштування",
        "tabContent": "Вміст",
        "tabPreview": "Попередній перегляд",
        "backToBlocks": "Назад до блоків",
        "paletteHint": "Натисніть на блок або перетягніть його в лист",
        "dropHint": "Перетягніть блок сюди",
        "emptyState": "Шаблонів ще немає. Створіть перший шаблон, щоб почати.",
        "channelEmail": "Email",
        "systemTemplate": "Приклад",
        "archived": "Архівовано",
        "usedByCampaigns": "{{count}} кампанія або автоматизація",
        "usedByCampaigns_plural": "{{count}} кампаній або автоматизацій",
        "duplicate": "Дублювати",
        "archive": "Архівувати",
        "unarchive": "Розархівувати",
        "duplicated": "Шаблон продубльовано",
        "deleteDescription": "Видалити шаблон \"{{name}}\"? Цю дію не можна скасувати.",
        "deleteBlocked": "Цей шаблон використовується в кампаніях або автоматизаціях і не може бути видалений. Заархівуйте його.",
        "createTemplateTitle": "Новий email-шаблон",
        "editTemplateTitle": "Редагувати email-шаблон",
        "viewTemplateTitle": "Email-шаблон",
        "saveTemplate": "Зберегти шаблон",
        "sendTest": "Тестовий лист",
        "sendTestHint": "Надішліть собі тестовий лист, щоб побачити, що саме отримають ваші контакти.",
        "templateName": "Назва шаблону",
        "preheader": "Прехедер",
        "deviceDesktop": "Компʼютер",
        "deviceMobile": "Телефон",
        "emailChannel": "Email-канал",
        "testSendSuccess": "Тестовий лист надіслано",
        "testSendFail": "Не вдалося надіслати тестовий лист",
        "loadingPreview": "Генерується перегляд…",
        "blocks": "Блоки",
        "textColor": "Колір тексту",
        "buttonColor": "Колір кнопки",
        "buttonShape": "Форма кнопки",
        "shape_square": "Квадратна",
        "shape_rounded": "Заокруглена",
        "shape_pill": "Капсула",
        "blockLogo": "Логотип",
        "blockImage": "Зображення",
        "blockHeading": "Заголовок",
        "blockText": "Текст",
        "blockButton": "Кнопка",
        "blockDivider": "Розділювач",
        "blockSpacer": "Відступ",
        "blockColumns": "Колонки",
        "columnsHint": "Перетягніть блоки з палітри в будь-яку колонку або натисніть на елемент у колонці, щоб відредагувати його.",
        "cornerRadius": "Радіус кутів",
        "blockSocial": "Соцмережі",
        "logoPlaceholder": "Логотип",
        "imagePlaceholder": "Виберіть блок, щоб завантажити зображення",
        "headingPlaceholder": "Заголовок",
        "textPlaceholder": "Напишіть текст…",
        "buttonPlaceholder": "Кнопка",
        "socialPlaceholder": "Соцмережі — з профілю локації",
        "headingText": "Текст заголовка",
        "textContent": "Текст",
        "imageAlt": "Альтернативний текст",
        "buttonLabel": "Назва кнопки",
        "buttonDestination": "Призначення",
        "bindingUrl": "Власне посилання",
        "bindingSurvey": "Посилання на опитування",
        "bindingCoupon": "Посилання на купон",
        "spacerHeight": "Висота (px)",
        "logoHint": "Логотип підставляється з бренду або локації під час надсилання листа.",
        "socialHint": "Посилання Facebook та Instagram беруться з профілю локації.",
        "padding": "Відступи",
        "headingLevel": "Рівень заголовка",
        "fontSize": "Розмір тексту",
        "buttonSize": "Розмір кнопки",
        "buttonWidth": "Ширина кнопки",
        "widthFull": "На всю ширину",
        "widthAuto": "За вмістом",
        "imageWidth": "Ширина зображення",
        "lineColor": "Колір лінії",
        "thickness": "Товщина",
        "footerPreviewInfo": "Назва компанії · Адреса",
        "footerPreviewLinks": "Відписатися · Політика конфіденційності",
        "footerLockedTooltip": "Додається автоматично до кожного листа з реальними даними вашого бізнесу",
        "alignment": "Вирівнювання",
        "alignLeft": "Ліворуч",
        "alignCenter": "По центру",
        "alignRight": "Праворуч",
        "emailDesign": "Дизайн листа",
        "createNew": "Створити новий",
        "surveyLinkHint": "Кампанія, що використовує цей шаблон, підставить сюди посилання на опитування.",
        "couponLinkHint": "Кампанія, що використовує цей шаблон, підставить сюди посилання на купон.",
        "noBrand": "Без бренду",
        "dynamicLinkRequired": "Кампаніям з опитуванням чи купоном потрібен шаблон із кнопкою динамічного посилання.",
        "dynamicLinkNotSupported": "Шаблони з кнопкою динамічного посилання можна використовувати лише в кампаніях з опитуванням або купоном.",
        "channelWhatsApp": "WhatsApp",
        "newEmailTemplate": "Створити email шаблон",
        "newWhatsAppTemplate": "Створити WhatsApp шаблон",
        "waChannelRequired": "Підключіть канал WhatsApp Business, щоб створювати WhatsApp-шаблони.",
        "waStatus_draft": "Чернетка",
        "waStatus_pending": "На перевірці",
        "waStatus_approved": "Схвалено",
        "waStatus_rejected": "Відхилено",
        "waStatus_paused": "Призупинено",
        "waStatus_disabled": "Вимкнено",
        "waNeedsSetup": "Потребує налаштування",
        "waDisconnected": "Відключено",
        "waEditResubmit": "Редагувати й надіслати знову",
        "waCategory": "Категорія",
        "waCategory_MARKETING": "Маркетинг",
        "waCategory_UTILITY": "Сервісна",
        "waWaba": "Акаунт WhatsApp Business",
        "waWabaRequired": "Виберіть акаунт WhatsApp Business для цього шаблону.",
        "waNameHint": "Малі латинські літери, цифри та підкреслення",
        "waEmptyPreview": "Тут з'явиться попередній перегляд вашого повідомлення",
        "waNameInvalid": "Використовуйте лише малі латинські літери, цифри та підкреслення.",
        "waHeader": "Заголовок",
        "waHeaderNone": "Немає",
        "waHeaderText": "Текст",
        "waHeaderImage": "Зображення",
        "waHeaderTextLabel": "Текст заголовка",
        "waHeaderOneVariable": "Текстовий заголовок допускає щонайбільше одну змінну.",
        "waHeaderImageRequired": "Завантажте зображення заголовка або вимкніть заголовок.",
        "waBody": "Текст повідомлення",
        "waBodyEdgeVariable": "Текст повідомлення не може починатися чи закінчуватися змінною.",
        "waBodyMixedVariables": "Не змішуйте іменовані та нумеровані змінні в одному шаблоні.",
        "waFooter": "Нижній колонтитул",
        "waFooterLabel": "Текст нижнього колонтитула (необов'язково)",
        "waButtons": "Кнопки",
        "waAddButton": "Додати кнопку",
        "waButtonQuickReply": "Швидка відповідь",
        "waButtonUrl": "URL",
        "waButtonPhone": "Телефон",
        "waButtonWebsite": "Відвідати сайт",
        "waButtonSurvey": "Посилання на опитування",
        "waButtonCoupon": "Посилання на купон",
        "waUrlAbsolute": "URL-адреси кнопок мають починатися з http:// або https://.",
        "waLinkTypeCouponOnly": "Кнопка з посиланням цього шаблону веде на посилання купонів, тому підходить лише для кампаній з купонами.",
        "waLinkTypeSurveyOnly": "Кнопка з посиланням цього шаблону веде на посилання опитувань, тому не підходить для кампаній з купонами.",
        "waQuickRepliesGrouped": "Кнопки швидких відповідей мають іти поспіль.",
        "waButtonsIncomplete": "Заповніть підпис і призначення кожної кнопки.",
        "waVariables": "Змінні",
        "waResolution": "Чим заповнюється",
        "waGroupContact": "Контакт",
        "waGroupLocation": "Локація",
        "waMappingRequired": "Виберіть, чим заповнюється кожна змінна.",
        "waViewTemplateTitle": "WhatsApp-шаблон",
        "waEditTemplateTitle": "Редагувати WhatsApp-шаблон",
        "waCreateTemplateTitle": "Новий WhatsApp-шаблон",
        "waSaveDraft": "Зберегти чернетку",
        "waSubmitForReview": "Надіслати на перевірку",
        "waSubmitted": "Шаблон надіслано на перевірку",
        "waReviewNote": "Meta перевіряє шаблони після надсилання — зазвичай за кілька годин, до 24 годин.",
        "waPendingBanner": "Meta перевіряє цей шаблон; до завершення перевірки він доступний лише для читання.",
        "waDisabledBanner": "Meta вимкнула цей шаблон. Його не можна редагувати чи використовувати в кампаніях.",
        "waRejectedBanner": "Meta відхилила цей шаблон. Виправте вміст і надішліть знову.",
        "waResubmitBanner": "Після збереження шаблон знову надсилається на перевірку Meta.",
        "noLinkButton": "У цього шаблону немає кнопки з динамічним посиланням, тож він не може доставити посилання на опитування чи купон.",
        "linkButtonNotSupported": "Цей шаблон має кнопку з динамічним посиланням, тому його можна використовувати лише в кампаніях з опитуваннями або купонами.",
        "waLockedByCampaigns": "Цей шаблон використовується в запланованих або активних кампаніях чи активних автоматизаціях. Дублюйте його, щоб редагувати, або спочатку видаліть ці посилання.",
        "waMalformedVariable": "Некоректна змінна — використовуйте {{назву_малими_літерами}} з літер, цифр і підкреслень.",
        "waUnknownVariable": "Невідома змінна — використайте одне з доступних полів.",
        "waFromContact": "з контакту",
        "waFromLocation": "з локації",
        "waLinkSlotInfo": "Кнопка URL заповнюється посиланням на опитування або купон."
    },
    "ImpersonationBanner": {
        "impersonatedBy": "Вхід виконано співробітником Pluspoint: {{name}}",
        "impersonatedByPartner": "Вхід виконано партнером: {{name}}",
        "minutesLeft": "Залишилось {{count}} хв",
        "exit": "Вийти"
    }
}
